import { jsx as D, jsxs as st, Fragment as Os } from "react/jsx-runtime";
import * as c from "react";
import ir, { useRef as Ae, useState as It, useCallback as H, forwardRef as mn, useImperativeHandle as hn, useEffect as dt, memo as jt, useMemo as yt, useLayoutEffect as Qc } from "react";
import { useDeepCompareEffect as $s, useDeepCompareCallback as Ei, useDeepCompareMemo as Ns } from "use-deep-compare";
import Jc from "use-deep-compare-effect";
import Yc from "style-object-to-css-string";
import gn from "styled-components";
import { AgGridReact as xs } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import { useCustomCompareMemo as Zc } from "use-custom-compare";
import { dequal as Xc } from "dequal";
import ef from "lodash/debounce";
import tf from "rc-dropdown";
import rf, { unstable_batchedUpdates as nf, createPortal as of, flushSync as af } from "react-dom";
import "rc-dropdown/assets/index.css";
const Ts = ({
  dataSource: t,
  onFetchChildrenForRecord: e,
  childField: r = "child_id"
}) => {
  const n = Ae([]), [o, a] = It([]), i = Ae([]), s = Ae(/* @__PURE__ */ new Map()), [u, l] = It(
    t.map(
      (m) => ko({
        entry: m,
        childField: r,
        idLevelMap: s.current
      })
    )
  );
  $s(() => {
    const m = t.map((I) => I.id), E = u.map((I) => I.id).filter((I) => !m.includes(I)), R = /* @__PURE__ */ new Set();
    t.forEach((I) => {
      var N;
      ((N = I[r]) == null ? void 0 : N.length) > 0 && I[r].some(
        (M) => E.includes(M)
      ) && R.add(I.id);
    });
    const A = [...E, ...Array.from(R)];
    n.current = n.current.filter(
      (I) => !A.includes(I)
    ), a([...n.current]), i.current = i.current.filter(
      (I) => !A.includes(I)
    ), E.forEach((I) => {
      s.current.delete(I);
    }), l(
      t.map(
        (I) => ko({
          entry: I,
          childField: r,
          idLevelMap: s.current
        })
      )
    );
  }, [t]);
  const d = H((m) => {
    n.current.indexOf(m) === -1 ? n.current.push(m) : n.current = n.current.filter(
      (g) => g !== m
    ), a([...n.current]);
  }, []), y = H((m) => n.current.includes(m), []), f = H((m) => i.current.includes(m), []), v = H((m) => s.current.get(m) || 0, []), h = H(
    (m) => {
      const g = u.find((E) => E.id === m);
      return g ? g[r] !== void 0 && g[r].length > 0 : !1;
    },
    [r, u]
  ), b = H(
    (m) => {
      const g = u.find((E) => E.id === m);
      return g ? g.isLoading : !1;
    },
    [u]
  ), p = H(
    (m) => {
      const g = u.find((R) => R.id === m);
      if (!g)
        return [];
      const E = g[r];
      return E ? u.filter((R) => E.includes(R.id)) : [];
    },
    [r, u]
  ), S = H(
    async (m) => {
      const g = u.find((E) => E.id === m.id);
      if (!g)
        return !1;
      if (!g.isLoading) {
        if (!y(m.id) && !f(g.id)) {
          l(
            Do(
              {
                ...g,
                isLoading: !0
              },
              u
            )
          );
          try {
            const E = await (e == null ? void 0 : e(g)) || [];
            E.forEach((R) => {
              s.current.set(R.id, g.level + 1);
            }), l(
              Do(
                {
                  ...g,
                  isLoading: !1
                },
                [
                  ...u,
                  ...E.map((R) => ko({
                    entry: R,
                    childField: r,
                    idLevelMap: s.current
                  }))
                ]
              )
            ), i.current.push(g.id);
          } catch (E) {
            console.error(E), l(
              Do(
                {
                  ...g,
                  isLoading: !1
                },
                u
              )
            );
          }
        }
        d(m.id);
      }
    },
    [
      u,
      y,
      f,
      d,
      e,
      r
    ]
  ), w = H(
    (m) => b(m.id) ? "loading" : h(m.id) ? y(m.id) ? "collapse" : "expand" : "none",
    [b, h, y]
  ), C = H(() => {
    const g = u.filter((E) => E.level === 0).map((E) => E.id);
    return n.current.forEach((E) => {
      const R = u.find((A) => A.id === E);
      R && R.child_id && R.child_id.forEach((A) => {
        g.includes(A) || g.push(A);
      });
    }), g;
  }, [u]);
  return {
    items: u,
    openedKeys: o,
    keyIsOpened: y,
    onExpandableIconClicked: S,
    getExpandableStatusForRow: w,
    getChildsForParent: p,
    getAllVisibleKeys: C,
    getLevelForKey: v
  };
};
function ko({
  entry: t,
  childField: e,
  idLevelMap: r
}) {
  return {
    id: t.id,
    [e]: t[e],
    isLoading: !1,
    level: r.get(t.id) || 0,
    data: t
  };
}
const Do = (t, e) => e.map((r) => r.id === t.id ? t : r), uf = ({
  selectionRowKeysProps: t = []
}) => {
  const [e, r] = It(
    t
  );
  Jc(() => {
    r(t);
  }, [t]);
  const n = H(
    (s) => {
      if (e.length === s.length || e.length > 0) {
        r([]);
        return;
      }
      r(s);
    },
    [e, r]
  ), o = H(
    (s, u) => {
      u.length !== 0 && r(s ? [.../* @__PURE__ */ new Set([...e, ...u])] : e.filter((l) => !u.includes(l)));
    },
    [e, r]
  ), a = H(
    (s) => {
      if (e.find(
        (l) => s.id === l
      ) === void 0) {
        r([...e, s.id]);
        return;
      }
      r([...e.filter((l) => l !== s.id)]);
    },
    [e, r]
  ), i = H(
    (s) => e.find(
      (l) => s.id === l
    ) !== void 0,
    [e]
  );
  return {
    selectedRowKeys: e,
    isRowSelected: i,
    toggleAllRowsSelected: n,
    toggleRowSelected: a,
    changeSelected: o
  };
}, sf = (t, e) => {
  const [r, n] = It(null), [o, a] = It(!1), [i, s] = It(null);
  return H(
    (l, d) => {
      if (d.nativeEvent.shiftKey) {
        const y = t.findIndex((p) => p === l), f = t.findIndex((p) => p === r), v = t.findIndex(
          (p) => p === i
        ), h = Math.min(y, f), b = Math.max(y, f);
        if (h > -1 && b > -1) {
          e(o, t.slice(h, b + 1)), v > b && e(
            !o,
            t.slice(b + 1, v + 1)
          ), v < h && e(
            !o,
            t.slice(v, h)
          ), s(l);
          return;
        }
      } else
        n(l), s(null), a(d.target.checked);
      e(d.target.checked, [l]);
    },
    [
      e,
      t,
      r,
      n,
      o,
      a,
      i,
      s
    ]
  );
}, lf = (t) => {
  const [e, r] = It(t), n = H(
    (a) => {
      if (e && a === e.id)
        return e;
    },
    [e]
  ), o = H(
    (a) => {
      if (!e) {
        r({
          id: a,
          desc: !1
        });
        return;
      }
      if (e.id !== a) {
        r({
          id: a,
          desc: !1
        });
        return;
      }
      if (e.desc === !1) {
        r({
          id: a,
          desc: !0
        });
        return;
      }
      e.desc === !0 && r(void 0);
    },
    [e]
  );
  return {
    localSorter: e,
    getColumnSorter: n,
    handleColumnClick: o
  };
}, cf = gn.div`
  overflow-x: auto;
  height: ${({ height: t }) => `${t}px` || "auto"};
  border-bottom: 1px solid #f0f0f0;
  ${(t) => Yc(t.containerStyle ?? {})}

  table {
    white-space: nowrap;
    border-spacing: 0;
    width: 100%;

    tr {
      cursor: ${({ canClick: t }) => t ? "pointer" : "auto"};
      user-select: none;

      &:nth-child(odd) {
        background: #fff;
      }

      &:nth-child(even) {
        background: #fafafa;
      }

      &:hover {
        background-color: #f2f2f2;
      }

      td {
        border-bottom: 1px solid #f0f0f0;
      }

      :last-child td {
        border-bottom: 0;
      }
    }

    th {
      position: sticky;
      top: 0;
      background-color: #fafafa;
      border-bottom: 1px solid #f0f0f0;
      z-index: 5;
    }

    th:hover {
      background-color: #f2f2f2;
    }

    th .arrow {
      padding-left: 10px;
      font-size: 0.65em;
      color: #bdbdbd;
    }

    th .ctx {
      display: flex;
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;

      :last-child {
        border-right: 0;
      }
    }

    /* Responsive */
    @media (max-width: 991px) {
      thead {
        display: none;
      }

      td:nth-of-type(1) {
        width: ${(t) => t.readonly ? "auto !important" : "50px"};
        display: ${(t) => t.readonly ? "block" : ""};
      }

      td:nth-of-type(n + 2) {
        display: block;
        width: auto !important;
      }

      .rft-label {
        display: block !important;
      }
    }
  }
`, ks = ({
  value: t,
  onChange: e
}) => {
  const r = ir.useRef();
  return ir.useEffect(() => {
    const n = r.current;
    t === !0 ? (n.checked = !0, n.indeterminate = !1) : t === !1 ? (n.checked = !1, n.indeterminate = !1) : t === null && (n.checked = !1, n.indeterminate = !0);
  }), /* @__PURE__ */ D(
    "input",
    {
      onDoubleClick: (n) => {
        n.stopPropagation();
      },
      ref: r,
      type: "checkbox",
      onChange: e,
      tabIndex: -1
    }
  );
}, ff = ({
  onRowSelectionChange: t,
  allRowsAreSelected: e,
  columns: r,
  toggleAllRowsSelected: n,
  selectedRowKeys: o,
  handleColumnClick: a,
  getColumnSorter: i,
  sortEnabled: s,
  status: u = !1,
  headerStyle: l
}) => /* @__PURE__ */ st(Os, { children: [
  t && /* @__PURE__ */ D(
    "th",
    {
      style: {
        width: 10,
        left: 0,
        position: "sticky",
        backgroundColor: "#f2f2f2",
        ...l,
        cursor: "auto"
      },
      children: /* @__PURE__ */ D(
        "div",
        {
          style: {
            width: 50,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          children: /* @__PURE__ */ D(
            ks,
            {
              value: e ? !0 : o.length === 0 ? !1 : null,
              onChange: n
            }
          )
        }
      )
    },
    "react_formiga_table_selection"
  ),
  u && /* @__PURE__ */ D("th", { style: { ...l } }, "th-status"),
  r.map((d) => /* @__PURE__ */ D(
    "th",
    {
      style: { ...l },
      onClick: s ? () => {
        a(d.key);
      } : void 0,
      children: /* @__PURE__ */ st("div", { className: "ctx", children: [
        /* @__PURE__ */ D(
          "div",
          {
            style: {
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
              ...l == null ? void 0 : l.rftLabel
            },
            children: d.title
          }
        ),
        /* @__PURE__ */ D("div", { style: { display: "flex", alignItems: "center" }, children: /* @__PURE__ */ D(
          "span",
          {
            className: "arrow",
            style: {
              visibility: i(d.key) !== void 0 ? void 0 : "hidden",
              marginLeft: "auto"
            },
            children: i(d.key) !== void 0 && i(d.key).desc ? " ▼" : " ▲"
          },
          d.key
        ) })
      ] })
    },
    d.key
  ))
] }), wi = ({
  column: t,
  row: e,
  columnIdx: r,
  level: n,
  getColumnSorter: o,
  expandableOpts: a,
  getExpandableStatusForRow: i,
  onExpandableIconClicked: s,
  onCellRender: u,
  rowIsSelected: l,
  cellStyle: d
}) => {
  const y = o(t.key) !== void 0 ? {
    backgroundColor: l ? "#E6F7FF" : "#fafafa"
  } : l ? {
    backgroundColor: l ? "#E6F7FF" : void 0
  } : {};
  let f;
  return u ? f = u({
    column: t,
    columnIdx: r,
    rowKey: e.id,
    value: e[t.key]
  }) : t.render ? f = t.render(e[t.key]) : f = e[t.key], /* @__PURE__ */ st("td", { style: y, children: [
    /* @__PURE__ */ D(
      df,
      {
        row: e,
        columnIdx: r,
        expandableOpts: a,
        getExpandableStatusForRow: i,
        onExpandableIconClicked: s,
        level: n
      }
    ),
    /* @__PURE__ */ st("div", { style: { display: "inline-block", width: "100%", ...d }, children: [
      /* @__PURE__ */ D(
        "div",
        {
          className: "rft-label",
          style: { display: "none", ...d == null ? void 0 : d.rftLabel },
          children: t.title
        }
      ),
      f
    ] })
  ] });
};
function df({
  row: t,
  columnIdx: e,
  expandableOpts: r,
  getExpandableStatusForRow: n,
  onExpandableIconClicked: o,
  level: a
}) {
  if (!r)
    return null;
  const i = n(t);
  if (i === "none" || e !== 0)
    return /* @__PURE__ */ D("div", { style: { display: "inline-block", width: 19 + a * 25 } });
  let s;
  return i === "expand" ? s = r.expandIcon : i === "collapse" ? s = r.collapseIcon : i === "loading" && (s = r.loadingIcon), /* @__PURE__ */ D("div", { style: { display: "inline-block" }, children: /* @__PURE__ */ D(
    s,
    {
      style: { marginRight: 5, marginLeft: a * 25 },
      onClick: () => {
        o(t);
      }
    }
  ) });
}
class Ci extends ir.Component {
  constructor(e) {
    super(e), this.state = { hasError: !1, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(e) {
    return { hasError: !0, error: e };
  }
  componentDidCatch(e, r) {
    this.setState({ errorInfo: r }), console.error("Error caught by ErrorBoundary:", e, r);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ st(
      "div",
      {
        style: {
          margin: "10px",
          padding: "10px",
          borderRadius: "4px",
          backgroundColor: "#FFF2F0"
        },
        children: [
          /* @__PURE__ */ D("strong", { style: { color: "red" }, children: "Something went wrong." }),
          /* @__PURE__ */ D("details", { style: { whiteSpace: "pre-wrap" }, children: /* @__PURE__ */ st("pre", { children: [
            this.state.error && this.state.error.toString(),
            /* @__PURE__ */ D("br", {}),
            this.state.errorInfo && this.state.errorInfo.componentStack
          ] }) })
        ]
      }
    ) : this.props.children;
  }
}
const vf = ({
  onRowSelectionChange: t,
  dataSource: e,
  columns: r,
  getColumnSorter: n,
  onRowStyle: o,
  onRowStatus: a,
  onRowDoubleClick: i,
  isRowSelected: s,
  toggleRowSelected: u,
  expandableOpts: l,
  onExpandableIconClicked: d,
  getExpandableStatusForRow: y,
  keyIsOpened: f,
  getChildsForParent: v,
  getLevelForKey: h,
  cellStyle: b
}) => /* @__PURE__ */ D(Os, { children: e.filter((p) => h(p.id) === 0).map((p) => Ds({
  row: p,
  columns: r,
  onRowStyle: o,
  onRowStatus: a,
  onRowDoubleClick: i,
  onRowSelectionChange: t,
  isRowSelected: s,
  toggleRowSelected: u,
  expandableOpts: l,
  getExpandableStatusForRow: y,
  onExpandableIconClicked: d,
  getColumnSorter: n,
  keyIsOpened: f,
  getChildsForParent: v,
  cellStyle: b
})) });
function Ds({
  row: t,
  columns: e,
  onRowDoubleClick: r,
  onRowSelectionChange: n,
  isRowSelected: o,
  toggleRowSelected: a,
  expandableOpts: i,
  getExpandableStatusForRow: s,
  onExpandableIconClicked: u,
  getColumnSorter: l,
  keyIsOpened: d,
  getChildsForParent: y,
  onRowStyle: f,
  onRowStatus: v,
  level: h = 0,
  onCellRender: b,
  cellStyle: p
}) {
  var m;
  const S = f ? f(t) : "", w = o(t);
  let C = [
    /* @__PURE__ */ st(
      "tr",
      {
        style: S,
        onDoubleClick: () => {
          r == null || r(t);
        },
        children: [
          n && /* @__PURE__ */ D(
            "td",
            {
              style: {
                left: 0,
                position: "sticky",
                backgroundColor: w ? "#E6F7FF" : "#f2f2f2",
                cursor: "auto"
              },
              onDoubleClick: (g) => {
                g.stopPropagation(), g.preventDefault();
              },
              children: /* @__PURE__ */ D(
                "div",
                {
                  style: {
                    width: 50,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  },
                  children: /* @__PURE__ */ D(
                    ks,
                    {
                      value: w,
                      onChange: (g) => {
                        a(t.id, g);
                      }
                    }
                  )
                }
              )
            },
            `react_formiga_table_selection-${t.id}`
          ),
          v && /* @__PURE__ */ D(Ci, { children: /* @__PURE__ */ D(
            wi,
            {
              row: t,
              getColumnSorter: () => {
              },
              column: "row-status",
              columnIdx: -1,
              onCellRender: () => v(t),
              expandableOpts: i,
              getExpandableStatusForRow: s,
              onExpandableIconClicked: u,
              level: h,
              rowIsSelected: w,
              cellStyle: p
            }
          ) }, `status-${t.id}`),
          e.map((g, E) => /* @__PURE__ */ D(Ci, { children: /* @__PURE__ */ D(
            wi,
            {
              column: g,
              columnIdx: E,
              row: t,
              getColumnSorter: l,
              expandableOpts: i,
              getExpandableStatusForRow: s,
              onExpandableIconClicked: u,
              level: h,
              rowIsSelected: w,
              cellStyle: p
            }
          ) }, `${g.key}-${t.id}`))
        ]
      },
      `tr-${t.id}`
    )
  ];
  return i !== void 0 && d(t.id) && (C = C.concat(
    (m = y(t.id)) == null ? void 0 : m.map((g) => Ds({
      row: g.data,
      columns: e,
      onRowStyle: f,
      onRowDoubleClick: r,
      onRowSelectionChange: n,
      isRowSelected: o,
      toggleRowSelected: a,
      expandableOpts: i,
      getExpandableStatusForRow: s,
      onExpandableIconClicked: u,
      getColumnSorter: l,
      keyIsOpened: d,
      getChildsForParent: y,
      level: g.level,
      onCellRender: b,
      onRowStatus: v
    }))
  )), C;
}
const pf = mn((t, e) => {
  const {
    height: r,
    loading: n,
    loadingComponent: o,
    dataSource: a,
    columns: i,
    onRowDoubleClick: s,
    onRowStyle: u,
    onRowStatus: l,
    onRowSelectionChange: d,
    onChangeSort: y,
    sorter: f,
    expandableOpts: v,
    onCellRender: h,
    readonly: b,
    selectionRowKeys: p,
    customStyle: S
  } = t, {
    selectedRowKeys: w,
    toggleAllRowsSelected: C,
    isRowSelected: m,
    changeSelected: g
  } = uf({
    selectionRowKeysProps: p
  });
  hn(e, () => ({
    unselectAll: () => {
      C([]);
    }
  }));
  const E = sf(
    a.map((V) => V.id),
    g
  ), { localSorter: R, getColumnSorter: A, handleColumnClick: I } = lf(f), {
    keyIsOpened: N,
    onExpandableIconClicked: K,
    getExpandableStatusForRow: M,
    getChildsForParent: P,
    getAllVisibleKeys: j,
    getLevelForKey: W
  } = Ts({
    dataSource: a,
    onFetchChildrenForRecord: v == null ? void 0 : v.onFetchChildrenForRecord,
    childField: v == null ? void 0 : v.childField
  });
  dt(() => {
    d == null || d(w);
  }, [w]), dt(() => {
    y == null || y(R);
  }, [R]);
  const G = H(() => w.length === 0 ? !1 : v ? j().length === w.length : a.length === w.length, [a.length, v, w.length]), Y = H(() => {
    C(j());
  }, [C, j]);
  return n ? o : /* @__PURE__ */ D(
    cf,
    {
      height: r,
      canClick: s !== void 0,
      readonly: b,
      containerStyle: S == null ? void 0 : S.containerStyle,
      children: /* @__PURE__ */ st("table", { style: S == null ? void 0 : S.tableStyle, children: [
        /* @__PURE__ */ D("thead", { children: /* @__PURE__ */ D("tr", { children: /* @__PURE__ */ D(
          ff,
          {
            allRowsAreSelected: G(),
            columns: i,
            onRowSelectionChange: d,
            selectedRowKeys: w,
            toggleAllRowsSelected: Y,
            handleColumnClick: I,
            getColumnSorter: A,
            sortEnabled: v === void 0,
            status: !!l,
            headerStyle: S == null ? void 0 : S.headerStyle
          }
        ) }) }),
        /* @__PURE__ */ D("tbody", { children: /* @__PURE__ */ D(
          vf,
          {
            dataSource: a,
            columns: i,
            onRowSelectionChange: d,
            getColumnSorter: A,
            onRowDoubleClick: s,
            onRowStyle: u,
            onRowStatus: l,
            isRowSelected: m,
            toggleRowSelected: E,
            expandableOpts: v,
            onExpandableIconClicked: K,
            getExpandableStatusForRow: M,
            keyIsOpened: N,
            getChildsForParent: P,
            getLevelForKey: W,
            onCellRender: h,
            cellStyle: S == null ? void 0 : S.cellStyle
          }
        ) })
      ] })
    }
  );
});
pf.displayName = "Table";
const Ls = (t, e) => Zc(
  () => t,
  [t],
  (r, n) => {
    const o = r[0], a = n[0], i = o.map((u) => u[e]).sort((u, l) => u.localeCompare(l)).join(","), s = a.map((u) => u[e]).sort((u, l) => u.localeCompare(l)).join(",");
    return i === s;
  }
), Fs = jt(
  ({ value: t, onChange: e }) => {
    const r = ir.useRef(null);
    dt(() => {
      const o = r.current;
      o && (t === !0 ? (o.checked = !0, o.indeterminate = !1) : t === !1 ? (o.checked = !1, o.indeterminate = !1) : t === null && (o.checked = !1, o.indeterminate = !0));
    }, [t]);
    const n = H(
      (o) => {
        e(o);
      },
      [e]
    );
    return /* @__PURE__ */ D(
      "input",
      {
        style: {
          width: "13px",
          height: "13px",
          border: "1px solid grey",
          cursor: "pointer",
          margin: 0
        },
        onDoubleClick: (o) => {
          o.stopPropagation();
        },
        ref: r,
        type: "checkbox",
        onChange: n,
        checked: t === !0,
        tabIndex: -1
      }
    );
  }
);
Fs.displayName = "HeaderCheckboxComp";
const js = jt(
  ({
    selectedRowKeysLength: t,
    totalRows: e,
    onSelectionCheckboxClicked: r
  }) => {
    const n = ir.useMemo(() => t === 0 ? !1 : t === e && e > 0 ? !0 : null, [t, e]);
    return /* @__PURE__ */ D(
      Fs,
      {
        value: n,
        onChange: r
      }
    );
  }
);
js.displayName = "HeaderCheckbox";
const za = "$status", Va = "$checkbox", Bs = [Va, za], yf = [...Bs], mf = ({
  actualColumnKeys: t,
  persistedColumnState: e
}) => {
  if (!e)
    return;
  const r = e.map(
    (i) => i.colId
  ), n = [...t].sort(), o = [
    ...r.filter(
      (i) => !yf.includes(i)
    )
  ].sort();
  if (JSON.stringify(n) === JSON.stringify(o))
    return e;
}, hf = 50, gf = 100, bf = 400, Ws = ({
  gridRef: t,
  containerRef: e,
  columns: r,
  onGetColumnsState: n,
  type: o = "infinite"
}) => {
  const a = Ae(), i = Bs, s = H(
    (v) => {
      var p;
      const h = v == null ? void 0 : v.reduce(
        (S, w) => S + w.getActualWidth(),
        0
      ), b = (p = e == null ? void 0 : e.current) == null ? void 0 : p.clientWidth;
      return !b || !h ? 0 : b - h;
    },
    [e]
  ), u = H((v) => {
    setTimeout(() => {
      v();
    }, hf);
  }, []), l = H(() => {
    u(() => {
      var v;
      (v = t == null ? void 0 : t.current) == null || v.api.applyColumnState({
        state: a.current,
        applyOrder: !0
      });
    });
  }, [t, u]), d = H(
    (v) => {
      var h;
      a.current = v, (h = t == null ? void 0 : t.current) == null || h.api.applyColumnState({
        state: a.current,
        applyOrder: !0
      });
    },
    [t]
  ), y = Ei(() => {
    u(() => {
      var S, w, C, m, g, E;
      (S = t == null ? void 0 : t.current) == null || S.api.autoSizeAllColumns();
      const v = (w = t == null ? void 0 : t.current) == null ? void 0 : w.api.getAllGridColumns();
      if (!v)
        return;
      const b = ((C = t == null ? void 0 : t.current) == null ? void 0 : C.api.getColumnState()).map((R) => ({
        ...R,
        width: Math.min(
          Math.max(R.width || 0, gf),
          bf
        )
      }));
      (m = t == null ? void 0 : t.current) == null || m.api.applyColumnState({ state: b });
      const p = s(v);
      if (p > 0) {
        const R = p / (v.length - i.length), I = ((g = t == null ? void 0 : t.current) == null ? void 0 : g.api.getColumnState()).map((N) => ({
          ...N,
          width: i.includes(N.colId) ? N.width : N.width + R
        }));
        (E = t == null ? void 0 : t.current) == null || E.api.applyColumnState({ state: I });
      }
    });
  }, [i, t, s, u]);
  return {
    loadPersistedColumnState: Ei(() => {
      a.current = mf({
        actualColumnKeys: r.map((v) => v.key),
        persistedColumnState: n == null ? void 0 : n()
      }), a.current && a.current.length > 0 ? l() : y();
    }, [l, r, n]),
    columnsPersistedStateRef: a,
    applyAndUpdateNewState: d,
    applyAutoFitState: y
  };
}, Ri = (t) => Object.entries(t).reduce(
  (e, [r, n]) => (n != null && (e[r] = n), e),
  {}
), Ks = (t, e) => {
  if (!t || !e)
    return !1;
  const r = t.map(Ri), n = e.map(Ri);
  return Xc(r, n);
};
function Fe() {
  return Fe = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        ({}).hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Fe.apply(null, arguments);
}
function ft(t) {
  "@babel/helpers - typeof";
  return ft = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ft(t);
}
function Sf(t, e) {
  if (ft(t) != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (ft(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Us(t) {
  var e = Sf(t, "string");
  return ft(e) == "symbol" ? e : e + "";
}
function fe(t, e, r) {
  return (e = Us(e)) in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Pi(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function B(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pi(Object(r), !0).forEach(function(n) {
      fe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Pi(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function oa(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function Ef(t) {
  if (Array.isArray(t))
    return oa(t);
}
function wf(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function zs(t, e) {
  if (t) {
    if (typeof t == "string")
      return oa(t, e);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? oa(t, e) : void 0;
  }
}
function Cf() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ft(t) {
  return Ef(t) || wf(t) || zs(t) || Cf();
}
function Rf(t) {
  if (Array.isArray(t))
    return t;
}
function Pf(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, o, a, i, s = [], u = !0, l = !1;
    try {
      if (a = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r)
          return;
        u = !1;
      } else
        for (; !(u = (n = a.call(r)).done) && (s.push(n.value), s.length !== e); u = !0)
          ;
    } catch (d) {
      l = !0, o = d;
    } finally {
      try {
        if (!u && r.return != null && (i = r.return(), Object(i) !== i))
          return;
      } finally {
        if (l)
          throw o;
      }
    }
    return s;
  }
}
function If() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function z(t, e) {
  return Rf(t) || Pf(t, e) || zs(t, e) || If();
}
function Af(t, e) {
  if (t == null)
    return {};
  var r = {};
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n)) {
      if (e.includes(n))
        continue;
      r[n] = t[n];
    }
  return r;
}
function Ve(t, e) {
  if (t == null)
    return {};
  var r, n, o = Af(t, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (n = 0; n < a.length; n++)
      r = a[n], e.includes(r) || {}.propertyIsEnumerable.call(t, r) && (o[r] = t[r]);
  }
  return o;
}
var Ha = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Mf(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var Hs = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function r() {
      for (var a = "", i = 0; i < arguments.length; i++) {
        var s = arguments[i];
        s && (a = o(a, n(s)));
      }
      return a;
    }
    function n(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return r.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var i = "";
      for (var s in a)
        e.call(a, s) && a[s] && (i = o(i, s));
      return i;
    }
    function o(a, i) {
      return i ? a ? a + " " + i : a + i : a;
    }
    t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
  })();
})(Hs);
var _f = Hs.exports;
const et = /* @__PURE__ */ Vs(_f);
var aa = { exports: {} }, _e = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ii;
function Of() {
  if (Ii)
    return _e;
  Ii = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h;
  h = Symbol.for("react.module.reference");
  function b(p) {
    if (typeof p == "object" && p !== null) {
      var S = p.$$typeof;
      switch (S) {
        case t:
          switch (p = p.type, p) {
            case r:
            case o:
            case n:
            case l:
            case d:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case s:
                case i:
                case u:
                case f:
                case y:
                case a:
                  return p;
                default:
                  return S;
              }
          }
        case e:
          return S;
      }
    }
  }
  return _e.ContextConsumer = i, _e.ContextProvider = a, _e.Element = t, _e.ForwardRef = u, _e.Fragment = r, _e.Lazy = f, _e.Memo = y, _e.Portal = e, _e.Profiler = o, _e.StrictMode = n, _e.Suspense = l, _e.SuspenseList = d, _e.isAsyncMode = function() {
    return !1;
  }, _e.isConcurrentMode = function() {
    return !1;
  }, _e.isContextConsumer = function(p) {
    return b(p) === i;
  }, _e.isContextProvider = function(p) {
    return b(p) === a;
  }, _e.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, _e.isForwardRef = function(p) {
    return b(p) === u;
  }, _e.isFragment = function(p) {
    return b(p) === r;
  }, _e.isLazy = function(p) {
    return b(p) === f;
  }, _e.isMemo = function(p) {
    return b(p) === y;
  }, _e.isPortal = function(p) {
    return b(p) === e;
  }, _e.isProfiler = function(p) {
    return b(p) === o;
  }, _e.isStrictMode = function(p) {
    return b(p) === n;
  }, _e.isSuspense = function(p) {
    return b(p) === l;
  }, _e.isSuspenseList = function(p) {
    return b(p) === d;
  }, _e.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === o || p === n || p === l || p === d || p === v || typeof p == "object" && p !== null && (p.$$typeof === f || p.$$typeof === y || p.$$typeof === a || p.$$typeof === i || p.$$typeof === u || p.$$typeof === h || p.getModuleId !== void 0);
  }, _e.typeOf = b, _e;
}
var Oe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ai;
function $f() {
  return Ai || (Ai = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), h = !1, b = !1, p = !1, S = !1, w = !1, C;
    C = Symbol.for("react.module.reference");
    function m(x) {
      return !!(typeof x == "string" || typeof x == "function" || x === r || x === o || w || x === n || x === l || x === d || S || x === v || h || b || p || typeof x == "object" && x !== null && (x.$$typeof === f || x.$$typeof === y || x.$$typeof === a || x.$$typeof === i || x.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      x.$$typeof === C || x.getModuleId !== void 0));
    }
    function g(x) {
      if (typeof x == "object" && x !== null) {
        var Se = x.$$typeof;
        switch (Se) {
          case t:
            var Ee = x.type;
            switch (Ee) {
              case r:
              case o:
              case n:
              case l:
              case d:
                return Ee;
              default:
                var Ie = Ee && Ee.$$typeof;
                switch (Ie) {
                  case s:
                  case i:
                  case u:
                  case f:
                  case y:
                  case a:
                    return Ie;
                  default:
                    return Se;
                }
            }
          case e:
            return Se;
        }
      }
    }
    var E = i, R = a, A = t, I = u, N = r, K = f, M = y, P = e, j = o, W = n, G = l, Y = d, V = !1, te = !1;
    function Q(x) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function de(x) {
      return te || (te = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ye(x) {
      return g(x) === i;
    }
    function Ce(x) {
      return g(x) === a;
    }
    function Me(x) {
      return typeof x == "object" && x !== null && x.$$typeof === t;
    }
    function $e(x) {
      return g(x) === u;
    }
    function me(x) {
      return g(x) === r;
    }
    function ve(x) {
      return g(x) === f;
    }
    function ae(x) {
      return g(x) === y;
    }
    function he(x) {
      return g(x) === e;
    }
    function Re(x) {
      return g(x) === o;
    }
    function ee(x) {
      return g(x) === n;
    }
    function Pe(x) {
      return g(x) === l;
    }
    function ke(x) {
      return g(x) === d;
    }
    Oe.ContextConsumer = E, Oe.ContextProvider = R, Oe.Element = A, Oe.ForwardRef = I, Oe.Fragment = N, Oe.Lazy = K, Oe.Memo = M, Oe.Portal = P, Oe.Profiler = j, Oe.StrictMode = W, Oe.Suspense = G, Oe.SuspenseList = Y, Oe.isAsyncMode = Q, Oe.isConcurrentMode = de, Oe.isContextConsumer = ye, Oe.isContextProvider = Ce, Oe.isElement = Me, Oe.isForwardRef = $e, Oe.isFragment = me, Oe.isLazy = ve, Oe.isMemo = ae, Oe.isPortal = he, Oe.isProfiler = Re, Oe.isStrictMode = ee, Oe.isSuspense = Pe, Oe.isSuspenseList = ke, Oe.isValidElementType = m, Oe.typeOf = g;
  }()), Oe;
}
process.env.NODE_ENV === "production" ? aa.exports = Of() : aa.exports = $f();
var qs = aa.exports;
function Hn(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return ir.Children.forEach(t, function(n) {
    n == null && !e.keepEmpty || (Array.isArray(n) ? r = r.concat(Hn(n)) : qs.isFragment(n) && n.props ? r = r.concat(Hn(n.props.children, e)) : r.push(n));
  }), r;
}
var ia = {}, qa = [], Nf = function(e) {
  qa.push(e);
};
function qn(t, e) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var r = qa.reduce(function(n, o) {
      return o(n ?? "", "warning");
    }, e);
    r && console.error("Warning: ".concat(r));
  }
}
function xf(t, e) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var r = qa.reduce(function(n, o) {
      return o(n ?? "", "note");
    }, e);
    r && console.warn("Note: ".concat(r));
  }
}
function Tf() {
  ia = {};
}
function Gs(t, e, r) {
  !e && !ia[r] && (t(!1, r), ia[r] = !0);
}
function _t(t, e) {
  Gs(qn, t, e);
}
function kf(t, e) {
  Gs(xf, t, e);
}
_t.preMessage = Nf;
_t.resetWarned = Tf;
_t.noteOnce = kf;
function Gn(t) {
  return t instanceof HTMLElement || t instanceof SVGElement;
}
function Tn(t) {
  return Gn(t) ? t : t instanceof ir.Component ? rf.findDOMNode(t) : null;
}
function Qs(t, e, r) {
  var n = c.useRef({});
  return (!("value" in n.current) || r(n.current.condition, e)) && (n.current.value = t(), n.current.condition = e), n.current.value;
}
function Ga(t, e) {
  typeof t == "function" ? t(e) : ft(t) === "object" && t && "current" in t && (t.current = e);
}
function Js() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n = e.filter(function(o) {
    return o;
  });
  return n.length <= 1 ? n[0] : function(o) {
    e.forEach(function(a) {
      Ga(a, o);
    });
  };
}
function yo() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return Qs(function() {
    return Js.apply(void 0, e);
  }, e, function(n, o) {
    return n.length !== o.length || n.every(function(a, i) {
      return a !== o[i];
    });
  });
}
function mo(t) {
  var e, r, n = qs.isMemo(t) ? t.type.type : t.type;
  return !(typeof n == "function" && !((e = n.prototype) !== null && e !== void 0 && e.render) || typeof t == "function" && !((r = t.prototype) !== null && r !== void 0 && r.render));
}
var ua = /* @__PURE__ */ c.createContext(null);
function Df(t) {
  var e = t.children, r = t.onBatchResize, n = c.useRef(0), o = c.useRef([]), a = c.useContext(ua), i = c.useCallback(function(s, u, l) {
    n.current += 1;
    var d = n.current;
    o.current.push({
      size: s,
      element: u,
      data: l
    }), Promise.resolve().then(function() {
      d === n.current && (r == null || r(o.current), o.current = []);
    }), a == null || a(s, u, l);
  }, [r, a]);
  return /* @__PURE__ */ c.createElement(ua.Provider, {
    value: i
  }, e);
}
var Ys = function() {
  if (typeof Map < "u")
    return Map;
  function t(e, r) {
    var n = -1;
    return e.some(function(o, a) {
      return o[0] === r ? (n = a, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(r) {
        var n = t(this.__entries__, r), o = this.__entries__[n];
        return o && o[1];
      }, e.prototype.set = function(r, n) {
        var o = t(this.__entries__, r);
        ~o ? this.__entries__[o][1] = n : this.__entries__.push([r, n]);
      }, e.prototype.delete = function(r) {
        var n = this.__entries__, o = t(n, r);
        ~o && n.splice(o, 1);
      }, e.prototype.has = function(r) {
        return !!~t(this.__entries__, r);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(r, n) {
        n === void 0 && (n = null);
        for (var o = 0, a = this.__entries__; o < a.length; o++) {
          var i = a[o];
          r.call(n, i[1], i[0]);
        }
      }, e;
    }()
  );
}(), sa = typeof window < "u" && typeof document < "u" && window.document === document, Qn = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Lf = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Qn) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), Ff = 2;
function jf(t, e) {
  var r = !1, n = !1, o = 0;
  function a() {
    r && (r = !1, t()), n && s();
  }
  function i() {
    Lf(a);
  }
  function s() {
    var u = Date.now();
    if (r) {
      if (u - o < Ff)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(i, e);
    o = u;
  }
  return s;
}
var Bf = 20, Wf = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Kf = typeof MutationObserver < "u", Uf = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = jf(this.refresh.bind(this), Bf);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var r = this.observers_, n = r.indexOf(e);
      ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return e.forEach(function(r) {
        return r.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !sa || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Kf ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !sa || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var r = e.propertyName, n = r === void 0 ? "" : r, o = Wf.some(function(a) {
        return !!~n.indexOf(a);
      });
      o && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), Zs = function(t, e) {
  for (var r = 0, n = Object.keys(e); r < n.length; r++) {
    var o = n[r];
    Object.defineProperty(t, o, {
      value: e[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, jr = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || Qn;
}, Xs = ho(0, 0, 0, 0);
function Jn(t) {
  return parseFloat(t) || 0;
}
function Mi(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  return e.reduce(function(n, o) {
    var a = t["border-" + o + "-width"];
    return n + Jn(a);
  }, 0);
}
function zf(t) {
  for (var e = ["top", "right", "bottom", "left"], r = {}, n = 0, o = e; n < o.length; n++) {
    var a = o[n], i = t["padding-" + a];
    r[a] = Jn(i);
  }
  return r;
}
function Vf(t) {
  var e = t.getBBox();
  return ho(0, 0, e.width, e.height);
}
function Hf(t) {
  var e = t.clientWidth, r = t.clientHeight;
  if (!e && !r)
    return Xs;
  var n = jr(t).getComputedStyle(t), o = zf(n), a = o.left + o.right, i = o.top + o.bottom, s = Jn(n.width), u = Jn(n.height);
  if (n.boxSizing === "border-box" && (Math.round(s + a) !== e && (s -= Mi(n, "left", "right") + a), Math.round(u + i) !== r && (u -= Mi(n, "top", "bottom") + i)), !Gf(t)) {
    var l = Math.round(s + a) - e, d = Math.round(u + i) - r;
    Math.abs(l) !== 1 && (s -= l), Math.abs(d) !== 1 && (u -= d);
  }
  return ho(o.left, o.top, s, u);
}
var qf = function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof jr(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof jr(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function Gf(t) {
  return t === jr(t).document.documentElement;
}
function Qf(t) {
  return sa ? qf(t) ? Vf(t) : Hf(t) : Xs;
}
function Jf(t) {
  var e = t.x, r = t.y, n = t.width, o = t.height, a = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, i = Object.create(a.prototype);
  return Zs(i, {
    x: e,
    y: r,
    width: n,
    height: o,
    top: r,
    right: e + n,
    bottom: o + r,
    left: e
  }), i;
}
function ho(t, e, r, n) {
  return { x: t, y: e, width: r, height: n };
}
var Yf = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = ho(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = Qf(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), Zf = (
  /** @class */
  function() {
    function t(e, r) {
      var n = Jf(r);
      Zs(this, { target: e, contentRect: n });
    }
    return t;
  }()
), Xf = (
  /** @class */
  function() {
    function t(e, r, n) {
      if (this.activeObservations_ = [], this.observations_ = new Ys(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = r, this.callbackCtx_ = n;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof jr(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(e) || (r.set(e, new Yf(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof jr(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(e) && (r.delete(e), r.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && e.activeObservations_.push(r);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
          return new Zf(n.target, n.broadcastRect());
        });
        this.callback_.call(e, r, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), el = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Ys(), tl = (
  /** @class */
  function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = Uf.getInstance(), n = new Xf(e, r, this);
      el.set(this, n);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  tl.prototype[t] = function() {
    var e;
    return (e = el.get(this))[t].apply(e, arguments);
  };
});
var ed = function() {
  return typeof Qn.ResizeObserver < "u" ? Qn.ResizeObserver : tl;
}(), Yt = /* @__PURE__ */ new Map();
function rl(t) {
  t.forEach(function(e) {
    var r, n = e.target;
    (r = Yt.get(n)) === null || r === void 0 || r.forEach(function(o) {
      return o(n);
    });
  });
}
var nl = new ed(rl);
process.env.NODE_ENV;
process.env.NODE_ENV;
function td(t, e) {
  Yt.has(t) || (Yt.set(t, /* @__PURE__ */ new Set()), nl.observe(t)), Yt.get(t).add(e);
}
function rd(t, e) {
  Yt.has(t) && (Yt.get(t).delete(e), Yt.get(t).size || (nl.unobserve(t), Yt.delete(t)));
}
function go(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _i(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Us(n.key), n);
  }
}
function bo(t, e, r) {
  return e && _i(t.prototype, e), r && _i(t, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function la(t, e) {
  return la = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, la(t, e);
}
function So(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && la(t, e);
}
function Yn(t) {
  return Yn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Yn(t);
}
function ol() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ol = function() {
    return !!t;
  })();
}
function ca(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function nd(t, e) {
  if (e && (ft(e) == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ca(t);
}
function Eo(t) {
  var e = ol();
  return function() {
    var r, n = Yn(t);
    if (e) {
      var o = Yn(this).constructor;
      r = Reflect.construct(n, arguments, o);
    } else
      r = n.apply(this, arguments);
    return nd(this, r);
  };
}
var od = /* @__PURE__ */ function(t) {
  So(r, t);
  var e = Eo(r);
  function r() {
    return go(this, r), e.apply(this, arguments);
  }
  return bo(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(c.Component);
function ad(t, e) {
  var r = t.children, n = t.disabled, o = c.useRef(null), a = c.useRef(null), i = c.useContext(ua), s = typeof r == "function", u = s ? r(o) : r, l = c.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), d = !s && /* @__PURE__ */ c.isValidElement(u) && mo(u), y = d ? u.ref : null, f = yo(y, o), v = function() {
    var S;
    return Tn(o.current) || // Support `nativeElement` format
    (o.current && ft(o.current) === "object" ? Tn((S = o.current) === null || S === void 0 ? void 0 : S.nativeElement) : null) || Tn(a.current);
  };
  c.useImperativeHandle(e, function() {
    return v();
  });
  var h = c.useRef(t);
  h.current = t;
  var b = c.useCallback(function(p) {
    var S = h.current, w = S.onResize, C = S.data, m = p.getBoundingClientRect(), g = m.width, E = m.height, R = p.offsetWidth, A = p.offsetHeight, I = Math.floor(g), N = Math.floor(E);
    if (l.current.width !== I || l.current.height !== N || l.current.offsetWidth !== R || l.current.offsetHeight !== A) {
      var K = {
        width: I,
        height: N,
        offsetWidth: R,
        offsetHeight: A
      };
      l.current = K;
      var M = R === Math.round(g) ? g : R, P = A === Math.round(E) ? E : A, j = B(B({}, K), {}, {
        offsetWidth: M,
        offsetHeight: P
      });
      i == null || i(j, p, C), w && Promise.resolve().then(function() {
        w(j, p);
      });
    }
  }, []);
  return c.useEffect(function() {
    var p = v();
    return p && !n && td(p, b), function() {
      return rd(p, b);
    };
  }, [o.current, n]), /* @__PURE__ */ c.createElement(od, {
    ref: a
  }, d ? /* @__PURE__ */ c.cloneElement(u, {
    ref: f
  }) : u);
}
var al = /* @__PURE__ */ c.forwardRef(ad);
process.env.NODE_ENV !== "production" && (al.displayName = "SingleObserver");
var id = "rc-observer-key";
function ud(t, e) {
  var r = t.children, n = typeof r == "function" ? [r] : Hn(r);
  return process.env.NODE_ENV !== "production" && (n.length > 1 ? qn(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : n.length === 0 && qn(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), n.map(function(o, a) {
    var i = (o == null ? void 0 : o.key) || "".concat(id, "-").concat(a);
    return /* @__PURE__ */ c.createElement(al, Fe({}, t, {
      key: i,
      ref: a === 0 ? e : void 0
    }), o);
  });
}
var Ur = /* @__PURE__ */ c.forwardRef(ud);
process.env.NODE_ENV !== "production" && (Ur.displayName = "ResizeObserver");
Ur.Collection = Df;
function Lt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Oi = process.env.NODE_ENV !== "test" && Lt() ? c.useLayoutEffect : c.useEffect, ut = function(e, r) {
  var n = c.useRef(!0);
  Oi(function() {
    return e(n.current);
  }, r), Oi(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
}, $i = function(e, r) {
  ut(function(n) {
    if (!n)
      return e();
  }, r);
}, sd = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], Mr = void 0;
function ld(t, e) {
  var r = t.prefixCls, n = t.invalidate, o = t.item, a = t.renderItem, i = t.responsive, s = t.responsiveDisabled, u = t.registerSize, l = t.itemKey, d = t.className, y = t.style, f = t.children, v = t.display, h = t.order, b = t.component, p = b === void 0 ? "div" : b, S = Ve(t, sd), w = i && !v;
  function C(A) {
    u(l, A);
  }
  c.useEffect(function() {
    return function() {
      C(null);
    };
  }, []);
  var m = a && o !== Mr ? a(o) : f, g;
  n || (g = {
    opacity: w ? 0 : 1,
    height: w ? 0 : Mr,
    overflowY: w ? "hidden" : Mr,
    order: i ? h : Mr,
    pointerEvents: w ? "none" : Mr,
    position: w ? "absolute" : Mr
  });
  var E = {};
  w && (E["aria-hidden"] = !0);
  var R = /* @__PURE__ */ c.createElement(p, Fe({
    className: et(!n && r, d),
    style: B(B({}, g), y)
  }, E, S, {
    ref: e
  }), m);
  return i && (R = /* @__PURE__ */ c.createElement(Ur, {
    onResize: function(I) {
      var N = I.offsetWidth;
      C(N);
    },
    disabled: s
  }, R)), R;
}
var sn = /* @__PURE__ */ c.forwardRef(ld);
sn.displayName = "Item";
function kt(t) {
  var e = c.useRef();
  e.current = t;
  var r = c.useCallback(function() {
    for (var n, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return (n = e.current) === null || n === void 0 ? void 0 : n.call.apply(n, [e].concat(a));
  }, []);
  return r;
}
var il = function(e) {
  return +setTimeout(e, 16);
}, ul = function(e) {
  return clearTimeout(e);
};
typeof window < "u" && "requestAnimationFrame" in window && (il = function(e) {
  return window.requestAnimationFrame(e);
}, ul = function(e) {
  return window.cancelAnimationFrame(e);
});
var Ni = 0, wo = /* @__PURE__ */ new Map();
function sl(t) {
  wo.delete(t);
}
var mt = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Ni += 1;
  var n = Ni;
  function o(a) {
    if (a === 0)
      sl(n), e();
    else {
      var i = il(function() {
        o(a - 1);
      });
      wo.set(n, i);
    }
  }
  return o(r), n;
};
mt.cancel = function(t) {
  var e = wo.get(t);
  return sl(t), ul(e);
};
process.env.NODE_ENV !== "production" && (mt.ids = function() {
  return wo;
});
function cd(t) {
  if (typeof MessageChannel > "u")
    mt(t);
  else {
    var e = new MessageChannel();
    e.port1.onmessage = function() {
      return t();
    }, e.port2.postMessage(void 0);
  }
}
function fd() {
  var t = c.useRef(null), e = function(n) {
    t.current || (t.current = [], cd(function() {
      nf(function() {
        t.current.forEach(function(o) {
          o();
        }), t.current = null;
      });
    })), t.current.push(n);
  };
  return e;
}
function Xr(t, e) {
  var r = c.useState(e), n = z(r, 2), o = n[0], a = n[1], i = kt(function(s) {
    t(function() {
      a(s);
    });
  });
  return [o, i];
}
var Zn = /* @__PURE__ */ ir.createContext(null), dd = ["component"], vd = ["className"], pd = ["className"], yd = function(e, r) {
  var n = c.useContext(Zn);
  if (!n) {
    var o = e.component, a = o === void 0 ? "div" : o, i = Ve(e, dd);
    return /* @__PURE__ */ c.createElement(a, Fe({}, i, {
      ref: r
    }));
  }
  var s = n.className, u = Ve(n, vd), l = e.className, d = Ve(e, pd);
  return /* @__PURE__ */ c.createElement(Zn.Provider, {
    value: null
  }, /* @__PURE__ */ c.createElement(sn, Fe({
    ref: r,
    className: et(s, l)
  }, u, d)));
}, ll = /* @__PURE__ */ c.forwardRef(yd);
ll.displayName = "RawItem";
var md = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], cl = "responsive", fl = "invalidate";
function hd(t) {
  return "+ ".concat(t.length, " ...");
}
function gd(t, e) {
  var r = t.prefixCls, n = r === void 0 ? "rc-overflow" : r, o = t.data, a = o === void 0 ? [] : o, i = t.renderItem, s = t.renderRawItem, u = t.itemKey, l = t.itemWidth, d = l === void 0 ? 10 : l, y = t.ssr, f = t.style, v = t.className, h = t.maxCount, b = t.renderRest, p = t.renderRawRest, S = t.suffix, w = t.component, C = w === void 0 ? "div" : w, m = t.itemComponent, g = t.onVisibleChange, E = Ve(t, md), R = y === "full", A = fd(), I = Xr(A, null), N = z(I, 2), K = N[0], M = N[1], P = K || 0, j = Xr(A, /* @__PURE__ */ new Map()), W = z(j, 2), G = W[0], Y = W[1], V = Xr(A, 0), te = z(V, 2), Q = te[0], de = te[1], ye = Xr(A, 0), Ce = z(ye, 2), Me = Ce[0], $e = Ce[1], me = Xr(A, 0), ve = z(me, 2), ae = ve[0], he = ve[1], Re = It(null), ee = z(Re, 2), Pe = ee[0], ke = ee[1], x = It(null), Se = z(x, 2), Ee = Se[0], Ie = Se[1], T = c.useMemo(function() {
    return Ee === null && R ? Number.MAX_SAFE_INTEGER : Ee || 0;
  }, [Ee, K]), _ = It(!1), $ = z(_, 2), F = $[0], ne = $[1], re = "".concat(n, "-item"), ie = Math.max(Q, Me), ue = h === cl, se = a.length && ue, Ke = h === fl, Ue = se || typeof h == "number" && a.length > h, O = yt(function() {
    var J = a;
    return se ? K === null && R ? J = a : J = a.slice(0, Math.min(a.length, P / d)) : typeof h == "number" && (J = a.slice(0, h)), J;
  }, [a, d, K, h, se]), k = yt(function() {
    return se ? a.slice(T + 1) : a.slice(O.length);
  }, [a, O, se, T]), L = H(function(J, Z) {
    var De;
    return typeof u == "function" ? u(J) : (De = u && (J == null ? void 0 : J[u])) !== null && De !== void 0 ? De : Z;
  }, [u]), ce = H(i || function(J) {
    return J;
  }, [i]);
  function oe(J, Z, De) {
    Ee === J && (Z === void 0 || Z === Pe) || (Ie(J), De || (ne(J < a.length - 1), g == null || g(J)), Z !== void 0 && ke(Z));
  }
  function ge(J, Z) {
    M(Z.clientWidth);
  }
  function je(J, Z) {
    Y(function(De) {
      var Ge = new Map(De);
      return Z === null ? Ge.delete(J) : Ge.set(J, Z), Ge;
    });
  }
  function be(J, Z) {
    $e(Z), de(Me);
  }
  function Ne(J, Z) {
    he(Z);
  }
  function Je(J) {
    return G.get(L(O[J], J));
  }
  ut(function() {
    if (P && typeof ie == "number" && O) {
      var J = ae, Z = O.length, De = Z - 1;
      if (!Z) {
        oe(0, null);
        return;
      }
      for (var Ge = 0; Ge < Z; Ge += 1) {
        var ct = Je(Ge);
        if (R && (ct = ct || 0), ct === void 0) {
          oe(Ge - 1, void 0, !0);
          break;
        }
        if (J += ct, // Only one means `totalWidth` is the final width
        De === 0 && J <= P || // Last two width will be the final width
        Ge === De - 1 && J + Je(De) <= P) {
          oe(De, null);
          break;
        } else if (J + ie > P) {
          oe(Ge - 1, J - ct - ae + Me);
          break;
        }
      }
      S && Je(0) + ae > P && ke(null);
    }
  }, [P, G, Me, ae, L, O]);
  var lt = F && !!k.length, ze = {};
  Pe !== null && se && (ze = {
    position: "absolute",
    left: Pe,
    top: 0
  });
  var vt = {
    prefixCls: re,
    responsive: se,
    component: m,
    invalidate: Ke
  }, Ot = s ? function(J, Z) {
    var De = L(J, Z);
    return /* @__PURE__ */ c.createElement(Zn.Provider, {
      key: De,
      value: B(B({}, vt), {}, {
        order: Z,
        item: J,
        itemKey: De,
        registerSize: je,
        display: Z <= T
      })
    }, s(J, Z));
  } : function(J, Z) {
    var De = L(J, Z);
    return /* @__PURE__ */ c.createElement(sn, Fe({}, vt, {
      order: Z,
      key: De,
      item: J,
      renderItem: ce,
      itemKey: De,
      registerSize: je,
      display: Z <= T
    }));
  }, Ye, Te = {
    order: lt ? T : Number.MAX_SAFE_INTEGER,
    className: "".concat(re, "-rest"),
    registerSize: be,
    display: lt
  };
  if (p)
    p && (Ye = /* @__PURE__ */ c.createElement(Zn.Provider, {
      value: B(B({}, vt), Te)
    }, p(k)));
  else {
    var le = b || hd;
    Ye = /* @__PURE__ */ c.createElement(sn, Fe({}, vt, Te), typeof le == "function" ? le(k) : le);
  }
  var tt = /* @__PURE__ */ c.createElement(C, Fe({
    className: et(!Ke && n, v),
    style: f,
    ref: e
  }, E), O.map(Ot), Ue ? Ye : null, S && /* @__PURE__ */ c.createElement(sn, Fe({}, vt, {
    responsive: ue,
    responsiveDisabled: !se,
    order: T,
    className: "".concat(re, "-suffix"),
    registerSize: Ne,
    display: !0,
    style: ze
  }), S));
  return ue && (tt = /* @__PURE__ */ c.createElement(Ur, {
    onResize: ge,
    disabled: !se
  }, tt)), tt;
}
var Zt = /* @__PURE__ */ c.forwardRef(gd);
Zt.displayName = "Overflow";
Zt.Item = ll;
Zt.RESPONSIVE = cl;
Zt.INVALIDATE = fl;
function Lr(t) {
  var e = c.useRef(!1), r = c.useState(t), n = z(r, 2), o = n[0], a = n[1];
  c.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []);
  function i(s, u) {
    u && e.current || a(s);
  }
  return [o, i];
}
function Lo(t) {
  return t !== void 0;
}
function kn(t, e) {
  var r = e || {}, n = r.defaultValue, o = r.value, a = r.onChange, i = r.postState, s = Lr(function() {
    return Lo(o) ? o : Lo(n) ? typeof n == "function" ? n() : n : typeof t == "function" ? t() : t;
  }), u = z(s, 2), l = u[0], d = u[1], y = o !== void 0 ? o : l, f = i ? i(y) : y, v = kt(a), h = Lr([y]), b = z(h, 2), p = b[0], S = b[1];
  $i(function() {
    var C = p[0];
    l !== C && v(l, C);
  }, [p]), $i(function() {
    Lo(o) || d(o);
  }, [o]);
  var w = kt(function(C, m) {
    d(C, m), S([y], m);
  });
  return [f, w];
}
function dl(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = /* @__PURE__ */ new Set();
  function o(a, i) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, u = n.has(a);
    if (_t(!u, "Warning: There may be circular references"), u)
      return !1;
    if (a === i)
      return !0;
    if (r && s > 1)
      return !1;
    n.add(a);
    var l = s + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(i) || a.length !== i.length)
        return !1;
      for (var d = 0; d < a.length; d++)
        if (!o(a[d], i[d], l))
          return !1;
      return !0;
    }
    if (a && i && ft(a) === "object" && ft(i) === "object") {
      var y = Object.keys(a);
      return y.length !== Object.keys(i).length ? !1 : y.every(function(f) {
        return o(a[f], i[f], l);
      });
    }
    return !1;
  }
  return o(t, e);
}
var vl = /* @__PURE__ */ c.createContext(null);
function pl(t, e) {
  return t === void 0 ? null : "".concat(t, "-").concat(e);
}
function yl(t) {
  var e = c.useContext(vl);
  return pl(e, t);
}
var bd = ["children", "locked"], Mt = /* @__PURE__ */ c.createContext(null);
function Sd(t, e) {
  var r = B({}, t);
  return Object.keys(e).forEach(function(n) {
    var o = e[n];
    o !== void 0 && (r[n] = o);
  }), r;
}
function vn(t) {
  var e = t.children, r = t.locked, n = Ve(t, bd), o = c.useContext(Mt), a = Qs(function() {
    return Sd(o, n);
  }, [o, n], function(i, s) {
    return !r && (i[0] !== s[0] || !dl(i[1], s[1], !0));
  });
  return /* @__PURE__ */ c.createElement(Mt.Provider, {
    value: a
  }, e);
}
var Ed = [], ml = /* @__PURE__ */ c.createContext(null);
function Co() {
  return c.useContext(ml);
}
var hl = /* @__PURE__ */ c.createContext(Ed);
function bn(t) {
  var e = c.useContext(hl);
  return c.useMemo(function() {
    return t !== void 0 ? [].concat(Ft(e), [t]) : e;
  }, [e, t]);
}
var gl = /* @__PURE__ */ c.createContext(null), Qa = /* @__PURE__ */ c.createContext({});
const bl = function(t) {
  if (!t)
    return !1;
  if (t instanceof Element) {
    if (t.offsetParent)
      return !0;
    if (t.getBBox) {
      var e = t.getBBox(), r = e.width, n = e.height;
      if (r || n)
        return !0;
    }
    if (t.getBoundingClientRect) {
      var o = t.getBoundingClientRect(), a = o.width, i = o.height;
      if (a || i)
        return !0;
    }
  }
  return !1;
};
function xi(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (bl(t)) {
    var r = t.nodeName.toLowerCase(), n = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(r) || // Editable element
      t.isContentEditable || // Anchor with href element
      r === "a" && !!t.getAttribute("href")
    ), o = t.getAttribute("tabindex"), a = Number(o), i = null;
    return o && !Number.isNaN(a) ? i = a : n && i === null && (i = 0), n && t.disabled && (i = null), i !== null && (i >= 0 || e && i < 0);
  }
  return !1;
}
function wd(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = Ft(t.querySelectorAll("*")).filter(function(n) {
    return xi(n, e);
  });
  return xi(t, e) && r.unshift(t), r;
}
var q = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(e) {
    var r = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    r >= q.F1 && r <= q.F12)
      return !1;
    switch (r) {
      case q.ALT:
      case q.CAPS_LOCK:
      case q.CONTEXT_MENU:
      case q.CTRL:
      case q.DOWN:
      case q.END:
      case q.ESC:
      case q.HOME:
      case q.INSERT:
      case q.LEFT:
      case q.MAC_FF_META:
      case q.META:
      case q.NUMLOCK:
      case q.NUM_CENTER:
      case q.PAGE_DOWN:
      case q.PAGE_UP:
      case q.PAUSE:
      case q.PRINT_SCREEN:
      case q.RIGHT:
      case q.SHIFT:
      case q.UP:
      case q.WIN_KEY:
      case q.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(e) {
    if (e >= q.ZERO && e <= q.NINE || e >= q.NUM_ZERO && e <= q.NUM_MULTIPLY || e >= q.A && e <= q.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && e === 0)
      return !0;
    switch (e) {
      case q.SPACE:
      case q.QUESTION_MARK:
      case q.NUM_PLUS:
      case q.NUM_MINUS:
      case q.NUM_PERIOD:
      case q.NUM_DIVISION:
      case q.SEMICOLON:
      case q.DASH:
      case q.EQUALS:
      case q.COMMA:
      case q.PERIOD:
      case q.SLASH:
      case q.APOSTROPHE:
      case q.SINGLE_QUOTE:
      case q.OPEN_SQUARE_BRACKET:
      case q.BACKSLASH:
      case q.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, fa = q.LEFT, da = q.RIGHT, va = q.UP, Dn = q.DOWN, Ln = q.ENTER, Sl = q.ESC, en = q.HOME, tn = q.END, Ti = [va, Dn, fa, da];
function Cd(t, e, r, n) {
  var o, a, i, s, u = "prev", l = "next", d = "children", y = "parent";
  if (t === "inline" && n === Ln)
    return {
      inlineTrigger: !0
    };
  var f = (o = {}, fe(o, va, u), fe(o, Dn, l), o), v = (a = {}, fe(a, fa, r ? l : u), fe(a, da, r ? u : l), fe(a, Dn, d), fe(a, Ln, d), a), h = (i = {}, fe(i, va, u), fe(i, Dn, l), fe(i, Ln, d), fe(i, Sl, y), fe(i, fa, r ? d : y), fe(i, da, r ? y : d), i), b = {
    inline: f,
    horizontal: v,
    vertical: h,
    inlineSub: f,
    horizontalSub: h,
    verticalSub: h
  }, p = (s = b["".concat(t).concat(e ? "" : "Sub")]) === null || s === void 0 ? void 0 : s[n];
  switch (p) {
    case u:
      return {
        offset: -1,
        sibling: !0
      };
    case l:
      return {
        offset: 1,
        sibling: !0
      };
    case y:
      return {
        offset: -1,
        sibling: !1
      };
    case d:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function Rd(t) {
  for (var e = t; e; ) {
    if (e.getAttribute("data-menu-list"))
      return e;
    e = e.parentElement;
  }
  return null;
}
function Pd(t, e) {
  for (var r = t || document.activeElement; r; ) {
    if (e.has(r))
      return r;
    r = r.parentElement;
  }
  return null;
}
function Ja(t, e) {
  var r = wd(t, !0);
  return r.filter(function(n) {
    return e.has(n);
  });
}
function ki(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!t)
    return null;
  var o = Ja(t, e), a = o.length, i = o.findIndex(function(s) {
    return r === s;
  });
  return n < 0 ? i === -1 ? i = a - 1 : i -= 1 : n > 0 && (i += 1), i = (i + a) % a, o[i];
}
var pa = function(e, r) {
  var n = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  return e.forEach(function(i) {
    var s = document.querySelector("[data-menu-id='".concat(pl(r, i), "']"));
    s && (n.add(s), a.set(s, i), o.set(i, s));
  }), {
    elements: n,
    key2element: o,
    element2key: a
  };
};
function Id(t, e, r, n, o, a, i, s, u, l) {
  var d = c.useRef(), y = c.useRef();
  y.current = e;
  var f = function() {
    mt.cancel(d.current);
  };
  return c.useEffect(function() {
    return function() {
      f();
    };
  }, []), function(v) {
    var h = v.which;
    if ([].concat(Ti, [Ln, Sl, en, tn]).includes(h)) {
      var b = a(), p = pa(b, n), S = p, w = S.elements, C = S.key2element, m = S.element2key, g = C.get(e), E = Pd(g, w), R = m.get(E), A = Cd(t, i(R, !0).length === 1, r, h);
      if (!A && h !== en && h !== tn)
        return;
      (Ti.includes(h) || [en, tn].includes(h)) && v.preventDefault();
      var I = function(Y) {
        if (Y) {
          var V = Y, te = Y.querySelector("a");
          te != null && te.getAttribute("href") && (V = te);
          var Q = m.get(Y);
          s(Q), f(), d.current = mt(function() {
            y.current === Q && V.focus();
          });
        }
      };
      if ([en, tn].includes(h) || A.sibling || !E) {
        var N;
        !E || t === "inline" ? N = o.current : N = Rd(E);
        var K, M = Ja(N, w);
        h === en ? K = M[0] : h === tn ? K = M[M.length - 1] : K = ki(N, w, E, A.offset), I(K);
      } else if (A.inlineTrigger)
        u(R);
      else if (A.offset > 0)
        u(R, !0), f(), d.current = mt(function() {
          p = pa(b, n);
          var G = E.getAttribute("aria-controls"), Y = document.getElementById(G), V = ki(Y, p.elements);
          I(V);
        }, 5);
      else if (A.offset < 0) {
        var P = i(R, !0), j = P[P.length - 2], W = C.get(j);
        u(j, !1), I(W);
      }
    }
    l == null || l(v);
  };
}
function Ad(t) {
  Promise.resolve().then(t);
}
var Ya = "__RC_UTIL_PATH_SPLIT__", Di = function(e) {
  return e.join(Ya);
}, Md = function(e) {
  return e.split(Ya);
}, ya = "rc-menu-more";
function _d() {
  var t = c.useState({}), e = z(t, 2), r = e[1], n = Ae(/* @__PURE__ */ new Map()), o = Ae(/* @__PURE__ */ new Map()), a = c.useState([]), i = z(a, 2), s = i[0], u = i[1], l = Ae(0), d = Ae(!1), y = function() {
    d.current || r({});
  }, f = H(function(C, m) {
    process.env.NODE_ENV !== "production" && _t(!n.current.has(C), "Duplicated key '".concat(C, "' used in Menu by path [").concat(m.join(" > "), "]"));
    var g = Di(m);
    o.current.set(g, C), n.current.set(C, g), l.current += 1;
    var E = l.current;
    Ad(function() {
      E === l.current && y();
    });
  }, []), v = H(function(C, m) {
    var g = Di(m);
    o.current.delete(g), n.current.delete(C);
  }, []), h = H(function(C) {
    u(C);
  }, []), b = H(function(C, m) {
    var g = n.current.get(C) || "", E = Md(g);
    return m && s.includes(E[0]) && E.unshift(ya), E;
  }, [s]), p = H(function(C, m) {
    return C.some(function(g) {
      var E = b(g, !0);
      return E.includes(m);
    });
  }, [b]), S = function() {
    var m = Ft(n.current.keys());
    return s.length && m.push(ya), m;
  }, w = H(function(C) {
    var m = "".concat(n.current.get(C)).concat(Ya), g = /* @__PURE__ */ new Set();
    return Ft(o.current.keys()).forEach(function(E) {
      E.startsWith(m) && g.add(o.current.get(E));
    }), g;
  }, []);
  return c.useEffect(function() {
    return function() {
      d.current = !0;
    };
  }, []), {
    // Register
    registerPath: f,
    unregisterPath: v,
    refreshOverflowKeys: h,
    // Util
    isSubPathKey: p,
    getKeyPath: b,
    getKeys: S,
    getSubPathKeys: w
  };
}
function un(t) {
  var e = c.useRef(t);
  e.current = t;
  var r = c.useCallback(function() {
    for (var n, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return (n = e.current) === null || n === void 0 ? void 0 : n.call.apply(n, [e].concat(a));
  }, []);
  return t ? r : void 0;
}
var Od = Math.random().toFixed(5).toString().slice(2), Li = 0;
function $d(t) {
  var e = kn(t, {
    value: t
  }), r = z(e, 2), n = r[0], o = r[1];
  return c.useEffect(function() {
    Li += 1;
    var a = process.env.NODE_ENV === "test" ? "test" : "".concat(Od, "-").concat(Li);
    o("rc-menu-uuid-".concat(a));
  }, []), n;
}
function El(t, e) {
  var r = B({}, t);
  return Array.isArray(e) && e.forEach(function(n) {
    delete r[n];
  }), r;
}
function wl(t, e, r, n) {
  var o = c.useContext(Mt), a = o.activeKey, i = o.onActive, s = o.onInactive, u = {
    active: a === t
  };
  return e || (u.onMouseEnter = function(l) {
    r == null || r({
      key: t,
      domEvent: l
    }), i(t);
  }, u.onMouseLeave = function(l) {
    n == null || n({
      key: t,
      domEvent: l
    }), s(t);
  }), u;
}
function Cl(t) {
  var e = c.useContext(Mt), r = e.mode, n = e.rtl, o = e.inlineIndent;
  if (r !== "inline")
    return null;
  var a = t;
  return n ? {
    paddingRight: a * o
  } : {
    paddingLeft: a * o
  };
}
function Rl(t) {
  var e = t.icon, r = t.props, n = t.children, o;
  return e === null || e === !1 ? null : (typeof e == "function" ? o = /* @__PURE__ */ c.createElement(e, B({}, r)) : typeof e != "boolean" && (o = e), o || n || null);
}
var Nd = ["item"];
function Xn(t) {
  var e = t.item, r = Ve(t, Nd);
  return Object.defineProperty(r, "item", {
    get: function() {
      return _t(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), e;
    }
  }), r;
}
var xd = ["title", "attribute", "elementRef"], Td = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], kd = ["active"], Dd = /* @__PURE__ */ function(t) {
  So(r, t);
  var e = Eo(r);
  function r() {
    return go(this, r), e.apply(this, arguments);
  }
  return bo(r, [{
    key: "render",
    value: function() {
      var o = this.props, a = o.title, i = o.attribute, s = o.elementRef, u = Ve(o, xd), l = El(u, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return _t(!i, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ c.createElement(Zt.Item, Fe({}, i, {
        title: typeof a == "string" ? a : void 0
      }, l, {
        ref: s
      }));
    }
  }]), r;
}(c.Component), Ld = /* @__PURE__ */ c.forwardRef(function(t, e) {
  var r, n = t.style, o = t.className, a = t.eventKey, i = t.warnKey, s = t.disabled, u = t.itemIcon, l = t.children, d = t.role, y = t.onMouseEnter, f = t.onMouseLeave, v = t.onClick, h = t.onKeyDown, b = t.onFocus, p = Ve(t, Td), S = yl(a), w = c.useContext(Mt), C = w.prefixCls, m = w.onItemClick, g = w.disabled, E = w.overflowDisabled, R = w.itemIcon, A = w.selectedKeys, I = w.onActive, N = c.useContext(Qa), K = N._internalRenderMenuItem, M = "".concat(C, "-item"), P = c.useRef(), j = c.useRef(), W = g || s, G = yo(e, j), Y = bn(a);
  process.env.NODE_ENV !== "production" && i && _t(!1, "MenuItem should not leave undefined `key`.");
  var V = function(ee) {
    return {
      key: a,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: Ft(Y).reverse(),
      item: P.current,
      domEvent: ee
    };
  }, te = u || R, Q = wl(a, W, y, f), de = Q.active, ye = Ve(Q, kd), Ce = A.includes(a), Me = Cl(Y.length), $e = function(ee) {
    if (!W) {
      var Pe = V(ee);
      v == null || v(Xn(Pe)), m(Pe);
    }
  }, me = function(ee) {
    if (h == null || h(ee), ee.which === q.ENTER) {
      var Pe = V(ee);
      v == null || v(Xn(Pe)), m(Pe);
    }
  }, ve = function(ee) {
    I(a), b == null || b(ee);
  }, ae = {};
  t.role === "option" && (ae["aria-selected"] = Ce);
  var he = /* @__PURE__ */ c.createElement(Dd, Fe({
    ref: P,
    elementRef: G,
    role: d === null ? "none" : d || "menuitem",
    tabIndex: s ? null : -1,
    "data-menu-id": E && S ? null : S
  }, p, ye, ae, {
    component: "li",
    "aria-disabled": s,
    style: B(B({}, Me), n),
    className: et(M, (r = {}, fe(r, "".concat(M, "-active"), de), fe(r, "".concat(M, "-selected"), Ce), fe(r, "".concat(M, "-disabled"), W), r), o),
    onClick: $e,
    onKeyDown: me,
    onFocus: ve
  }), l, /* @__PURE__ */ c.createElement(Rl, {
    props: B(B({}, t), {}, {
      isSelected: Ce
    }),
    icon: te
  }));
  return K && (he = K(he, t, {
    selected: Ce
  })), he;
});
function Fd(t, e) {
  var r = t.eventKey, n = Co(), o = bn(r);
  return c.useEffect(function() {
    if (n)
      return n.registerPath(r, o), function() {
        n.unregisterPath(r, o);
      };
  }, [o]), n ? null : /* @__PURE__ */ c.createElement(Ld, Fe({}, t, {
    ref: e
  }));
}
const Ro = /* @__PURE__ */ c.forwardRef(Fd);
var jd = ["className", "children"], Bd = function(e, r) {
  var n = e.className, o = e.children, a = Ve(e, jd), i = c.useContext(Mt), s = i.prefixCls, u = i.mode, l = i.rtl;
  return /* @__PURE__ */ c.createElement("ul", Fe({
    className: et(s, l && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(u === "inline" ? "inline" : "vertical"), n),
    role: "menu"
  }, a, {
    "data-menu-list": !0,
    ref: r
  }), o);
}, Za = /* @__PURE__ */ c.forwardRef(Bd);
Za.displayName = "SubMenuList";
function Xa(t, e) {
  return Hn(t).map(function(r, n) {
    if (/* @__PURE__ */ c.isValidElement(r)) {
      var o, a, i = r.key, s = (o = (a = r.props) === null || a === void 0 ? void 0 : a.eventKey) !== null && o !== void 0 ? o : i, u = s == null;
      u && (s = "tmp_key-".concat([].concat(Ft(e), [n]).join("-")));
      var l = {
        key: s,
        eventKey: s
      };
      return process.env.NODE_ENV !== "production" && u && (l.warnKey = !0), /* @__PURE__ */ c.cloneElement(r, l);
    }
    return r;
  });
}
var Pl = /* @__PURE__ */ c.createContext(null), Fi = [];
function Wd(t, e) {
  var r = c.useState(function() {
    if (!Lt())
      return null;
    var h = document.createElement("div");
    return process.env.NODE_ENV !== "production" && e && h.setAttribute("data-debug", e), h;
  }), n = z(r, 1), o = n[0], a = c.useRef(!1), i = c.useContext(Pl), s = c.useState(Fi), u = z(s, 2), l = u[0], d = u[1], y = i || (a.current ? void 0 : function(h) {
    d(function(b) {
      var p = [h].concat(Ft(b));
      return p;
    });
  });
  function f() {
    o.parentElement || document.body.appendChild(o), a.current = !0;
  }
  function v() {
    var h;
    (h = o.parentElement) === null || h === void 0 || h.removeChild(o), a.current = !1;
  }
  return ut(function() {
    return t ? i ? i(f) : f() : v(), v;
  }, [t]), ut(function() {
    l.length && (l.forEach(function(h) {
      return h();
    }), d(Fi));
  }, [l]), [o, y];
}
function Kd(t, e) {
  if (!t)
    return !1;
  if (t.contains)
    return t.contains(e);
  for (var r = e; r; ) {
    if (r === t)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
var ji = "data-rc-order", Bi = "data-rc-priority", Ud = "rc-util-key", ma = /* @__PURE__ */ new Map();
function Il() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.mark;
  return e ? e.startsWith("data-") ? e : "data-".concat(e) : Ud;
}
function Po(t) {
  if (t.attachTo)
    return t.attachTo;
  var e = document.querySelector("head");
  return e || document.body;
}
function zd(t) {
  return t === "queue" ? "prependQueue" : t ? "prepend" : "append";
}
function Al(t) {
  return Array.from((ma.get(t) || t).children).filter(function(e) {
    return e.tagName === "STYLE";
  });
}
function Ml(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!Lt())
    return null;
  var r = e.csp, n = e.prepend, o = e.priority, a = o === void 0 ? 0 : o, i = zd(n), s = i === "prependQueue", u = document.createElement("style");
  u.setAttribute(ji, i), s && a && u.setAttribute(Bi, "".concat(a)), r != null && r.nonce && (u.nonce = r == null ? void 0 : r.nonce), u.innerHTML = t;
  var l = Po(e), d = l.firstChild;
  if (n) {
    if (s) {
      var y = Al(l).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(ji)))
          return !1;
        var v = Number(f.getAttribute(Bi) || 0);
        return a >= v;
      });
      if (y.length)
        return l.insertBefore(u, y[y.length - 1].nextSibling), u;
    }
    l.insertBefore(u, d);
  } else
    l.appendChild(u);
  return u;
}
function _l(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = Po(e);
  return Al(r).find(function(n) {
    return n.getAttribute(Il(e)) === t;
  });
}
function Wi(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = _l(t, e);
  if (r) {
    var n = Po(e);
    n.removeChild(r);
  }
}
function Vd(t, e) {
  var r = ma.get(t);
  if (!r || !Kd(document, r)) {
    var n = Ml("", e), o = n.parentNode;
    ma.set(t, o), t.removeChild(n);
  }
}
function Hd(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = Po(r);
  Vd(n, r);
  var o = _l(e, r);
  if (o) {
    var a, i;
    if ((a = r.csp) !== null && a !== void 0 && a.nonce && o.nonce !== ((i = r.csp) === null || i === void 0 ? void 0 : i.nonce)) {
      var s;
      o.nonce = (s = r.csp) === null || s === void 0 ? void 0 : s.nonce;
    }
    return o.innerHTML !== t && (o.innerHTML = t), o;
  }
  var u = Ml(t, r);
  return u.setAttribute(Il(r), e), u;
}
var Fo;
function qd(t) {
  if (typeof document > "u")
    return 0;
  if (t || Fo === void 0) {
    var e = document.createElement("div");
    e.style.width = "100%", e.style.height = "200px";
    var r = document.createElement("div"), n = r.style;
    n.position = "absolute", n.top = "0", n.left = "0", n.pointerEvents = "none", n.visibility = "hidden", n.width = "200px", n.height = "150px", n.overflow = "hidden", r.appendChild(e), document.body.appendChild(r);
    var o = e.offsetWidth;
    r.style.overflow = "scroll";
    var a = e.offsetWidth;
    o === a && (a = r.clientWidth), document.body.removeChild(r), Fo = o - a;
  }
  return Fo;
}
function Ki(t) {
  var e = t.match(/^(.*)px$/), r = Number(e == null ? void 0 : e[1]);
  return Number.isNaN(r) ? qd() : r;
}
function Gd(t) {
  if (typeof document > "u" || !t || !(t instanceof Element))
    return {
      width: 0,
      height: 0
    };
  var e = getComputedStyle(t, "::-webkit-scrollbar"), r = e.width, n = e.height;
  return {
    width: Ki(r),
    height: Ki(n)
  };
}
function Qd() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var Jd = "rc-util-locker-".concat(Date.now()), Ui = 0;
function Yd(t) {
  var e = !!t, r = c.useState(function() {
    return Ui += 1, "".concat(Jd, "_").concat(Ui);
  }), n = z(r, 1), o = n[0];
  ut(function() {
    if (e) {
      var a = Gd(document.body).width, i = Qd();
      Hd(`
html body {
  overflow-y: hidden;
  `.concat(i ? "width: calc(100% - ".concat(a, "px);") : "", `
}`), o);
    } else
      Wi(o);
    return function() {
      Wi(o);
    };
  }, [e, o]);
}
var zi = !1;
function Zd(t) {
  return typeof t == "boolean" && (zi = t), zi;
}
var Vi = function(e) {
  return e === !1 ? !1 : !Lt() || !e ? null : typeof e == "string" ? document.querySelector(e) : typeof e == "function" ? e() : e;
}, ei = /* @__PURE__ */ c.forwardRef(function(t, e) {
  var r = t.open, n = t.autoLock, o = t.getContainer, a = t.debug, i = t.autoDestroy, s = i === void 0 ? !0 : i, u = t.children, l = c.useState(r), d = z(l, 2), y = d[0], f = d[1], v = y || r;
  process.env.NODE_ENV !== "production" && _t(Lt() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), c.useEffect(function() {
    (s || r) && f(r);
  }, [r, s]);
  var h = c.useState(function() {
    return Vi(o);
  }), b = z(h, 2), p = b[0], S = b[1];
  c.useEffect(function() {
    var M = Vi(o);
    S(M ?? null);
  });
  var w = Wd(v && !p, a), C = z(w, 2), m = C[0], g = C[1], E = p ?? m;
  Yd(n && r && Lt() && (E === m || E === document.body));
  var R = null;
  if (u && mo(u) && e) {
    var A = u;
    R = A.ref;
  }
  var I = yo(R, e);
  if (!v || !Lt() || p === void 0)
    return null;
  var N = E === !1 || Zd(), K = u;
  return e && (K = /* @__PURE__ */ c.cloneElement(u, {
    ref: I
  })), /* @__PURE__ */ c.createElement(Pl.Provider, {
    value: g
  }, N ? K : /* @__PURE__ */ of(K, E));
});
process.env.NODE_ENV !== "production" && (ei.displayName = "Portal");
function Ol(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
}
function Xd(t) {
  return Ol(t) instanceof ShadowRoot;
}
function ha(t) {
  return Xd(t) ? Ol(t) : null;
}
function ev() {
  var t = B({}, c);
  return t.useId;
}
var Hi = 0, qi = ev();
const tv = qi ? (
  // Use React `useId`
  function(e) {
    var r = qi();
    return e || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
) : (
  // Use compatible of `useId`
  function(e) {
    var r = c.useState("ssr-id"), n = z(r, 2), o = n[0], a = n[1];
    return c.useEffect(function() {
      var i = Hi;
      Hi += 1, a("rc_unique_".concat(i));
    }, []), e || (process.env.NODE_ENV === "test" ? "test-id" : o);
  }
), rv = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var t = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t == null ? void 0 : t.substr(0, 4));
};
var nv = /* @__PURE__ */ c.createContext({}), ov = /* @__PURE__ */ function(t) {
  So(r, t);
  var e = Eo(r);
  function r() {
    return go(this, r), e.apply(this, arguments);
  }
  return bo(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(c.Component), vr = "none", In = "appear", An = "enter", Mn = "leave", Gi = "none", Pt = "prepare", Tr = "start", kr = "active", ti = "end", $l = "prepared";
function Qi(t, e) {
  var r = {};
  return r[t.toLowerCase()] = e.toLowerCase(), r["Webkit".concat(t)] = "webkit".concat(e), r["Moz".concat(t)] = "moz".concat(e), r["ms".concat(t)] = "MS".concat(e), r["O".concat(t)] = "o".concat(e.toLowerCase()), r;
}
function av(t, e) {
  var r = {
    animationend: Qi("Animation", "AnimationEnd"),
    transitionend: Qi("Transition", "TransitionEnd")
  };
  return t && ("AnimationEvent" in e || delete r.animationend.animation, "TransitionEvent" in e || delete r.transitionend.transition), r;
}
var iv = av(Lt(), typeof window < "u" ? window : {}), Nl = {};
if (Lt()) {
  var uv = document.createElement("div");
  Nl = uv.style;
}
var _n = {};
function xl(t) {
  if (_n[t])
    return _n[t];
  var e = iv[t];
  if (e)
    for (var r = Object.keys(e), n = r.length, o = 0; o < n; o += 1) {
      var a = r[o];
      if (Object.prototype.hasOwnProperty.call(e, a) && a in Nl)
        return _n[t] = e[a], _n[t];
    }
  return "";
}
var Tl = xl("animationend"), kl = xl("transitionend"), Dl = !!(Tl && kl), Ji = Tl || "animationend", Yi = kl || "transitionend";
function Zi(t, e) {
  if (!t)
    return null;
  if (ft(t) === "object") {
    var r = e.replace(/-\w/g, function(n) {
      return n[1].toUpperCase();
    });
    return t[r];
  }
  return "".concat(t, "-").concat(e);
}
const sv = function(t) {
  var e = Ae(), r = Ae(t);
  r.current = t;
  var n = c.useCallback(function(i) {
    r.current(i);
  }, []);
  function o(i) {
    i && (i.removeEventListener(Yi, n), i.removeEventListener(Ji, n));
  }
  function a(i) {
    e.current && e.current !== i && o(e.current), i && i !== e.current && (i.addEventListener(Yi, n), i.addEventListener(Ji, n), e.current = i);
  }
  return c.useEffect(function() {
    return function() {
      o(e.current);
    };
  }, []), [a, o];
};
var Ll = Lt() ? Qc : dt;
const lv = function() {
  var t = c.useRef(null);
  function e() {
    mt.cancel(t.current);
  }
  function r(n) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    e();
    var a = mt(function() {
      o <= 1 ? n({
        isCanceled: function() {
          return a !== t.current;
        }
      }) : r(n, o - 1);
    });
    t.current = a;
  }
  return c.useEffect(function() {
    return function() {
      e();
    };
  }, []), [r, e];
};
var cv = [Pt, Tr, kr, ti], fv = [Pt, $l], Fl = !1, dv = !0;
function jl(t) {
  return t === kr || t === ti;
}
const vv = function(t, e, r) {
  var n = Lr(Gi), o = z(n, 2), a = o[0], i = o[1], s = lv(), u = z(s, 2), l = u[0], d = u[1];
  function y() {
    i(Pt, !0);
  }
  var f = e ? fv : cv;
  return Ll(function() {
    if (a !== Gi && a !== ti) {
      var v = f.indexOf(a), h = f[v + 1], b = r(a);
      b === Fl ? i(h, !0) : h && l(function(p) {
        function S() {
          p.isCanceled() || i(h, !0);
        }
        b === !0 ? S() : Promise.resolve(b).then(S);
      });
    }
  }, [t, a]), c.useEffect(function() {
    return function() {
      d();
    };
  }, []), [y, a];
};
function pv(t, e, r, n) {
  var o = n.motionEnter, a = o === void 0 ? !0 : o, i = n.motionAppear, s = i === void 0 ? !0 : i, u = n.motionLeave, l = u === void 0 ? !0 : u, d = n.motionDeadline, y = n.motionLeaveImmediately, f = n.onAppearPrepare, v = n.onEnterPrepare, h = n.onLeavePrepare, b = n.onAppearStart, p = n.onEnterStart, S = n.onLeaveStart, w = n.onAppearActive, C = n.onEnterActive, m = n.onLeaveActive, g = n.onAppearEnd, E = n.onEnterEnd, R = n.onLeaveEnd, A = n.onVisibleChanged, I = Lr(), N = z(I, 2), K = N[0], M = N[1], P = Lr(vr), j = z(P, 2), W = j[0], G = j[1], Y = Lr(null), V = z(Y, 2), te = V[0], Q = V[1], de = Ae(!1), ye = Ae(null);
  function Ce() {
    return r();
  }
  var Me = Ae(!1);
  function $e() {
    G(vr, !0), Q(null, !0);
  }
  function me(_) {
    var $ = Ce();
    if (!(_ && !_.deadline && _.target !== $)) {
      var F = Me.current, ne;
      W === In && F ? ne = g == null ? void 0 : g($, _) : W === An && F ? ne = E == null ? void 0 : E($, _) : W === Mn && F && (ne = R == null ? void 0 : R($, _)), W !== vr && F && ne !== !1 && $e();
    }
  }
  var ve = sv(me), ae = z(ve, 1), he = ae[0], Re = function($) {
    var F, ne, re;
    switch ($) {
      case In:
        return F = {}, fe(F, Pt, f), fe(F, Tr, b), fe(F, kr, w), F;
      case An:
        return ne = {}, fe(ne, Pt, v), fe(ne, Tr, p), fe(ne, kr, C), ne;
      case Mn:
        return re = {}, fe(re, Pt, h), fe(re, Tr, S), fe(re, kr, m), re;
      default:
        return {};
    }
  }, ee = c.useMemo(function() {
    return Re(W);
  }, [W]), Pe = vv(W, !t, function(_) {
    if (_ === Pt) {
      var $ = ee[Pt];
      return $ ? $(Ce()) : Fl;
    }
    if (Se in ee) {
      var F;
      Q(((F = ee[Se]) === null || F === void 0 ? void 0 : F.call(ee, Ce(), null)) || null);
    }
    return Se === kr && (he(Ce()), d > 0 && (clearTimeout(ye.current), ye.current = setTimeout(function() {
      me({
        deadline: !0
      });
    }, d))), Se === $l && $e(), dv;
  }), ke = z(Pe, 2), x = ke[0], Se = ke[1], Ee = jl(Se);
  Me.current = Ee, Ll(function() {
    M(e);
    var _ = de.current;
    de.current = !0;
    var $;
    !_ && e && s && ($ = In), _ && e && a && ($ = An), (_ && !e && l || !_ && y && !e && l) && ($ = Mn);
    var F = Re($);
    $ && (t || F[Pt]) ? (G($), x()) : G(vr);
  }, [e]), dt(function() {
    // Cancel appear
    (W === In && !s || // Cancel enter
    W === An && !a || // Cancel leave
    W === Mn && !l) && G(vr);
  }, [s, a, l]), dt(function() {
    return function() {
      de.current = !1, clearTimeout(ye.current);
    };
  }, []);
  var Ie = c.useRef(!1);
  dt(function() {
    K && (Ie.current = !0), K !== void 0 && W === vr && ((Ie.current || K) && (A == null || A(K)), Ie.current = !0);
  }, [K, W]);
  var T = te;
  return ee[Pt] && Se === Tr && (T = B({
    transition: "none"
  }, T)), [W, Se, T, K ?? e];
}
function yv(t) {
  var e = t;
  ft(t) === "object" && (e = t.transitionSupport);
  function r(o, a) {
    return !!(o.motionName && e && a !== !1);
  }
  var n = /* @__PURE__ */ c.forwardRef(function(o, a) {
    var i = o.visible, s = i === void 0 ? !0 : i, u = o.removeOnLeave, l = u === void 0 ? !0 : u, d = o.forceRender, y = o.children, f = o.motionName, v = o.leavedClassName, h = o.eventProps, b = c.useContext(nv), p = b.motion, S = r(o, p), w = Ae(), C = Ae();
    function m() {
      try {
        return w.current instanceof HTMLElement ? w.current : Tn(C.current);
      } catch {
        return null;
      }
    }
    var g = pv(S, s, m, o), E = z(g, 4), R = E[0], A = E[1], I = E[2], N = E[3], K = c.useRef(N);
    N && (K.current = !0);
    var M = c.useCallback(function(Q) {
      w.current = Q, Ga(a, Q);
    }, [a]), P, j = B(B({}, h), {}, {
      visible: s
    });
    if (!y)
      P = null;
    else if (R === vr)
      N ? P = y(B({}, j), M) : !l && K.current && v ? P = y(B(B({}, j), {}, {
        className: v
      }), M) : d || !l && !v ? P = y(B(B({}, j), {}, {
        style: {
          display: "none"
        }
      }), M) : P = null;
    else {
      var W, G;
      A === Pt ? G = "prepare" : jl(A) ? G = "active" : A === Tr && (G = "start");
      var Y = Zi(f, "".concat(R, "-").concat(G));
      P = y(B(B({}, j), {}, {
        className: et(Zi(f, R), (W = {}, fe(W, Y, Y && G), fe(W, f, typeof f == "string"), W)),
        style: I
      }), M);
    }
    if (/* @__PURE__ */ c.isValidElement(P) && mo(P)) {
      var V = P, te = V.ref;
      te || (P = /* @__PURE__ */ c.cloneElement(P, {
        ref: M
      }));
    }
    return /* @__PURE__ */ c.createElement(ov, {
      ref: C
    }, P);
  });
  return n.displayName = "CSSMotion", n;
}
const Io = yv(Dl);
var ga = "add", ba = "keep", Sa = "remove", jo = "removed";
function mv(t) {
  var e;
  return t && ft(t) === "object" && "key" in t ? e = t : e = {
    key: t
  }, B(B({}, e), {}, {
    key: String(e.key)
  });
}
function Ea() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return t.map(mv);
}
function hv() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = [], n = 0, o = e.length, a = Ea(t), i = Ea(e);
  a.forEach(function(l) {
    for (var d = !1, y = n; y < o; y += 1) {
      var f = i[y];
      if (f.key === l.key) {
        n < y && (r = r.concat(i.slice(n, y).map(function(v) {
          return B(B({}, v), {}, {
            status: ga
          });
        })), n = y), r.push(B(B({}, f), {}, {
          status: ba
        })), n += 1, d = !0;
        break;
      }
    }
    d || r.push(B(B({}, l), {}, {
      status: Sa
    }));
  }), n < o && (r = r.concat(i.slice(n).map(function(l) {
    return B(B({}, l), {}, {
      status: ga
    });
  })));
  var s = {};
  r.forEach(function(l) {
    var d = l.key;
    s[d] = (s[d] || 0) + 1;
  });
  var u = Object.keys(s).filter(function(l) {
    return s[l] > 1;
  });
  return u.forEach(function(l) {
    r = r.filter(function(d) {
      var y = d.key, f = d.status;
      return y !== l || f !== Sa;
    }), r.forEach(function(d) {
      d.key === l && (d.status = ba);
    });
  }), r;
}
var gv = ["component", "children", "onVisibleChanged", "onAllRemoved"], bv = ["status"], Sv = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function Ev(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Io, r = /* @__PURE__ */ function(n) {
    So(a, n);
    var o = Eo(a);
    function a() {
      var i;
      go(this, a);
      for (var s = arguments.length, u = new Array(s), l = 0; l < s; l++)
        u[l] = arguments[l];
      return i = o.call.apply(o, [this].concat(u)), fe(ca(i), "state", {
        keyEntities: []
      }), fe(ca(i), "removeKey", function(d) {
        var y = i.state.keyEntities, f = y.map(function(v) {
          return v.key !== d ? v : B(B({}, v), {}, {
            status: jo
          });
        });
        return i.setState({
          keyEntities: f
        }), f.filter(function(v) {
          var h = v.status;
          return h !== jo;
        }).length;
      }), i;
    }
    return bo(a, [{
      key: "render",
      value: function() {
        var s = this, u = this.state.keyEntities, l = this.props, d = l.component, y = l.children, f = l.onVisibleChanged, v = l.onAllRemoved, h = Ve(l, gv), b = d || c.Fragment, p = {};
        return Sv.forEach(function(S) {
          p[S] = h[S], delete h[S];
        }), delete h.keys, /* @__PURE__ */ c.createElement(b, h, u.map(function(S, w) {
          var C = S.status, m = Ve(S, bv), g = C === ga || C === ba;
          return /* @__PURE__ */ c.createElement(e, Fe({}, p, {
            key: m.key,
            visible: g,
            eventProps: m,
            onVisibleChanged: function(R) {
              if (f == null || f(R, {
                key: m.key
              }), !R) {
                var A = s.removeKey(m.key);
                A === 0 && v && v();
              }
            }
          }), function(E, R) {
            return y(B(B({}, E), {}, {
              index: w
            }), R);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, u) {
        var l = s.keys, d = u.keyEntities, y = Ea(l), f = hv(d, y);
        return {
          keyEntities: f.filter(function(v) {
            var h = d.find(function(b) {
              var p = b.key;
              return v.key === p;
            });
            return !(h && h.status === jo && v.status === Sa);
          })
        };
      }
    }]), a;
  }(c.Component);
  return fe(r, "defaultProps", {
    component: "div"
  }), r;
}
Ev(Dl);
function wv(t) {
  var e = t.prefixCls, r = t.align, n = t.arrow, o = t.arrowPos, a = n || {}, i = a.className, s = a.content, u = o.x, l = u === void 0 ? 0 : u, d = o.y, y = d === void 0 ? 0 : d, f = c.useRef();
  if (!r || !r.points)
    return null;
  var v = {
    position: "absolute"
  };
  if (r.autoArrow !== !1) {
    var h = r.points[0], b = r.points[1], p = h[0], S = h[1], w = b[0], C = b[1];
    p === w || !["t", "b"].includes(p) ? v.top = y : p === "t" ? v.top = 0 : v.bottom = 0, S === C || !["l", "r"].includes(S) ? v.left = l : S === "l" ? v.left = 0 : v.right = 0;
  }
  return /* @__PURE__ */ c.createElement("div", {
    ref: f,
    className: et("".concat(e, "-arrow"), i),
    style: v
  }, s);
}
function Cv(t) {
  var e = t.prefixCls, r = t.open, n = t.zIndex, o = t.mask, a = t.motion;
  return o ? /* @__PURE__ */ c.createElement(Io, Fe({}, a, {
    motionAppear: !0,
    visible: r,
    removeOnLeave: !0
  }), function(i) {
    var s = i.className;
    return /* @__PURE__ */ c.createElement("div", {
      style: {
        zIndex: n
      },
      className: et("".concat(e, "-mask"), s)
    });
  }) : null;
}
var Bl = /* @__PURE__ */ c.memo(function(t) {
  var e = t.children;
  return e;
}, function(t, e) {
  return e.cache;
});
process.env.NODE_ENV !== "production" && (Bl.displayName = "PopupContent");
var Wl = /* @__PURE__ */ c.forwardRef(function(t, e) {
  var r = t.popup, n = t.className, o = t.prefixCls, a = t.style, i = t.target, s = t.onVisibleChanged, u = t.open, l = t.keepDom, d = t.fresh, y = t.onClick, f = t.mask, v = t.arrow, h = t.arrowPos, b = t.align, p = t.motion, S = t.maskMotion, w = t.forceRender, C = t.getPopupContainer, m = t.autoDestroy, g = t.portal, E = t.zIndex, R = t.onMouseEnter, A = t.onMouseLeave, I = t.onPointerEnter, N = t.ready, K = t.offsetX, M = t.offsetY, P = t.offsetR, j = t.offsetB, W = t.onAlign, G = t.onPrepare, Y = t.stretch, V = t.targetWidth, te = t.targetHeight, Q = typeof r == "function" ? r() : r, de = u || l, ye = (C == null ? void 0 : C.length) > 0, Ce = c.useState(!C || !ye), Me = z(Ce, 2), $e = Me[0], me = Me[1];
  if (ut(function() {
    !$e && ye && i && me(!0);
  }, [$e, ye, i]), !$e)
    return null;
  var ve = "auto", ae = {
    left: "-1000vw",
    top: "-1000vh",
    right: ve,
    bottom: ve
  };
  if (N || !u) {
    var he, Re = b.points, ee = b.dynamicInset || ((he = b._experimental) === null || he === void 0 ? void 0 : he.dynamicInset), Pe = ee && Re[0][1] === "r", ke = ee && Re[0][0] === "b";
    Pe ? (ae.right = P, ae.left = ve) : (ae.left = K, ae.right = ve), ke ? (ae.bottom = j, ae.top = ve) : (ae.top = M, ae.bottom = ve);
  }
  var x = {};
  return Y && (Y.includes("height") && te ? x.height = te : Y.includes("minHeight") && te && (x.minHeight = te), Y.includes("width") && V ? x.width = V : Y.includes("minWidth") && V && (x.minWidth = V)), u || (x.pointerEvents = "none"), /* @__PURE__ */ c.createElement(g, {
    open: w || de,
    getContainer: C && function() {
      return C(i);
    },
    autoDestroy: m
  }, /* @__PURE__ */ c.createElement(Cv, {
    prefixCls: o,
    open: u,
    zIndex: E,
    mask: f,
    motion: S
  }), /* @__PURE__ */ c.createElement(Ur, {
    onResize: W,
    disabled: !u
  }, function(Se) {
    return /* @__PURE__ */ c.createElement(Io, Fe({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: w,
      leavedClassName: "".concat(o, "-hidden")
    }, p, {
      onAppearPrepare: G,
      onEnterPrepare: G,
      visible: u,
      onVisibleChanged: function(Ie) {
        var T;
        p == null || (T = p.onVisibleChanged) === null || T === void 0 || T.call(p, Ie), s(Ie);
      }
    }), function(Ee, Ie) {
      var T = Ee.className, _ = Ee.style, $ = et(o, T, n);
      return /* @__PURE__ */ c.createElement("div", {
        ref: Js(Se, e, Ie),
        className: $,
        style: B(B(B(B({
          "--arrow-x": "".concat(h.x || 0, "px"),
          "--arrow-y": "".concat(h.y || 0, "px")
        }, ae), x), _), {}, {
          boxSizing: "border-box",
          zIndex: E
        }, a),
        onMouseEnter: R,
        onMouseLeave: A,
        onPointerEnter: I,
        onClick: y
      }, v && /* @__PURE__ */ c.createElement(wv, {
        prefixCls: o,
        arrow: v,
        arrowPos: h,
        align: b
      }), /* @__PURE__ */ c.createElement(Bl, {
        cache: !u && !d
      }, Q));
    });
  }));
});
process.env.NODE_ENV !== "production" && (Wl.displayName = "Popup");
var Kl = /* @__PURE__ */ c.forwardRef(function(t, e) {
  var r = t.children, n = t.getTriggerDOMNode, o = mo(r), a = c.useCallback(function(s) {
    Ga(e, n ? n(s) : s);
  }, [n]), i = yo(a, r.ref);
  return o ? /* @__PURE__ */ c.cloneElement(r, {
    ref: i
  }) : r;
});
process.env.NODE_ENV !== "production" && (Kl.displayName = "TriggerWrapper");
var Xi = /* @__PURE__ */ c.createContext(null);
function eu(t) {
  return t ? Array.isArray(t) ? t : [t] : [];
}
function Rv(t, e, r, n) {
  return c.useMemo(function() {
    var o = eu(r ?? e), a = eu(n ?? e), i = new Set(o), s = new Set(a);
    return t && (i.has("hover") && (i.delete("hover"), i.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [i, s];
  }, [t, e, r, n]);
}
function Pv() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 ? arguments[2] : void 0;
  return r ? t[0] === e[0] : t[0] === e[0] && t[1] === e[1];
}
function Iv(t, e, r, n) {
  for (var o = r.points, a = Object.keys(t), i = 0; i < a.length; i += 1) {
    var s, u = a[i];
    if (Pv((s = t[u]) === null || s === void 0 ? void 0 : s.points, o, n))
      return "".concat(e, "-placement-").concat(u);
  }
  return "";
}
function tu(t, e, r, n) {
  return e || (r ? {
    motionName: "".concat(t, "-").concat(r)
  } : n ? {
    motionName: n
  } : null);
}
function Sn(t) {
  return t.ownerDocument.defaultView;
}
function wa(t) {
  for (var e = [], r = t == null ? void 0 : t.parentElement, n = ["hidden", "scroll", "clip", "auto"]; r; ) {
    var o = Sn(r).getComputedStyle(r), a = o.overflowX, i = o.overflowY, s = o.overflow;
    [a, i, s].some(function(u) {
      return n.includes(u);
    }) && e.push(r), r = r.parentElement;
  }
  return e;
}
function pn(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(t) ? e : t;
}
function rn(t) {
  return pn(parseFloat(t), 0);
}
function ru(t, e) {
  var r = B({}, t);
  return (e || []).forEach(function(n) {
    if (!(n instanceof HTMLBodyElement || n instanceof HTMLHtmlElement)) {
      var o = Sn(n).getComputedStyle(n), a = o.overflow, i = o.overflowClipMargin, s = o.borderTopWidth, u = o.borderBottomWidth, l = o.borderLeftWidth, d = o.borderRightWidth, y = n.getBoundingClientRect(), f = n.offsetHeight, v = n.clientHeight, h = n.offsetWidth, b = n.clientWidth, p = rn(s), S = rn(u), w = rn(l), C = rn(d), m = pn(Math.round(y.width / h * 1e3) / 1e3), g = pn(Math.round(y.height / f * 1e3) / 1e3), E = (h - b - w - C) * m, R = (f - v - p - S) * g, A = p * g, I = S * g, N = w * m, K = C * m, M = 0, P = 0;
      if (a === "clip") {
        var j = rn(i);
        M = j * m, P = j * g;
      }
      var W = y.x + N - M, G = y.y + A - P, Y = W + y.width + 2 * M - N - K - E, V = G + y.height + 2 * P - A - I - R;
      r.left = Math.max(r.left, W), r.top = Math.max(r.top, G), r.right = Math.min(r.right, Y), r.bottom = Math.min(r.bottom, V);
    }
  }), r;
}
function nu(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = "".concat(e), n = r.match(/^(.*)\%$/);
  return n ? t * (parseFloat(n[1]) / 100) : parseFloat(r);
}
function ou(t, e) {
  var r = e || [], n = z(r, 2), o = n[0], a = n[1];
  return [nu(t.width, o), nu(t.height, a)];
}
function au() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [t[0], t[1]];
}
function _r(t, e) {
  var r = e[0], n = e[1], o, a;
  return r === "t" ? a = t.y : r === "b" ? a = t.y + t.height : a = t.y + t.height / 2, n === "l" ? o = t.x : n === "r" ? o = t.x + t.width : o = t.x + t.width / 2, {
    x: o,
    y: a
  };
}
function nr(t, e) {
  var r = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return t.map(function(n, o) {
    return o === e ? r[n] || "c" : n;
  }).join("");
}
function Av(t, e, r, n, o, a, i) {
  var s = c.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[n] || {}
  }), u = z(s, 2), l = u[0], d = u[1], y = c.useRef(0), f = c.useMemo(function() {
    return e ? wa(e) : [];
  }, [e]), v = c.useRef({}), h = function() {
    v.current = {};
  };
  t || h();
  var b = kt(function() {
    if (e && r && t) {
      let ot = function(Qt, dr) {
        var Ir = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $, Ar = Q.x + Qt, Yr = Q.y + dr, Zr = Ar + he, Cn = Yr + ae, Oo = Math.max(Ar, Ir.left), $o = Math.max(Yr, Ir.top), No = Math.min(Zr, Ir.right), xo = Math.min(Cn, Ir.bottom);
        return Math.max(0, (No - Oo) * (xo - $o));
      }, Pr = function() {
        pt = Q.y + le, nt = pt + ae, bt = Q.x + Te, Kt = bt + he;
      };
      var w, C, m = e, g = m.ownerDocument, E = Sn(m), R = E.getComputedStyle(m), A = R.width, I = R.height, N = R.position, K = m.style.left, M = m.style.top, P = m.style.right, j = m.style.bottom, W = m.style.overflow, G = B(B({}, o[n]), a), Y = g.createElement("div");
      (w = m.parentElement) === null || w === void 0 || w.appendChild(Y), Y.style.left = "".concat(m.offsetLeft, "px"), Y.style.top = "".concat(m.offsetTop, "px"), Y.style.position = N, Y.style.height = "".concat(m.offsetHeight, "px"), Y.style.width = "".concat(m.offsetWidth, "px"), m.style.left = "0", m.style.top = "0", m.style.right = "auto", m.style.bottom = "auto", m.style.overflow = "hidden";
      var V;
      if (Array.isArray(r))
        V = {
          x: r[0],
          y: r[1],
          width: 0,
          height: 0
        };
      else {
        var te = r.getBoundingClientRect();
        V = {
          x: te.x,
          y: te.y,
          width: te.width,
          height: te.height
        };
      }
      var Q = m.getBoundingClientRect(), de = g.documentElement, ye = de.clientWidth, Ce = de.clientHeight, Me = de.scrollWidth, $e = de.scrollHeight, me = de.scrollTop, ve = de.scrollLeft, ae = Q.height, he = Q.width, Re = V.height, ee = V.width, Pe = {
        left: 0,
        top: 0,
        right: ye,
        bottom: Ce
      }, ke = {
        left: -ve,
        top: -me,
        right: Me - ve,
        bottom: $e - me
      }, x = G.htmlRegion, Se = "visible", Ee = "visibleFirst";
      x !== "scroll" && x !== Ee && (x = Se);
      var Ie = x === Ee, T = ru(ke, f), _ = ru(Pe, f), $ = x === Se ? _ : T, F = Ie ? _ : $;
      m.style.left = "auto", m.style.top = "auto", m.style.right = "0", m.style.bottom = "0";
      var ne = m.getBoundingClientRect();
      m.style.left = K, m.style.top = M, m.style.right = P, m.style.bottom = j, m.style.overflow = W, (C = m.parentElement) === null || C === void 0 || C.removeChild(Y);
      var re = pn(Math.round(he / parseFloat(A) * 1e3) / 1e3), ie = pn(Math.round(ae / parseFloat(I) * 1e3) / 1e3);
      if (re === 0 || ie === 0 || Gn(r) && !bl(r))
        return;
      var ue = G.offset, se = G.targetOffset, Ke = ou(Q, ue), Ue = z(Ke, 2), O = Ue[0], k = Ue[1], L = ou(V, se), ce = z(L, 2), oe = ce[0], ge = ce[1];
      V.x -= oe, V.y -= ge;
      var je = G.points || [], be = z(je, 2), Ne = be[0], Je = be[1], lt = au(Je), ze = au(Ne), vt = _r(V, lt), Ot = _r(Q, ze), Ye = B({}, G), Te = vt.x - Ot.x + O, le = vt.y - Ot.y + k, tt = ot(Te, le), J = ot(Te, le, _), Z = _r(V, ["t", "l"]), De = _r(Q, ["t", "l"]), Ge = _r(V, ["b", "r"]), ct = _r(Q, ["b", "r"]), rt = G.overflow || {}, Hr = rt.adjustX, gr = rt.adjustY, Wt = rt.shiftX, $t = rt.shiftY, br = function(dr) {
        return typeof dr == "boolean" ? dr : dr >= 0;
      }, pt, nt, bt, Kt;
      Pr();
      var sr = br(gr), Xt = ze[0] === lt[0];
      if (sr && ze[0] === "t" && (nt > F.bottom || v.current.bt)) {
        var Ut = le;
        Xt ? Ut -= ae - Re : Ut = Z.y - ct.y - k;
        var Nt = ot(Te, Ut), qr = ot(Te, Ut, _);
        // Of course use larger one
        Nt > tt || Nt === tt && (!Ie || // Choose recommend one
        qr >= J) ? (v.current.bt = !0, le = Ut, k = -k, Ye.points = [nr(ze, 0), nr(lt, 0)]) : v.current.bt = !1;
      }
      if (sr && ze[0] === "b" && (pt < F.top || v.current.tb)) {
        var He = le;
        Xt ? He += ae - Re : He = Ge.y - De.y - k;
        var Sr = ot(Te, He), Gr = ot(Te, He, _);
        // Of course use larger one
        Sr > tt || Sr === tt && (!Ie || // Choose recommend one
        Gr >= J) ? (v.current.tb = !0, le = He, k = -k, Ye.points = [nr(ze, 0), nr(lt, 0)]) : v.current.tb = !1;
      }
      var lr = br(Hr), xt = ze[1] === lt[1];
      if (lr && ze[1] === "l" && (Kt > F.right || v.current.rl)) {
        var St = Te;
        xt ? St -= he - ee : St = Z.x - ct.x - O;
        var Er = ot(St, le), Qr = ot(St, le, _);
        // Of course use larger one
        Er > tt || Er === tt && (!Ie || // Choose recommend one
        Qr >= J) ? (v.current.rl = !0, Te = St, O = -O, Ye.points = [nr(ze, 1), nr(lt, 1)]) : v.current.rl = !1;
      }
      if (lr && ze[1] === "r" && (bt < F.left || v.current.lr)) {
        var zt = Te;
        xt ? zt += he - ee : zt = Ge.x - De.x - O;
        var cr = ot(zt, le), Et = ot(zt, le, _);
        // Of course use larger one
        cr > tt || cr === tt && (!Ie || // Choose recommend one
        Et >= J) ? (v.current.lr = !0, Te = zt, O = -O, Ye.points = [nr(ze, 1), nr(lt, 1)]) : v.current.lr = !1;
      }
      Pr();
      var wt = Wt === !0 ? 0 : Wt;
      typeof wt == "number" && (bt < _.left && (Te -= bt - _.left - O, V.x + ee < _.left + wt && (Te += V.x - _.left + ee - wt)), Kt > _.right && (Te -= Kt - _.right - O, V.x > _.right - wt && (Te += V.x - _.right + wt)));
      var Vt = $t === !0 ? 0 : $t;
      typeof Vt == "number" && (pt < _.top && (le -= pt - _.top - k, V.y + Re < _.top + Vt && (le += V.y - _.top + Re - Vt)), nt > _.bottom && (le -= nt - _.bottom - k, V.y > _.bottom - Vt && (le += V.y - _.bottom + Vt)));
      var er = Q.x + Te, Ht = er + he, Ct = Q.y + le, wr = Ct + ae, qt = V.x, Tt = qt + ee, Cr = V.y, Le = Cr + Re, we = Math.max(er, qt), xe = Math.min(Ht, Tt), Ze = (we + xe) / 2, Xe = Ze - er, tr = Math.max(Ct, Cr), rr = Math.min(wr, Le), Jr = (tr + rr) / 2, Rr = Jr - Ct;
      i == null || i(e, Ye);
      var fr = ne.right - Q.x - (Te + Q.width), Gt = ne.bottom - Q.y - (le + Q.height);
      d({
        ready: !0,
        offsetX: Te / re,
        offsetY: le / ie,
        offsetR: fr / re,
        offsetB: Gt / ie,
        arrowX: Xe / re,
        arrowY: Rr / ie,
        scaleX: re,
        scaleY: ie,
        align: Ye
      });
    }
  }), p = function() {
    y.current += 1;
    var C = y.current;
    Promise.resolve().then(function() {
      y.current === C && b();
    });
  }, S = function() {
    d(function(C) {
      return B(B({}, C), {}, {
        ready: !1
      });
    });
  };
  return ut(S, [n]), ut(function() {
    t || S();
  }, [t]), [l.ready, l.offsetX, l.offsetY, l.offsetR, l.offsetB, l.arrowX, l.arrowY, l.scaleX, l.scaleY, l.align, p];
}
function Mv(t, e, r, n, o) {
  ut(function() {
    if (t && e && r) {
      let y = function() {
        n(), o();
      };
      var a = e, i = r, s = wa(a), u = wa(i), l = Sn(i), d = new Set([l].concat(Ft(s), Ft(u)));
      return d.forEach(function(f) {
        f.addEventListener("scroll", y, {
          passive: !0
        });
      }), l.addEventListener("resize", y, {
        passive: !0
      }), n(), function() {
        d.forEach(function(f) {
          f.removeEventListener("scroll", y), l.removeEventListener("resize", y);
        });
      };
    }
  }, [t, e, r]);
}
function _v(t, e, r, n, o, a, i, s) {
  var u = c.useRef(t), l = c.useRef(!1);
  u.current !== t && (l.current = !0, u.current = t), c.useEffect(function() {
    var d = mt(function() {
      l.current = !1;
    });
    return function() {
      mt.cancel(d);
    };
  }, [t]), c.useEffect(function() {
    if (e && n && (!o || a)) {
      var d = function() {
        var N = !1, K = function(j) {
          var W = j.target;
          N = i(W);
        }, M = function(j) {
          var W = j.target;
          !l.current && u.current && !N && !i(W) && s(!1);
        };
        return [K, M];
      }, y = d(), f = z(y, 2), v = f[0], h = f[1], b = d(), p = z(b, 2), S = p[0], w = p[1], C = Sn(n);
      C.addEventListener("mousedown", v, !0), C.addEventListener("click", h, !0), C.addEventListener("contextmenu", h, !0);
      var m = ha(r);
      if (m && (m.addEventListener("mousedown", S, !0), m.addEventListener("click", w, !0), m.addEventListener("contextmenu", w, !0)), process.env.NODE_ENV !== "production") {
        var g, E, R = r == null || (g = r.getRootNode) === null || g === void 0 ? void 0 : g.call(r), A = (E = n.getRootNode) === null || E === void 0 ? void 0 : E.call(n);
        qn(R === A, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        C.removeEventListener("mousedown", v, !0), C.removeEventListener("click", h, !0), C.removeEventListener("contextmenu", h, !0), m && (m.removeEventListener("mousedown", S, !0), m.removeEventListener("click", w, !0), m.removeEventListener("contextmenu", w, !0));
      };
    }
  }, [e, r, n, o, a]);
}
var Ov = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function $v() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ei, e = /* @__PURE__ */ c.forwardRef(function(r, n) {
    var o = r.prefixCls, a = o === void 0 ? "rc-trigger-popup" : o, i = r.children, s = r.action, u = s === void 0 ? "hover" : s, l = r.showAction, d = r.hideAction, y = r.popupVisible, f = r.defaultPopupVisible, v = r.onPopupVisibleChange, h = r.afterPopupVisibleChange, b = r.mouseEnterDelay, p = r.mouseLeaveDelay, S = p === void 0 ? 0.1 : p, w = r.focusDelay, C = r.blurDelay, m = r.mask, g = r.maskClosable, E = g === void 0 ? !0 : g, R = r.getPopupContainer, A = r.forceRender, I = r.autoDestroy, N = r.destroyPopupOnHide, K = r.popup, M = r.popupClassName, P = r.popupStyle, j = r.popupPlacement, W = r.builtinPlacements, G = W === void 0 ? {} : W, Y = r.popupAlign, V = r.zIndex, te = r.stretch, Q = r.getPopupClassNameFromAlign, de = r.fresh, ye = r.alignPoint, Ce = r.onPopupClick, Me = r.onPopupAlign, $e = r.arrow, me = r.popupMotion, ve = r.maskMotion, ae = r.popupTransitionName, he = r.popupAnimation, Re = r.maskTransitionName, ee = r.maskAnimation, Pe = r.className, ke = r.getTriggerDOMNode, x = Ve(r, Ov), Se = I || N || !1, Ee = c.useState(!1), Ie = z(Ee, 2), T = Ie[0], _ = Ie[1];
    ut(function() {
      _(rv());
    }, []);
    var $ = c.useRef({}), F = c.useContext(Xi), ne = c.useMemo(function() {
      return {
        registerSubPopup: function(X, Be) {
          $.current[X] = Be, F == null || F.registerSubPopup(X, Be);
        }
      };
    }, [F]), re = tv(), ie = c.useState(null), ue = z(ie, 2), se = ue[0], Ke = ue[1], Ue = kt(function(U) {
      Gn(U) && se !== U && Ke(U), F == null || F.registerSubPopup(re, U);
    }), O = c.useState(null), k = z(O, 2), L = k[0], ce = k[1], oe = c.useRef(null), ge = kt(function(U) {
      Gn(U) && L !== U && (ce(U), oe.current = U);
    }), je = c.Children.only(i), be = (je == null ? void 0 : je.props) || {}, Ne = {}, Je = kt(function(U) {
      var X, Be, qe = L;
      return (qe == null ? void 0 : qe.contains(U)) || ((X = ha(qe)) === null || X === void 0 ? void 0 : X.host) === U || U === qe || (se == null ? void 0 : se.contains(U)) || ((Be = ha(se)) === null || Be === void 0 ? void 0 : Be.host) === U || U === se || Object.values($.current).some(function(We) {
        return (We == null ? void 0 : We.contains(U)) || U === We;
      });
    }), lt = tu(a, me, he, ae), ze = tu(a, ve, ee, Re), vt = c.useState(f || !1), Ot = z(vt, 2), Ye = Ot[0], Te = Ot[1], le = y ?? Ye, tt = kt(function(U) {
      y === void 0 && Te(U);
    });
    ut(function() {
      Te(y || !1);
    }, [y]);
    var J = c.useRef(le);
    J.current = le;
    var Z = c.useRef([]);
    Z.current = [];
    var De = kt(function(U) {
      var X;
      tt(U), ((X = Z.current[Z.current.length - 1]) !== null && X !== void 0 ? X : le) !== U && (Z.current.push(U), v == null || v(U));
    }), Ge = c.useRef(), ct = function() {
      clearTimeout(Ge.current);
    }, rt = function(X) {
      var Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      ct(), Be === 0 ? De(X) : Ge.current = setTimeout(function() {
        De(X);
      }, Be * 1e3);
    };
    c.useEffect(function() {
      return ct;
    }, []);
    var Hr = c.useState(!1), gr = z(Hr, 2), Wt = gr[0], $t = gr[1];
    ut(function(U) {
      (!U || le) && $t(!0);
    }, [le]);
    var br = c.useState(null), pt = z(br, 2), nt = pt[0], bt = pt[1], Kt = c.useState([0, 0]), sr = z(Kt, 2), Xt = sr[0], Ut = sr[1], Nt = function(X) {
      Ut([X.clientX, X.clientY]);
    }, qr = Av(le, se, ye ? Xt : L, j, G, Y, Me), He = z(qr, 11), Sr = He[0], Gr = He[1], lr = He[2], xt = He[3], St = He[4], Er = He[5], Qr = He[6], zt = He[7], cr = He[8], Et = He[9], wt = He[10], Vt = Rv(T, u, l, d), er = z(Vt, 2), Ht = er[0], Ct = er[1], wr = Ht.has("click"), qt = Ct.has("click") || Ct.has("contextMenu"), Tt = kt(function() {
      Wt || wt();
    }), Cr = function() {
      J.current && ye && qt && rt(!1);
    };
    Mv(le, L, se, Tt, Cr), ut(function() {
      Tt();
    }, [Xt, j]), ut(function() {
      le && !(G != null && G[j]) && Tt();
    }, [JSON.stringify(Y)]);
    var Le = c.useMemo(function() {
      var U = Iv(G, a, Et, ye);
      return et(U, Q == null ? void 0 : Q(Et));
    }, [Et, Q, G, a, ye]);
    c.useImperativeHandle(n, function() {
      return {
        nativeElement: oe.current,
        forceAlign: Tt
      };
    });
    var we = c.useState(0), xe = z(we, 2), Ze = xe[0], Xe = xe[1], tr = c.useState(0), rr = z(tr, 2), Jr = rr[0], Rr = rr[1], fr = function() {
      if (te && L) {
        var X = L.getBoundingClientRect();
        Xe(X.width), Rr(X.height);
      }
    }, Gt = function() {
      fr(), Tt();
    }, ot = function(X) {
      $t(!1), wt(), h == null || h(X);
    }, Pr = function() {
      return new Promise(function(X) {
        fr(), bt(function() {
          return X;
        });
      });
    };
    ut(function() {
      nt && (wt(), nt(), bt(null));
    }, [nt]);
    function Qt(U, X, Be, qe) {
      Ne[U] = function(We) {
        var Rn;
        qe == null || qe(We), rt(X, Be);
        for (var To = arguments.length, Si = new Array(To > 1 ? To - 1 : 0), Pn = 1; Pn < To; Pn++)
          Si[Pn - 1] = arguments[Pn];
        (Rn = be[U]) === null || Rn === void 0 || Rn.call.apply(Rn, [be, We].concat(Si));
      };
    }
    (wr || qt) && (Ne.onClick = function(U) {
      var X;
      J.current && qt ? rt(!1) : !J.current && wr && (Nt(U), rt(!0));
      for (var Be = arguments.length, qe = new Array(Be > 1 ? Be - 1 : 0), We = 1; We < Be; We++)
        qe[We - 1] = arguments[We];
      (X = be.onClick) === null || X === void 0 || X.call.apply(X, [be, U].concat(qe));
    }), _v(le, qt, L, se, m, E, Je, rt);
    var dr = Ht.has("hover"), Ir = Ct.has("hover"), Ar, Yr;
    dr && (Qt("onMouseEnter", !0, b, function(U) {
      Nt(U);
    }), Qt("onPointerEnter", !0, b, function(U) {
      Nt(U);
    }), Ar = function() {
      (le || Wt) && rt(!0, b);
    }, ye && (Ne.onMouseMove = function(U) {
      var X;
      (X = be.onMouseMove) === null || X === void 0 || X.call(be, U);
    })), Ir && (Qt("onMouseLeave", !1, S), Qt("onPointerLeave", !1, S), Yr = function() {
      rt(!1, S);
    }), Ht.has("focus") && Qt("onFocus", !0, w), Ct.has("focus") && Qt("onBlur", !1, C), Ht.has("contextMenu") && (Ne.onContextMenu = function(U) {
      var X;
      J.current && Ct.has("contextMenu") ? rt(!1) : (Nt(U), rt(!0)), U.preventDefault();
      for (var Be = arguments.length, qe = new Array(Be > 1 ? Be - 1 : 0), We = 1; We < Be; We++)
        qe[We - 1] = arguments[We];
      (X = be.onContextMenu) === null || X === void 0 || X.call.apply(X, [be, U].concat(qe));
    }), Pe && (Ne.className = et(be.className, Pe));
    var Zr = B(B({}, be), Ne), Cn = {}, Oo = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    Oo.forEach(function(U) {
      x[U] && (Cn[U] = function() {
        for (var X, Be = arguments.length, qe = new Array(Be), We = 0; We < Be; We++)
          qe[We] = arguments[We];
        (X = Zr[U]) === null || X === void 0 || X.call.apply(X, [Zr].concat(qe)), x[U].apply(x, qe);
      });
    });
    var $o = /* @__PURE__ */ c.cloneElement(je, B(B({}, Zr), Cn)), No = {
      x: Er,
      y: Qr
    }, xo = $e ? B({}, $e !== !0 ? $e : {}) : null;
    return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(Ur, {
      disabled: !le,
      ref: ge,
      onResize: Gt
    }, /* @__PURE__ */ c.createElement(Kl, {
      getTriggerDOMNode: ke
    }, $o)), /* @__PURE__ */ c.createElement(Xi.Provider, {
      value: ne
    }, /* @__PURE__ */ c.createElement(Wl, {
      portal: t,
      ref: Ue,
      prefixCls: a,
      popup: K,
      className: et(M, Le),
      style: P,
      target: L,
      onMouseEnter: Ar,
      onMouseLeave: Yr,
      onPointerEnter: Ar,
      zIndex: V,
      open: le,
      keepDom: Wt,
      fresh: de,
      onClick: Ce,
      mask: m,
      motion: lt,
      maskMotion: ze,
      onVisibleChanged: ot,
      onPrepare: Pr,
      forceRender: A,
      autoDestroy: Se,
      getPopupContainer: R,
      align: Et,
      arrow: xo,
      arrowPos: No,
      ready: Sr,
      offsetX: Gr,
      offsetY: lr,
      offsetR: xt,
      offsetB: St,
      onAlign: Tt,
      stretch: te,
      targetWidth: Ze / zt,
      targetHeight: Jr / cr
    })));
  });
  return process.env.NODE_ENV !== "production" && (e.displayName = "Trigger"), e;
}
const Nv = $v(ei);
var at = {
  adjustX: 1,
  adjustY: 1
}, xv = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: at
  },
  topRight: {
    points: ["br", "tr"],
    overflow: at
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: at
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: at
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: at
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: at
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: at
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: at
  }
}, Tv = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: at
  },
  topRight: {
    points: ["br", "tr"],
    overflow: at
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: at
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: at
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: at
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: at
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: at
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: at
  }
};
function Ul(t, e, r) {
  if (e)
    return e;
  if (r)
    return r[t] || r.other;
}
var kv = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function Dv(t) {
  var e = t.prefixCls, r = t.visible, n = t.children, o = t.popup, a = t.popupStyle, i = t.popupClassName, s = t.popupOffset, u = t.disabled, l = t.mode, d = t.onVisibleChange, y = c.useContext(Mt), f = y.getPopupContainer, v = y.rtl, h = y.subMenuOpenDelay, b = y.subMenuCloseDelay, p = y.builtinPlacements, S = y.triggerSubMenuAction, w = y.forceSubMenuRender, C = y.rootClassName, m = y.motion, g = y.defaultMotions, E = c.useState(!1), R = z(E, 2), A = R[0], I = R[1], N = B(v ? B({}, Tv) : B({}, xv), p), K = kv[l], M = Ul(l, m, g), P = c.useRef(M);
  l !== "inline" && (P.current = M);
  var j = B(B({}, P.current), {}, {
    leavedClassName: "".concat(e, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), W = c.useRef();
  return c.useEffect(function() {
    return W.current = mt(function() {
      I(r);
    }), function() {
      mt.cancel(W.current);
    };
  }, [r]), /* @__PURE__ */ c.createElement(Nv, {
    prefixCls: e,
    popupClassName: et("".concat(e, "-popup"), fe({}, "".concat(e, "-rtl"), v), i, C),
    stretch: l === "horizontal" ? "minWidth" : null,
    getPopupContainer: f,
    builtinPlacements: N,
    popupPlacement: K,
    popupVisible: A,
    popup: o,
    popupStyle: a,
    popupAlign: s && {
      offset: s
    },
    action: u ? [] : [S],
    mouseEnterDelay: h,
    mouseLeaveDelay: b,
    onPopupVisibleChange: d,
    forceRender: w,
    popupMotion: j,
    fresh: !0
  }, n);
}
function Lv(t) {
  var e = t.id, r = t.open, n = t.keyPath, o = t.children, a = "inline", i = c.useContext(Mt), s = i.prefixCls, u = i.forceSubMenuRender, l = i.motion, d = i.defaultMotions, y = i.mode, f = c.useRef(!1);
  f.current = y === a;
  var v = c.useState(!f.current), h = z(v, 2), b = h[0], p = h[1], S = f.current ? r : !1;
  c.useEffect(function() {
    f.current && p(!1);
  }, [y]);
  var w = B({}, Ul(a, l, d));
  n.length > 1 && (w.motionAppear = !1);
  var C = w.onVisibleChanged;
  return w.onVisibleChanged = function(m) {
    return !f.current && !m && p(!0), C == null ? void 0 : C(m);
  }, b ? null : /* @__PURE__ */ c.createElement(vn, {
    mode: a,
    locked: !f.current
  }, /* @__PURE__ */ c.createElement(Io, Fe({
    visible: S
  }, w, {
    forceRender: u,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(m) {
    var g = m.className, E = m.style;
    return /* @__PURE__ */ c.createElement(Za, {
      id: e,
      className: g,
      style: E
    }, o);
  }));
}
var Fv = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], jv = ["active"], Bv = function(e) {
  var r, n = e.style, o = e.className, a = e.title, i = e.eventKey, s = e.warnKey, u = e.disabled, l = e.internalPopupClose, d = e.children, y = e.itemIcon, f = e.expandIcon, v = e.popupClassName, h = e.popupOffset, b = e.popupStyle, p = e.onClick, S = e.onMouseEnter, w = e.onMouseLeave, C = e.onTitleClick, m = e.onTitleMouseEnter, g = e.onTitleMouseLeave, E = Ve(e, Fv), R = yl(i), A = c.useContext(Mt), I = A.prefixCls, N = A.mode, K = A.openKeys, M = A.disabled, P = A.overflowDisabled, j = A.activeKey, W = A.selectedKeys, G = A.itemIcon, Y = A.expandIcon, V = A.onItemClick, te = A.onOpenChange, Q = A.onActive, de = c.useContext(Qa), ye = de._internalRenderSubMenuItem, Ce = c.useContext(gl), Me = Ce.isSubPathKey, $e = bn(), me = "".concat(I, "-submenu"), ve = M || u, ae = c.useRef(), he = c.useRef();
  process.env.NODE_ENV !== "production" && s && _t(!1, "SubMenu should not leave undefined `key`.");
  var Re = y ?? G, ee = f ?? Y, Pe = K.includes(i), ke = !P && Pe, x = Me(W, i), Se = wl(i, ve, m, g), Ee = Se.active, Ie = Ve(Se, jv), T = c.useState(!1), _ = z(T, 2), $ = _[0], F = _[1], ne = function(Ne) {
    ve || F(Ne);
  }, re = function(Ne) {
    ne(!0), S == null || S({
      key: i,
      domEvent: Ne
    });
  }, ie = function(Ne) {
    ne(!1), w == null || w({
      key: i,
      domEvent: Ne
    });
  }, ue = c.useMemo(function() {
    return Ee || (N !== "inline" ? $ || Me([j], i) : !1);
  }, [N, Ee, j, $, i, Me]), se = Cl($e.length), Ke = function(Ne) {
    ve || (C == null || C({
      key: i,
      domEvent: Ne
    }), N === "inline" && te(i, !Pe));
  }, Ue = un(function(be) {
    p == null || p(Xn(be)), V(be);
  }), O = function(Ne) {
    N !== "inline" && te(i, Ne);
  }, k = function() {
    Q(i);
  }, L = R && "".concat(R, "-popup"), ce = /* @__PURE__ */ c.createElement("div", Fe({
    role: "menuitem",
    style: se,
    className: "".concat(me, "-title"),
    tabIndex: ve ? null : -1,
    ref: ae,
    title: typeof a == "string" ? a : null,
    "data-menu-id": P && R ? null : R,
    "aria-expanded": ke,
    "aria-haspopup": !0,
    "aria-controls": L,
    "aria-disabled": ve,
    onClick: Ke,
    onFocus: k
  }, Ie), a, /* @__PURE__ */ c.createElement(Rl, {
    icon: N !== "horizontal" ? ee : void 0,
    props: B(B({}, e), {}, {
      isOpen: ke,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ c.createElement("i", {
    className: "".concat(me, "-arrow")
  }))), oe = c.useRef(N);
  if (N !== "inline" && $e.length > 1 ? oe.current = "vertical" : oe.current = N, !P) {
    var ge = oe.current;
    ce = /* @__PURE__ */ c.createElement(Dv, {
      mode: ge,
      prefixCls: me,
      visible: !l && ke && N !== "inline",
      popupClassName: v,
      popupOffset: h,
      popupStyle: b,
      popup: /* @__PURE__ */ c.createElement(
        vn,
        {
          mode: ge === "horizontal" ? "vertical" : ge
        },
        /* @__PURE__ */ c.createElement(Za, {
          id: L,
          ref: he
        }, d)
      ),
      disabled: ve,
      onVisibleChange: O
    }, ce);
  }
  var je = /* @__PURE__ */ c.createElement(Zt.Item, Fe({
    role: "none"
  }, E, {
    component: "li",
    style: n,
    className: et(me, "".concat(me, "-").concat(N), o, (r = {}, fe(r, "".concat(me, "-open"), ke), fe(r, "".concat(me, "-active"), ue), fe(r, "".concat(me, "-selected"), x), fe(r, "".concat(me, "-disabled"), ve), r)),
    onMouseEnter: re,
    onMouseLeave: ie
  }), ce, !P && /* @__PURE__ */ c.createElement(Lv, {
    id: L,
    open: ke,
    keyPath: $e
  }, d));
  return ye && (je = ye(je, e, {
    selected: x,
    active: ue,
    open: ke,
    disabled: ve
  })), /* @__PURE__ */ c.createElement(vn, {
    onItemClick: Ue,
    mode: N === "horizontal" ? "vertical" : N,
    itemIcon: Re,
    expandIcon: ee
  }, je);
};
function ri(t) {
  var e = t.eventKey, r = t.children, n = bn(e), o = Xa(r, n), a = Co();
  c.useEffect(function() {
    if (a)
      return a.registerPath(e, n), function() {
        a.unregisterPath(e, n);
      };
  }, [n]);
  var i;
  return a ? i = o : i = /* @__PURE__ */ c.createElement(Bv, t, o), /* @__PURE__ */ c.createElement(hl.Provider, {
    value: n
  }, i);
}
var Wv = ["className", "title", "eventKey", "children"], Kv = ["children"], Uv = function(e) {
  var r = e.className, n = e.title;
  e.eventKey;
  var o = e.children, a = Ve(e, Wv), i = c.useContext(Mt), s = i.prefixCls, u = "".concat(s, "-item-group");
  return /* @__PURE__ */ c.createElement("li", Fe({
    role: "presentation"
  }, a, {
    onClick: function(d) {
      return d.stopPropagation();
    },
    className: et(u, r)
  }), /* @__PURE__ */ c.createElement("div", {
    role: "presentation",
    className: "".concat(u, "-title"),
    title: typeof n == "string" ? n : void 0
  }, n), /* @__PURE__ */ c.createElement("ul", {
    role: "group",
    className: "".concat(u, "-list")
  }, o));
};
function zl(t) {
  var e = t.children, r = Ve(t, Kv), n = bn(r.eventKey), o = Xa(e, n), a = Co();
  return a ? o : /* @__PURE__ */ c.createElement(Uv, El(r, ["warnKey"]), o);
}
function Vl(t) {
  var e = t.className, r = t.style, n = c.useContext(Mt), o = n.prefixCls, a = Co();
  return a ? null : /* @__PURE__ */ c.createElement("li", {
    role: "separator",
    className: et("".concat(o, "-item-divider"), e),
    style: r
  });
}
var zv = ["label", "children", "key", "type"];
function Ca(t) {
  return (t || []).map(function(e, r) {
    if (e && ft(e) === "object") {
      var n = e, o = n.label, a = n.children, i = n.key, s = n.type, u = Ve(n, zv), l = i ?? "tmp-".concat(r);
      return a || s === "group" ? s === "group" ? /* @__PURE__ */ c.createElement(zl, Fe({
        key: l
      }, u, {
        title: o
      }), Ca(a)) : /* @__PURE__ */ c.createElement(ri, Fe({
        key: l
      }, u, {
        title: o
      }), Ca(a)) : s === "divider" ? /* @__PURE__ */ c.createElement(Vl, Fe({
        key: l
      }, u)) : /* @__PURE__ */ c.createElement(Ro, Fe({
        key: l
      }, u), o);
    }
    return null;
  }).filter(function(e) {
    return e;
  });
}
function Vv(t, e, r) {
  var n = t;
  return e && (n = Ca(e)), Xa(n, r);
}
var Hv = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem"], Or = [], qv = /* @__PURE__ */ c.forwardRef(function(t, e) {
  var r, n, o = t, a = o.prefixCls, i = a === void 0 ? "rc-menu" : a, s = o.rootClassName, u = o.style, l = o.className, d = o.tabIndex, y = d === void 0 ? 0 : d, f = o.items, v = o.children, h = o.direction, b = o.id, p = o.mode, S = p === void 0 ? "vertical" : p, w = o.inlineCollapsed, C = o.disabled, m = o.disabledOverflow, g = o.subMenuOpenDelay, E = g === void 0 ? 0.1 : g, R = o.subMenuCloseDelay, A = R === void 0 ? 0.1 : R, I = o.forceSubMenuRender, N = o.defaultOpenKeys, K = o.openKeys, M = o.activeKey, P = o.defaultActiveFirst, j = o.selectable, W = j === void 0 ? !0 : j, G = o.multiple, Y = G === void 0 ? !1 : G, V = o.defaultSelectedKeys, te = o.selectedKeys, Q = o.onSelect, de = o.onDeselect, ye = o.inlineIndent, Ce = ye === void 0 ? 24 : ye, Me = o.motion, $e = o.defaultMotions, me = o.triggerSubMenuAction, ve = me === void 0 ? "hover" : me, ae = o.builtinPlacements, he = o.itemIcon, Re = o.expandIcon, ee = o.overflowedIndicator, Pe = ee === void 0 ? "..." : ee, ke = o.overflowedIndicatorPopupClassName, x = o.getPopupContainer, Se = o.onClick, Ee = o.onOpenChange, Ie = o.onKeyDown, T = o.openAnimation, _ = o.openTransitionName, $ = o._internalRenderMenuItem, F = o._internalRenderSubMenuItem, ne = Ve(o, Hv), re = c.useMemo(function() {
    return Vv(v, f, Or);
  }, [v, f]), ie = c.useState(!1), ue = z(ie, 2), se = ue[0], Ke = ue[1], Ue = c.useRef(), O = $d(b), k = h === "rtl";
  process.env.NODE_ENV !== "production" && _t(!T && !_, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var L = kn(N, {
    value: K,
    postState: function(we) {
      return we || Or;
    }
  }), ce = z(L, 2), oe = ce[0], ge = ce[1], je = function(we) {
    var xe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function Ze() {
      ge(we), Ee == null || Ee(we);
    }
    xe ? af(Ze) : Ze();
  }, be = c.useState(oe), Ne = z(be, 2), Je = Ne[0], lt = Ne[1], ze = c.useRef(!1), vt = c.useMemo(function() {
    return (S === "inline" || S === "vertical") && w ? ["vertical", w] : [S, !1];
  }, [S, w]), Ot = z(vt, 2), Ye = Ot[0], Te = Ot[1], le = Ye === "inline", tt = c.useState(Ye), J = z(tt, 2), Z = J[0], De = J[1], Ge = c.useState(Te), ct = z(Ge, 2), rt = ct[0], Hr = ct[1];
  c.useEffect(function() {
    De(Ye), Hr(Te), ze.current && (le ? ge(Je) : je(Or));
  }, [Ye, Te]);
  var gr = c.useState(0), Wt = z(gr, 2), $t = Wt[0], br = Wt[1], pt = $t >= re.length - 1 || Z !== "horizontal" || m;
  c.useEffect(function() {
    le && lt(oe);
  }, [oe]), c.useEffect(function() {
    return ze.current = !0, function() {
      ze.current = !1;
    };
  }, []);
  var nt = _d(), bt = nt.registerPath, Kt = nt.unregisterPath, sr = nt.refreshOverflowKeys, Xt = nt.isSubPathKey, Ut = nt.getKeyPath, Nt = nt.getKeys, qr = nt.getSubPathKeys, He = c.useMemo(function() {
    return {
      registerPath: bt,
      unregisterPath: Kt
    };
  }, [bt, Kt]), Sr = c.useMemo(function() {
    return {
      isSubPathKey: Xt
    };
  }, [Xt]);
  c.useEffect(function() {
    sr(pt ? Or : re.slice($t + 1).map(function(Le) {
      return Le.key;
    }));
  }, [$t, pt]);
  var Gr = kn(M || P && ((r = re[0]) === null || r === void 0 ? void 0 : r.key), {
    value: M
  }), lr = z(Gr, 2), xt = lr[0], St = lr[1], Er = un(function(Le) {
    St(Le);
  }), Qr = un(function() {
    St(void 0);
  });
  hn(e, function() {
    return {
      list: Ue.current,
      focus: function(we) {
        var xe, Ze = Nt(), Xe = pa(Ze, O), tr = Xe.elements, rr = Xe.key2element, Jr = Xe.element2key, Rr = Ja(Ue.current, tr), fr = xt ?? (Rr[0] ? Jr.get(Rr[0]) : (xe = re.find(function(Pr) {
          return !Pr.props.disabled;
        })) === null || xe === void 0 ? void 0 : xe.key), Gt = rr.get(fr);
        if (fr && Gt) {
          var ot;
          Gt == null || (ot = Gt.focus) === null || ot === void 0 || ot.call(Gt, we);
        }
      }
    };
  });
  var zt = kn(V || [], {
    value: te,
    // Legacy convert key to array
    postState: function(we) {
      return Array.isArray(we) ? we : we == null ? Or : [we];
    }
  }), cr = z(zt, 2), Et = cr[0], wt = cr[1], Vt = function(we) {
    if (W) {
      var xe = we.key, Ze = Et.includes(xe), Xe;
      Y ? Ze ? Xe = Et.filter(function(rr) {
        return rr !== xe;
      }) : Xe = [].concat(Ft(Et), [xe]) : Xe = [xe], wt(Xe);
      var tr = B(B({}, we), {}, {
        selectedKeys: Xe
      });
      Ze ? de == null || de(tr) : Q == null || Q(tr);
    }
    !Y && oe.length && Z !== "inline" && je(Or);
  }, er = un(function(Le) {
    Se == null || Se(Xn(Le)), Vt(Le);
  }), Ht = un(function(Le, we) {
    var xe = oe.filter(function(Xe) {
      return Xe !== Le;
    });
    if (we)
      xe.push(Le);
    else if (Z !== "inline") {
      var Ze = qr(Le);
      xe = xe.filter(function(Xe) {
        return !Ze.has(Xe);
      });
    }
    dl(oe, xe, !0) || je(xe, !0);
  }), Ct = function(we, xe) {
    var Ze = xe ?? !oe.includes(we);
    Ht(we, Ze);
  }, wr = Id(Z, xt, k, O, Ue, Nt, Ut, St, Ct, Ie);
  c.useEffect(function() {
    Ke(!0);
  }, []);
  var qt = c.useMemo(function() {
    return {
      _internalRenderMenuItem: $,
      _internalRenderSubMenuItem: F
    };
  }, [$, F]), Tt = Z !== "horizontal" || m ? re : (
    // Need wrap for overflow dropdown that do not response for open
    re.map(function(Le, we) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ c.createElement(vn, {
          key: Le.key,
          overflowDisabled: we > $t
        }, Le)
      );
    })
  ), Cr = /* @__PURE__ */ c.createElement(Zt, Fe({
    id: b,
    ref: Ue,
    prefixCls: "".concat(i, "-overflow"),
    component: "ul",
    itemComponent: Ro,
    className: et(i, "".concat(i, "-root"), "".concat(i, "-").concat(Z), l, (n = {}, fe(n, "".concat(i, "-inline-collapsed"), rt), fe(n, "".concat(i, "-rtl"), k), n), s),
    dir: h,
    style: u,
    role: "menu",
    tabIndex: y,
    data: Tt,
    renderRawItem: function(we) {
      return we;
    },
    renderRawRest: function(we) {
      var xe = we.length, Ze = xe ? re.slice(-xe) : null;
      return /* @__PURE__ */ c.createElement(ri, {
        eventKey: ya,
        title: Pe,
        disabled: pt,
        internalPopupClose: xe === 0,
        popupClassName: ke
      }, Ze);
    },
    maxCount: Z !== "horizontal" || m ? Zt.INVALIDATE : Zt.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(we) {
      br(we);
    },
    onKeyDown: wr
  }, ne));
  return /* @__PURE__ */ c.createElement(Qa.Provider, {
    value: qt
  }, /* @__PURE__ */ c.createElement(vl.Provider, {
    value: O
  }, /* @__PURE__ */ c.createElement(vn, {
    prefixCls: i,
    rootClassName: s,
    mode: Z,
    openKeys: oe,
    rtl: k,
    disabled: C,
    motion: se ? Me : null,
    defaultMotions: se ? $e : null,
    activeKey: xt,
    onActive: Er,
    onInactive: Qr,
    selectedKeys: Et,
    inlineIndent: Ce,
    subMenuOpenDelay: E,
    subMenuCloseDelay: A,
    forceSubMenuRender: I,
    builtinPlacements: ae,
    triggerSubMenuAction: ve,
    getPopupContainer: x,
    itemIcon: he,
    expandIcon: Re,
    onItemClick: er,
    onOpenChange: Ht
  }, /* @__PURE__ */ c.createElement(gl.Provider, {
    value: Sr
  }, Cr), /* @__PURE__ */ c.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ c.createElement(ml.Provider, {
    value: He
  }, re)))));
}), En = qv;
En.Item = Ro;
En.SubMenu = ri;
En.ItemGroup = zl;
En.Divider = Vl;
const Gv = (t) => /* @__PURE__ */ st(
  "svg",
  {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    ...t,
    children: [
      /* @__PURE__ */ D("path", { stroke: "none", d: "M0 0h24v24H0z" }),
      /* @__PURE__ */ D("path", { d: "M13 12 A1 1 0 0 1 12 13 A1 1 0 0 1 11 12 A1 1 0 0 1 13 12 z" }),
      /* @__PURE__ */ D("path", { d: "M13 19 A1 1 0 0 1 12 20 A1 1 0 0 1 11 19 A1 1 0 0 1 13 19 z" }),
      /* @__PURE__ */ D("path", { d: "M13 5 A1 1 0 0 1 12 6 A1 1 0 0 1 11 5 A1 1 0 0 1 13 5 z" })
    ]
  }
);
function Qv(t) {
  return /* @__PURE__ */ D(
    "svg",
    {
      viewBox: "0 0 21 21",
      fill: "currentColor",
      height: "1em",
      width: "1em",
      ...t,
      children: /* @__PURE__ */ D(
        "g",
        {
          fill: "none",
          fillRule: "evenodd",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: /* @__PURE__ */ D("path", { d: "M3.578 6.487A8 8 0 112.5 10.5M7.5 6.5h-4v-4" })
        }
      )
    }
  );
}
const Jv = (t) => /* @__PURE__ */ D(
  "svg",
  {
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ...t,
    children: /* @__PURE__ */ D("path", { d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" })
  }
), iu = gn(Ro)`
  padding: 7px 10px !important;
  cursor: pointer;
  font-family: -apple-system, "system-ui", "Segoe UI", Roboto, Oxygen-Sans,
    Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background-color: #f0f0f0;
  }
`, Yv = gn(Gv)`
  font-size: 1.5em;
  cursor: pointer;
  color: #000000;
`, Zv = gn(Qv)`
  font-size: 12px;
  flex-shrink: 0;
`, Xv = gn(Jv)`
  font-size: 12px;
  flex-shrink: 0;
`, Hl = ({
  onResetTableView: t,
  resetTableViewLabel: e,
  currentTableType: r,
  onChangeTableType: n,
  changeToInfiniteLabel: o,
  changeToPaginatedLabel: a
}) => /* @__PURE__ */ D(tf, { overlay: /* @__PURE__ */ st(En, { onClick: ({ key: u }) => {
  if (u === "1")
    t();
  else if (u === "2") {
    const l = r === "paginated" ? "infinite" : "paginated";
    n == null || n(l);
  }
}, children: [
  /* @__PURE__ */ st(iu, { children: [
    /* @__PURE__ */ D(Zv, {}),
    /* @__PURE__ */ D("span", { children: e })
  ] }, "1"),
  n && /* @__PURE__ */ st(iu, { children: [
    /* @__PURE__ */ D(Xv, {}),
    /* @__PURE__ */ D("span", { children: r === "paginated" ? o : a })
  ] }, "2")
] }), trigger: ["click"], children: /* @__PURE__ */ D(
  "div",
  {
    style: { display: "inline-block" },
    "aria-label": "More options",
    role: "button",
    tabIndex: 0,
    children: /* @__PURE__ */ D(Yv, {})
  }
) }), ni = jt(
  ({ message: t = "No results found" }) => /* @__PURE__ */ D("span", { style: { color: "#333" }, children: t })
);
ni.displayName = "NoRowsOverlay";
const uu = 100, ep = Number.MAX_SAFE_INTEGER, tp = 30, ql = mn(
  (t, e) => {
    const {
      onRequestData: r,
      columns: n,
      onRowDoubleClick: o,
      onRowSelectionChange: a,
      height: i = 600,
      onRowStyle: s,
      onColumnChanged: u,
      onGetColumnsState: l,
      onChangeFirstVisibleRowIndex: d,
      onGetFirstVisibleRowIndex: y,
      selectedRowKeys: f = [],
      totalRows: v = ep,
      onSelectionCheckboxClicked: h,
      footer: b,
      footerHeight: p = 30,
      onRowStatus: S,
      statusComponent: w,
      hasStatusColumn: C = !1,
      strings: m = {},
      showPointerCursorInRows: g = !0,
      initialSortState: E,
      cacheBlockSize: R = 30,
      onChangeTableType: A
    } = t, I = Ae(null), N = Ae(!0), K = Ae(!0), M = Ae(!1), P = Ae(null), j = b ? i + p : i, W = b ? i - p : i, G = Ae(), Y = Ae(!1), V = H(() => {
      var T, _;
      (_ = (T = I.current) == null ? void 0 : T.api) == null || _.forEachNode(($) => {
        var F;
        (F = $ == null ? void 0 : $.data) != null && F.id && f.includes($.data.id) ? $.setSelected(!0) : $.setSelected(!1);
      });
    }, [f]);
    $s(() => {
      V();
    }, [f]), hn(e, () => ({
      setSelectedRows: (T) => {
        var _, $;
        ($ = (_ = I.current) == null ? void 0 : _.api) == null || $.forEachNode((F) => {
          var ne;
          (ne = F == null ? void 0 : F.data) != null && ne.id && T.includes(F.data.id) ? F.setSelected(!0) : F.setSelected(!1);
        });
      },
      unselectAll: () => {
        var T, _;
        (_ = (T = I.current) == null ? void 0 : T.api) == null || _.deselectAll();
      },
      refresh: () => {
        var T, _, $, F;
        (_ = (T = I.current) == null ? void 0 : T.api) == null || _.deselectAll(), (F = ($ = I.current) == null ? void 0 : $.api) == null || F.purgeInfiniteCache();
      },
      updateRows: (T) => {
        var _;
        (_ = I.current) != null && _.api && T.filter(($) => $ == null ? void 0 : $.id).forEach(($) => {
          var ne;
          const F = (ne = I.current) == null ? void 0 : ne.api.getRenderedNodes().find((re) => {
            var ie;
            return ((ie = re.data) == null ? void 0 : ie.id) === ($ == null ? void 0 : $.id);
          });
          F && F.setData({ ...F.data, ...$ });
        });
      },
      getVisibleRowIds: () => {
        var _;
        return (_ = I.current) != null && _.api ? I.current.api.getRenderedNodes().map(($) => {
          var F;
          return (F = $ == null ? void 0 : $.data) == null ? void 0 : F.id;
        }) : [];
      },
      getVisibleRows: () => {
        var _;
        return (_ = I.current) != null && _.api ? I.current.api.getRenderedNodes().map(($) => $ == null ? void 0 : $.data) : [];
      },
      refreshRowStyles: () => {
        var T;
        (T = I.current) != null && T.api && I.current.api.redrawRows();
      }
    }));
    const te = Ls(n, "key"), {
      loadPersistedColumnState: Q,
      columnsPersistedStateRef: de,
      applyAndUpdateNewState: ye,
      applyAutoFitState: Ce
    } = Ws({
      gridRef: I,
      containerRef: P,
      columns: te,
      onGetColumnsState: l
    }), Me = H(() => {
      var $;
      const T = ($ = I == null ? void 0 : I.current) == null ? void 0 : $.api.getColumnState();
      if (!T)
        return;
      const _ = l == null ? void 0 : l();
      Ks(T, _) || (ye(T), u == null || u(T));
    }, [ye, u, l]), $e = H(
      (T) => {
        !T.finished || T.source !== "uiColumnResized" || Me();
      },
      [Me]
    ), me = yt(() => {
      if (w)
        return jt((T) => w(T.status));
    }, [w]), ve = yt(() => {
      const T = {
        checkboxSelection: !0,
        suppressMovable: !0,
        sortable: !1,
        pinned: "left",
        lockPosition: "left",
        lockPinned: !0,
        maxWidth: 50,
        resizable: !1,
        field: Va,
        headerComponent: () => /* @__PURE__ */ D(
          js,
          {
            totalRows: v,
            selectedRowKeysLength: (f == null ? void 0 : f.length) || 0,
            onSelectionCheckboxClicked: h
          }
        )
      }, _ = de.current, $ = _ == null ? void 0 : _.map((ie) => ie.colId), F = te.map((ie) => {
        const ue = E == null ? void 0 : E.find(
          (se) => se.colId === ie.key
        );
        return {
          field: ie.key,
          sortable: ie.isSortable,
          headerName: ie.title,
          sort: ue == null ? void 0 : ue.sort,
          sortIndex: ue == null ? void 0 : ue.sortIndex,
          cellRenderer: ie.render ? (se) => ie.render(se.value, se.data) : void 0
        };
      });
      return _ && $ && F.sort((ie, ue) => {
        const se = $.indexOf(ie.field), Ke = $.indexOf(ue.field);
        return se - Ke;
      }), [{
        field: za,
        suppressMovable: !0,
        sortable: !1,
        lockPosition: "left",
        lockPinned: !0,
        maxWidth: 30,
        pinned: "left",
        resizable: !1,
        cellStyle: {
          padding: 0,
          margin: 0
        },
        headerComponent: () => /* @__PURE__ */ D(
          Hl,
          {
            resetTableViewLabel: (m == null ? void 0 : m.resetTableViewLabel) || "resetTableViewLabel",
            currentTableType: "infinite",
            onChangeTableType: A,
            changeToInfiniteLabel: (m == null ? void 0 : m.changeToInfiniteLabel) || "Canviar a llistat infinit",
            changeToPaginatedLabel: (m == null ? void 0 : m.changeToPaginatedLabel) || "Canviar a llistat paginat",
            onResetTableView: async () => {
              var ie;
              ye([]), (ie = I.current) == null || ie.api.resetColumnState(), Ce(), u == null || u([]);
            }
          }
        ),
        cellRenderer: me ? (ie) => /* @__PURE__ */ D(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "100%"
            },
            children: /* @__PURE__ */ D(me, { status: ie.value })
          }
        ) : void 0
      }, T, ...F];
    }, [
      de,
      te,
      me,
      v,
      f == null ? void 0 : f.length,
      h,
      E,
      m,
      ye,
      Ce,
      u,
      A
    ]), ae = H(() => {
      var _;
      const T = y == null ? void 0 : y();
      T && ((_ = I.current) != null && _.api) && I.current.api.ensureIndexVisible(T, "top");
    }, [y]), he = H(
      (T) => {
        if (S)
          return S(T);
      },
      [S]
    ), Re = H(
      async (T) => {
        var _, $, F, ne, re, ie;
        try {
          if (M.current)
            return;
          const { startRow: ue, endRow: se } = T;
          if (R === v && T.startRow !== 0) {
            T.successCallback([], v);
            return;
          }
          M.current = !0, ue === 0 && ((_ = I.current) == null || _.api.showLoadingOverlay());
          const Ke = await r({
            startRow: ue,
            endRow: se,
            state: ($ = I.current) == null ? void 0 : $.api.getColumnState()
          });
          if (!Ke)
            throw new Error("Data is undefined");
          if (ue === 0 && Ke.length === 0) {
            (F = I.current) == null || F.api.showNoRowsOverlay(), T.successCallback([], 0), M.current = !1;
            return;
          }
          let Ue = -1;
          Ke.length < se - ue && (Ue = ue + Ke.length), Ue === -1 && v >= R && R !== tp && (Ue = R);
          const O = C ? await Promise.all(
            Ke.map(async (k) => {
              const L = he ? await he(k) : void 0;
              return {
                ...k,
                $status: L
              };
            })
          ) : Ke;
          T.successCallback(O, Ue), f && f.length > 0 && ((ne = I == null ? void 0 : I.current) == null || ne.api.forEachNode((k) => {
            var L;
            (L = k == null ? void 0 : k.data) != null && L.id && f.includes(k.data.id) && k.setSelected(!0);
          })), !de.current && !Y.current && (Y.current = !0, Ce()), M.current = !1, (re = I.current) == null || re.api.hideOverlay(), N.current && (N.current = !1, ae());
        } catch {
          M.current = !1, T.failCallback(), (ie = I.current) == null || ie.api.hideOverlay();
        }
      },
      [
        R,
        v,
        r,
        C,
        f,
        de,
        he,
        Ce,
        ae
      ]
    );
    dt(() => {
      G.current = { getRows: Re };
    }, [Re]);
    const ee = H(
      (T) => {
        Q(), T.api.setGridOption("datasource", {
          getRows: (_) => {
            var $;
            ($ = G.current) == null || $.getRows(_);
          }
        });
      },
      [G, Q]
    ), Pe = H(
      ({ data: T }) => {
        o == null || o(T);
      },
      [o]
    ), ke = H(
      ef((T) => {
        K.current || d == null || d(
          T.api.getFirstDisplayedRowIndex()
        ), K.current = !1;
      }, uu),
      [d]
    ), x = H(() => {
      var _, $;
      const T = [];
      return ($ = (_ = I.current) == null ? void 0 : _.api) == null || $.forEachNode((F) => {
        var ne;
        (ne = F == null ? void 0 : F.data) != null && ne.id && T.push(F.data.id);
      }), T;
    }, []), Se = H(
      (T) => {
        const _ = x(), $ = T.api.getSelectedNodes() || [], F = f.filter(
          (ue) => !_.includes(ue)
        ), ne = $.map(
          (ue) => ue.data.id
        ), re = Array.from(
          /* @__PURE__ */ new Set([
            ...ne,
            ...F
          ])
        );
        (re.length !== f.length || re.some((ue) => !f.includes(ue))) && (a == null || a(re));
      },
      [x, a, f]
    ), Ee = yt(() => ({
      cursor: g ? "pointer" : "default"
    }), [g]), Ie = yt(() => () => /* @__PURE__ */ D(ni, { message: m == null ? void 0 : m.noResultsLabel }), [m]);
    return /* @__PURE__ */ st(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          height: j
        },
        children: [
          /* @__PURE__ */ D(
            "div",
            {
              ref: P,
              className: "ag-grid-default-table ag-theme-quartz",
              style: { height: W, width: "100%" },
              children: /* @__PURE__ */ D(
                xs,
                {
                  ref: I,
                  columnDefs: ve,
                  onRowDoubleClicked: Pe,
                  enableCellTextSelection: !0,
                  rowStyle: Ee,
                  getRowStyle: s,
                  suppressCellFocus: !0,
                  suppressRowClickSelection: !0,
                  rowBuffer: 5,
                  rowSelection: "multiple",
                  onDragStopped: Me,
                  onColumnResized: $e,
                  rowModelType: "infinite",
                  cacheBlockSize: R,
                  onSelectionChanged: Se,
                  cacheOverflowSize: 2,
                  maxConcurrentDatasourceRequests: 1,
                  infiniteInitialRowCount: v,
                  onGridReady: ee,
                  onBodyScroll: ke,
                  blockLoadDebounceMillis: uu,
                  suppressDragLeaveHidesColumns: !0,
                  noRowsOverlayComponent: Ie
                }
              )
            }
          ),
          b && /* @__PURE__ */ D(
            "div",
            {
              style: {
                height: p
              },
              children: b
            }
          )
        ]
      }
    );
  }
);
ql.displayName = "InfiniteTable";
const nb = jt(ql);
function rp(t, e) {
  const r = Ae(null), n = Ae(e);
  return dt(() => {
    n.current = e;
  }, [e]), dt(() => {
    r.current && r.current.setState(t);
  }, [t]), { HeaderComponent: H(
    () => /* @__PURE__ */ D(
      Ql,
      {
        ref: r,
        onClick: () => {
          n.current();
        }
      }
    ),
    []
    // No dependencies needed since we're using refs
  ) };
}
const Gl = jt(
  mn(
    ({ onClick: t }, e) => {
      const r = Ae(null);
      hn(e, () => ({
        setState: (o) => {
          const a = r.current;
          a && (o === "checked" ? (a.checked = !0, a.indeterminate = !1) : o === "unchecked" ? (a.checked = !1, a.indeterminate = !1) : o === "indeterminate" && (a.checked = !1, a.indeterminate = !0));
        }
      }));
      const n = H(
        (o) => {
          o.stopPropagation(), t();
        },
        [t]
      );
      return /* @__PURE__ */ D(
        "input",
        {
          style: {
            width: "13px",
            height: "13px",
            border: "1px solid grey",
            cursor: "pointer",
            margin: 0
          },
          onDoubleClick: (o) => {
            o.stopPropagation();
          },
          ref: r,
          type: "checkbox",
          onChange: n,
          tabIndex: -1
        }
      );
    }
  )
);
Gl.displayName = "PaginatedHeaderCheckboxComp";
const Ql = jt(
  mn(
    // eslint-disable-next-line react/prop-types
    ({ onClick: t }, e) => /* @__PURE__ */ D(Gl, { ref: e, onClick: t })
  )
);
Ql.displayName = "PaginatedHeaderCheckbox";
var su = Object.prototype.toString, Jl = function(e) {
  var r = su.call(e), n = r === "[object Arguments]";
  return n || (n = r !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && su.call(e.callee) === "[object Function]"), n;
}, Bo, lu;
function np() {
  if (lu)
    return Bo;
  lu = 1;
  var t;
  if (!Object.keys) {
    var e = Object.prototype.hasOwnProperty, r = Object.prototype.toString, n = Jl, o = Object.prototype.propertyIsEnumerable, a = !o.call({ toString: null }, "toString"), i = o.call(function() {
    }, "prototype"), s = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], u = function(f) {
      var v = f.constructor;
      return v && v.prototype === f;
    }, l = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, d = function() {
      if (typeof window > "u")
        return !1;
      for (var f in window)
        try {
          if (!l["$" + f] && e.call(window, f) && window[f] !== null && typeof window[f] == "object")
            try {
              u(window[f]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), y = function(f) {
      if (typeof window > "u" || !d)
        return u(f);
      try {
        return u(f);
      } catch {
        return !1;
      }
    };
    t = function(v) {
      var h = v !== null && typeof v == "object", b = r.call(v) === "[object Function]", p = n(v), S = h && r.call(v) === "[object String]", w = [];
      if (!h && !b && !p)
        throw new TypeError("Object.keys called on a non-object");
      var C = i && b;
      if (S && v.length > 0 && !e.call(v, 0))
        for (var m = 0; m < v.length; ++m)
          w.push(String(m));
      if (p && v.length > 0)
        for (var g = 0; g < v.length; ++g)
          w.push(String(g));
      else
        for (var E in v)
          !(C && E === "prototype") && e.call(v, E) && w.push(String(E));
      if (a)
        for (var R = y(v), A = 0; A < s.length; ++A)
          !(R && s[A] === "constructor") && e.call(v, s[A]) && w.push(s[A]);
      return w;
    };
  }
  return Bo = t, Bo;
}
var op = Array.prototype.slice, ap = Jl, cu = Object.keys, Fn = cu ? function(e) {
  return cu(e);
} : np(), fu = Object.keys;
Fn.shim = function() {
  if (Object.keys) {
    var e = function() {
      var r = Object.keys(arguments);
      return r && r.length === arguments.length;
    }(1, 2);
    e || (Object.keys = function(n) {
      return ap(n) ? fu(op.call(n)) : fu(n);
    });
  } else
    Object.keys = Fn;
  return Object.keys || Fn;
};
var oi = Fn, Ao = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var o = 42;
  e[r] = o;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var a = Object.getOwnPropertySymbols(e);
  if (a.length !== 1 || a[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var i = Object.getOwnPropertyDescriptor(e, r);
    if (i.value !== o || i.enumerable !== !0)
      return !1;
  }
  return !0;
}, du = typeof Symbol < "u" && Symbol, ip = Ao, ai = function() {
  return typeof du != "function" || typeof Symbol != "function" || typeof du("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : ip();
}, vu = {
  foo: {}
}, up = Object, sp = function() {
  return { __proto__: vu }.foo === vu.foo && !({ __proto__: null } instanceof up);
}, lp = "Function.prototype.bind called on incompatible ", cp = Object.prototype.toString, fp = Math.max, dp = "[object Function]", pu = function(e, r) {
  for (var n = [], o = 0; o < e.length; o += 1)
    n[o] = e[o];
  for (var a = 0; a < r.length; a += 1)
    n[a + e.length] = r[a];
  return n;
}, vp = function(e, r) {
  for (var n = [], o = r || 0, a = 0; o < e.length; o += 1, a += 1)
    n[a] = e[o];
  return n;
}, pp = function(t, e) {
  for (var r = "", n = 0; n < t.length; n += 1)
    r += t[n], n + 1 < t.length && (r += e);
  return r;
}, yp = function(e) {
  var r = this;
  if (typeof r != "function" || cp.apply(r) !== dp)
    throw new TypeError(lp + r);
  for (var n = vp(arguments, 1), o, a = function() {
    if (this instanceof o) {
      var d = r.apply(
        this,
        pu(n, arguments)
      );
      return Object(d) === d ? d : this;
    }
    return r.apply(
      e,
      pu(n, arguments)
    );
  }, i = fp(0, r.length - n.length), s = [], u = 0; u < i; u++)
    s[u] = "$" + u;
  if (o = Function("binder", "return function (" + pp(s, ",") + "){ return binder.apply(this,arguments); }")(a), r.prototype) {
    var l = function() {
    };
    l.prototype = r.prototype, o.prototype = new l(), l.prototype = null;
  }
  return o;
}, mp = yp, ii = Function.prototype.bind || mp, hp = Function.prototype.call, gp = Object.prototype.hasOwnProperty, bp = ii, Yl = bp.call(hp, gp), pe, Br = SyntaxError, Zl = Function, Fr = TypeError, Wo = function(t) {
  try {
    return Zl('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, pr = Object.getOwnPropertyDescriptor;
if (pr)
  try {
    pr({}, "");
  } catch {
    pr = null;
  }
var Ko = function() {
  throw new Fr();
}, Sp = pr ? function() {
  try {
    return arguments.callee, Ko;
  } catch {
    try {
      return pr(arguments, "callee").get;
    } catch {
      return Ko;
    }
  }
}() : Ko, $r = ai(), Ep = sp(), Qe = Object.getPrototypeOf || (Ep ? function(t) {
  return t.__proto__;
} : null), xr = {}, wp = typeof Uint8Array > "u" || !Qe ? pe : Qe(Uint8Array), yr = {
  "%AggregateError%": typeof AggregateError > "u" ? pe : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? pe : ArrayBuffer,
  "%ArrayIteratorPrototype%": $r && Qe ? Qe([][Symbol.iterator]()) : pe,
  "%AsyncFromSyncIteratorPrototype%": pe,
  "%AsyncFunction%": xr,
  "%AsyncGenerator%": xr,
  "%AsyncGeneratorFunction%": xr,
  "%AsyncIteratorPrototype%": xr,
  "%Atomics%": typeof Atomics > "u" ? pe : Atomics,
  "%BigInt%": typeof BigInt > "u" ? pe : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? pe : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? pe : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? pe : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? pe : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? pe : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? pe : FinalizationRegistry,
  "%Function%": Zl,
  "%GeneratorFunction%": xr,
  "%Int8Array%": typeof Int8Array > "u" ? pe : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? pe : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? pe : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": $r && Qe ? Qe(Qe([][Symbol.iterator]())) : pe,
  "%JSON%": typeof JSON == "object" ? JSON : pe,
  "%Map%": typeof Map > "u" ? pe : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !$r || !Qe ? pe : Qe((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? pe : Promise,
  "%Proxy%": typeof Proxy > "u" ? pe : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? pe : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? pe : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !$r || !Qe ? pe : Qe((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? pe : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": $r && Qe ? Qe(""[Symbol.iterator]()) : pe,
  "%Symbol%": $r ? Symbol : pe,
  "%SyntaxError%": Br,
  "%ThrowTypeError%": Sp,
  "%TypedArray%": wp,
  "%TypeError%": Fr,
  "%Uint8Array%": typeof Uint8Array > "u" ? pe : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? pe : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? pe : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? pe : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? pe : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? pe : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? pe : WeakSet
};
if (Qe)
  try {
    null.error;
  } catch (t) {
    var Cp = Qe(Qe(t));
    yr["%Error.prototype%"] = Cp;
  }
var Rp = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = Wo("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = Wo("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = Wo("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = t("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var o = t("%AsyncGenerator%");
    o && Qe && (r = Qe(o.prototype));
  }
  return yr[e] = r, r;
}, yu = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, wn = ii, eo = Yl, Pp = wn.call(Function.call, Array.prototype.concat), Ip = wn.call(Function.apply, Array.prototype.splice), mu = wn.call(Function.call, String.prototype.replace), to = wn.call(Function.call, String.prototype.slice), Ap = wn.call(Function.call, RegExp.prototype.exec), Mp = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, _p = /\\(\\)?/g, Op = function(e) {
  var r = to(e, 0, 1), n = to(e, -1);
  if (r === "%" && n !== "%")
    throw new Br("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new Br("invalid intrinsic syntax, expected opening `%`");
  var o = [];
  return mu(e, Mp, function(a, i, s, u) {
    o[o.length] = s ? mu(u, _p, "$1") : i || a;
  }), o;
}, $p = function(e, r) {
  var n = e, o;
  if (eo(yu, n) && (o = yu[n], n = "%" + o[0] + "%"), eo(yr, n)) {
    var a = yr[n];
    if (a === xr && (a = Rp(n)), typeof a > "u" && !r)
      throw new Fr("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: o,
      name: n,
      value: a
    };
  }
  throw new Br("intrinsic " + e + " does not exist!");
}, ht = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new Fr("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new Fr('"allowMissing" argument must be a boolean');
  if (Ap(/^%?[^%]*%?$/, e) === null)
    throw new Br("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = Op(e), o = n.length > 0 ? n[0] : "", a = $p("%" + o + "%", r), i = a.name, s = a.value, u = !1, l = a.alias;
  l && (o = l[0], Ip(n, Pp([0, 1], l)));
  for (var d = 1, y = !0; d < n.length; d += 1) {
    var f = n[d], v = to(f, 0, 1), h = to(f, -1);
    if ((v === '"' || v === "'" || v === "`" || h === '"' || h === "'" || h === "`") && v !== h)
      throw new Br("property names with quotes must have matching quotes");
    if ((f === "constructor" || !y) && (u = !0), o += "." + f, i = "%" + o + "%", eo(yr, i))
      s = yr[i];
    else if (s != null) {
      if (!(f in s)) {
        if (!r)
          throw new Fr("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (pr && d + 1 >= n.length) {
        var b = pr(s, f);
        y = !!b, y && "get" in b && !("originalValue" in b.get) ? s = b.get : s = s[f];
      } else
        y = eo(s, f), s = s[f];
      y && !u && (yr[i] = s);
    }
  }
  return s;
}, Np = ht, Ra = Np("%Object.defineProperty%", !0), Pa = function() {
  if (Ra)
    try {
      return Ra({}, "a", { value: 1 }), !0;
    } catch {
      return !1;
    }
  return !1;
};
Pa.hasArrayLengthDefineBug = function() {
  if (!Pa())
    return null;
  try {
    return Ra([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var Mo = Pa, xp = ht, jn = xp("%Object.getOwnPropertyDescriptor%", !0);
if (jn)
  try {
    jn([], "length");
  } catch {
    jn = null;
  }
var ui = jn, Tp = Mo(), si = ht, ln = Tp && si("%Object.defineProperty%", !0);
if (ln)
  try {
    ln({}, "a", { value: 1 });
  } catch {
    ln = !1;
  }
var kp = si("%SyntaxError%"), Nr = si("%TypeError%"), hu = ui, li = function(e, r, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new Nr("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new Nr("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new Nr("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new Nr("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new Nr("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new Nr("`loose`, if provided, must be a boolean");
  var o = arguments.length > 3 ? arguments[3] : null, a = arguments.length > 4 ? arguments[4] : null, i = arguments.length > 5 ? arguments[5] : null, s = arguments.length > 6 ? arguments[6] : !1, u = !!hu && hu(e, r);
  if (ln)
    ln(e, r, {
      configurable: i === null && u ? u.configurable : !i,
      enumerable: o === null && u ? u.enumerable : !o,
      value: n,
      writable: a === null && u ? u.writable : !a
    });
  else if (s || !o && !a && !i)
    e[r] = n;
  else
    throw new kp("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Dp = oi, Lp = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", Fp = Object.prototype.toString, jp = Array.prototype.concat, gu = li, Bp = function(t) {
  return typeof t == "function" && Fp.call(t) === "[object Function]";
}, Xl = Mo(), Wp = function(t, e, r, n) {
  if (e in t) {
    if (n === !0) {
      if (t[e] === r)
        return;
    } else if (!Bp(n) || !n())
      return;
  }
  Xl ? gu(t, e, r, !0) : gu(t, e, r);
}, ec = function(t, e) {
  var r = arguments.length > 2 ? arguments[2] : {}, n = Dp(e);
  Lp && (n = jp.call(n, Object.getOwnPropertySymbols(e)));
  for (var o = 0; o < n.length; o += 1)
    Wp(t, n[o], e[n[o]], r[n[o]]);
};
ec.supportsDescriptors = !!Xl;
var mr = ec, tc = { exports: {} }, rc = ht, bu = li, Kp = Mo(), Su = ui, Eu = rc("%TypeError%"), Up = rc("%Math.floor%"), zp = function(e, r) {
  if (typeof e != "function")
    throw new Eu("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || Up(r) !== r)
    throw new Eu("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], o = !0, a = !0;
  if ("length" in e && Su) {
    var i = Su(e, "length");
    i && !i.configurable && (o = !1), i && !i.writable && (a = !1);
  }
  return (o || a || !n) && (Kp ? bu(e, "length", r, !0, !0) : bu(e, "length", r)), e;
};
(function(t) {
  var e = ii, r = ht, n = zp, o = r("%TypeError%"), a = r("%Function.prototype.apply%"), i = r("%Function.prototype.call%"), s = r("%Reflect.apply%", !0) || e.call(i, a), u = r("%Object.defineProperty%", !0), l = r("%Math.max%");
  if (u)
    try {
      u({}, "a", { value: 1 });
    } catch {
      u = null;
    }
  t.exports = function(f) {
    if (typeof f != "function")
      throw new o("a function is required");
    var v = s(e, i, arguments);
    return n(
      v,
      1 + l(0, f.length - (arguments.length - 1)),
      !0
    );
  };
  var d = function() {
    return s(e, a, arguments);
  };
  u ? u(t.exports, "apply", { value: d }) : t.exports.apply = d;
})(tc);
var zr = tc.exports, nc = ht, oc = zr, Vp = oc(nc("String.prototype.indexOf")), gt = function(e, r) {
  var n = nc(e, !!r);
  return typeof n == "function" && Vp(e, ".prototype.") > -1 ? oc(n) : n;
}, Hp = oi, ac = Ao(), ic = gt, wu = Object, qp = ic("Array.prototype.push"), Cu = ic("Object.prototype.propertyIsEnumerable"), Gp = ac ? Object.getOwnPropertySymbols : null, uc = function(e, r) {
  if (e == null)
    throw new TypeError("target must be an object");
  var n = wu(e);
  if (arguments.length === 1)
    return n;
  for (var o = 1; o < arguments.length; ++o) {
    var a = wu(arguments[o]), i = Hp(a), s = ac && (Object.getOwnPropertySymbols || Gp);
    if (s)
      for (var u = s(a), l = 0; l < u.length; ++l) {
        var d = u[l];
        Cu(a, d) && qp(i, d);
      }
    for (var y = 0; y < i.length; ++y) {
      var f = i[y];
      if (Cu(a, f)) {
        var v = a[f];
        n[f] = v;
      }
    }
  }
  return n;
}, Uo = uc, Qp = function() {
  if (!Object.assign)
    return !1;
  for (var t = "abcdefghijklmnopqrst", e = t.split(""), r = {}, n = 0; n < e.length; ++n)
    r[e[n]] = e[n];
  var o = Object.assign({}, r), a = "";
  for (var i in o)
    a += i;
  return t !== a;
}, Jp = function() {
  if (!Object.assign || !Object.preventExtensions)
    return !1;
  var t = Object.preventExtensions({ 1: 2 });
  try {
    Object.assign(t, "xy");
  } catch {
    return t[1] === "y";
  }
  return !1;
}, sc = function() {
  return !Object.assign || Qp() || Jp() ? Uo : Object.assign;
}, Yp = mr, Zp = sc, Xp = function() {
  var e = Zp();
  return Yp(
    Object,
    { assign: e },
    { assign: function() {
      return Object.assign !== e;
    } }
  ), e;
}, ey = mr, ty = zr, ry = uc, lc = sc, ny = Xp, oy = ty.apply(lc()), cc = function(e, r) {
  return oy(Object, arguments);
};
ey(cc, {
  getPolyfill: lc,
  implementation: ry,
  shim: ny
});
var ay = cc, yn = function() {
  return typeof (function() {
  }).name == "string";
}, cn = Object.getOwnPropertyDescriptor;
if (cn)
  try {
    cn([], "length");
  } catch {
    cn = null;
  }
yn.functionsHaveConfigurableNames = function() {
  if (!yn() || !cn)
    return !1;
  var e = cn(function() {
  }, "name");
  return !!e && !!e.configurable;
};
var iy = Function.prototype.bind;
yn.boundFunctionsHaveNames = function() {
  return yn() && typeof iy == "function" && (function() {
  }).bind().name !== "";
};
var uy = yn, Ru = li, sy = Mo(), ly = uy.functionsHaveConfigurableNames(), cy = TypeError, fy = function(e, r) {
  if (typeof e != "function")
    throw new cy("`fn` is not a function");
  var n = arguments.length > 2 && !!arguments[2];
  return (!n || ly) && (sy ? Ru(e, "name", r, !0, !0) : Ru(e, "name", r)), e;
}, dy = fy, vy = Object, py = TypeError, fc = dy(function() {
  if (this != null && this !== vy(this))
    throw new py("RegExp.prototype.flags getter called on non-object");
  var e = "";
  return this.hasIndices && (e += "d"), this.global && (e += "g"), this.ignoreCase && (e += "i"), this.multiline && (e += "m"), this.dotAll && (e += "s"), this.unicode && (e += "u"), this.unicodeSets && (e += "v"), this.sticky && (e += "y"), e;
}, "get flags", !0), yy = fc, my = mr.supportsDescriptors, hy = Object.getOwnPropertyDescriptor, dc = function() {
  if (my && /a/mig.flags === "gim") {
    var e = hy(RegExp.prototype, "flags");
    if (e && typeof e.get == "function" && typeof RegExp.prototype.dotAll == "boolean" && typeof RegExp.prototype.hasIndices == "boolean") {
      var r = "", n = {};
      if (Object.defineProperty(n, "hasIndices", {
        get: function() {
          r += "d";
        }
      }), Object.defineProperty(n, "sticky", {
        get: function() {
          r += "y";
        }
      }), r === "dy")
        return e.get;
    }
  }
  return yy;
}, gy = mr.supportsDescriptors, by = dc, Sy = Object.getOwnPropertyDescriptor, Ey = Object.defineProperty, wy = TypeError, Pu = Object.getPrototypeOf, Cy = /a/, Ry = function() {
  if (!gy || !Pu)
    throw new wy("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
  var e = by(), r = Pu(Cy), n = Sy(r, "flags");
  return (!n || n.get !== e) && Ey(r, "flags", {
    configurable: !0,
    enumerable: !1,
    get: e
  }), e;
}, Py = mr, Iy = zr, Ay = fc, vc = dc, My = Ry, pc = Iy(vc());
Py(pc, {
  getPolyfill: vc,
  implementation: Ay,
  shim: My
});
var _y = pc, Bn = { exports: {} }, Oy = Ao, hr = function() {
  return Oy() && !!Symbol.toStringTag;
}, $y = hr(), Ny = gt, Ia = Ny("Object.prototype.toString"), _o = function(e) {
  return $y && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : Ia(e) === "[object Arguments]";
}, yc = function(e) {
  return _o(e) ? !0 : e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && Ia(e) !== "[object Array]" && Ia(e.callee) === "[object Function]";
}, xy = function() {
  return _o(arguments);
}();
_o.isLegacyArguments = yc;
var mc = xy ? _o : yc;
const Ty = {}, ky = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ty
}, Symbol.toStringTag, { value: "Module" })), Dy = /* @__PURE__ */ Mf(ky);
var ci = typeof Map == "function" && Map.prototype, zo = Object.getOwnPropertyDescriptor && ci ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, ro = ci && zo && typeof zo.get == "function" ? zo.get : null, Iu = ci && Map.prototype.forEach, fi = typeof Set == "function" && Set.prototype, Vo = Object.getOwnPropertyDescriptor && fi ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, no = fi && Vo && typeof Vo.get == "function" ? Vo.get : null, Au = fi && Set.prototype.forEach, Ly = typeof WeakMap == "function" && WeakMap.prototype, fn = Ly ? WeakMap.prototype.has : null, Fy = typeof WeakSet == "function" && WeakSet.prototype, dn = Fy ? WeakSet.prototype.has : null, jy = typeof WeakRef == "function" && WeakRef.prototype, Mu = jy ? WeakRef.prototype.deref : null, By = Boolean.prototype.valueOf, Wy = Object.prototype.toString, Ky = Function.prototype.toString, Uy = String.prototype.match, di = String.prototype.slice, ar = String.prototype.replace, zy = String.prototype.toUpperCase, _u = String.prototype.toLowerCase, hc = RegExp.prototype.test, Ou = Array.prototype.concat, Dt = Array.prototype.join, Vy = Array.prototype.slice, $u = Math.floor, Aa = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Ho = Object.getOwnPropertySymbols, Ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Wr = typeof Symbol == "function" && typeof Symbol.iterator == "object", it = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Wr || "symbol") ? Symbol.toStringTag : null, gc = Object.prototype.propertyIsEnumerable, Nu = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(t) {
  return t.__proto__;
} : null);
function xu(t, e) {
  if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || hc.call(/e/, e))
    return e;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof t == "number") {
    var n = t < 0 ? -$u(-t) : $u(t);
    if (n !== t) {
      var o = String(n), a = di.call(e, o.length + 1);
      return ar.call(o, r, "$&_") + "." + ar.call(ar.call(a, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return ar.call(e, r, "$&_");
}
var _a = Dy, Tu = _a.custom, ku = Sc(Tu) ? Tu : null, Hy = function t(e, r, n, o) {
  var a = r || {};
  if (or(a, "quoteStyle") && a.quoteStyle !== "single" && a.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (or(a, "maxStringLength") && (typeof a.maxStringLength == "number" ? a.maxStringLength < 0 && a.maxStringLength !== 1 / 0 : a.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var i = or(a, "customInspect") ? a.customInspect : !0;
  if (typeof i != "boolean" && i !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (or(a, "indent") && a.indent !== null && a.indent !== "	" && !(parseInt(a.indent, 10) === a.indent && a.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (or(a, "numericSeparator") && typeof a.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var s = a.numericSeparator;
  if (typeof e > "u")
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "boolean")
    return e ? "true" : "false";
  if (typeof e == "string")
    return wc(e, a);
  if (typeof e == "number") {
    if (e === 0)
      return 1 / 0 / e > 0 ? "0" : "-0";
    var u = String(e);
    return s ? xu(e, u) : u;
  }
  if (typeof e == "bigint") {
    var l = String(e) + "n";
    return s ? xu(e, l) : l;
  }
  var d = typeof a.depth > "u" ? 5 : a.depth;
  if (typeof n > "u" && (n = 0), n >= d && d > 0 && typeof e == "object")
    return Oa(e) ? "[Array]" : "[Object]";
  var y = cm(a, n);
  if (typeof o > "u")
    o = [];
  else if (Ec(o, e) >= 0)
    return "[Circular]";
  function f(P, j, W) {
    if (j && (o = Vy.call(o), o.push(j)), W) {
      var G = {
        depth: a.depth
      };
      return or(a, "quoteStyle") && (G.quoteStyle = a.quoteStyle), t(P, G, n + 1, o);
    }
    return t(P, a, n + 1, o);
  }
  if (typeof e == "function" && !Du(e)) {
    var v = tm(e), h = On(e, f);
    return "[Function" + (v ? ": " + v : " (anonymous)") + "]" + (h.length > 0 ? " { " + Dt.call(h, ", ") + " }" : "");
  }
  if (Sc(e)) {
    var b = Wr ? ar.call(String(e), /^(Symbol\(.*\))_[^)]*$/, "$1") : Ma.call(e);
    return typeof e == "object" && !Wr ? nn(b) : b;
  }
  if (um(e)) {
    for (var p = "<" + _u.call(String(e.nodeName)), S = e.attributes || [], w = 0; w < S.length; w++)
      p += " " + S[w].name + "=" + bc(qy(S[w].value), "double", a);
    return p += ">", e.childNodes && e.childNodes.length && (p += "..."), p += "</" + _u.call(String(e.nodeName)) + ">", p;
  }
  if (Oa(e)) {
    if (e.length === 0)
      return "[]";
    var C = On(e, f);
    return y && !lm(C) ? "[" + $a(C, y) + "]" : "[ " + Dt.call(C, ", ") + " ]";
  }
  if (Qy(e)) {
    var m = On(e, f);
    return !("cause" in Error.prototype) && "cause" in e && !gc.call(e, "cause") ? "{ [" + String(e) + "] " + Dt.call(Ou.call("[cause]: " + f(e.cause), m), ", ") + " }" : m.length === 0 ? "[" + String(e) + "]" : "{ [" + String(e) + "] " + Dt.call(m, ", ") + " }";
  }
  if (typeof e == "object" && i) {
    if (ku && typeof e[ku] == "function" && _a)
      return _a(e, { depth: d - n });
    if (i !== "symbol" && typeof e.inspect == "function")
      return e.inspect();
  }
  if (rm(e)) {
    var g = [];
    return Iu && Iu.call(e, function(P, j) {
      g.push(f(j, e, !0) + " => " + f(P, e));
    }), Lu("Map", ro.call(e), g, y);
  }
  if (am(e)) {
    var E = [];
    return Au && Au.call(e, function(P) {
      E.push(f(P, e));
    }), Lu("Set", no.call(e), E, y);
  }
  if (nm(e))
    return qo("WeakMap");
  if (im(e))
    return qo("WeakSet");
  if (om(e))
    return qo("WeakRef");
  if (Yy(e))
    return nn(f(Number(e)));
  if (Xy(e))
    return nn(f(Aa.call(e)));
  if (Zy(e))
    return nn(By.call(e));
  if (Jy(e))
    return nn(f(String(e)));
  if (typeof window < "u" && e === window)
    return "{ [object Window] }";
  if (e === Ha)
    return "{ [object globalThis] }";
  if (!Gy(e) && !Du(e)) {
    var R = On(e, f), A = Nu ? Nu(e) === Object.prototype : e instanceof Object || e.constructor === Object, I = e instanceof Object ? "" : "null prototype", N = !A && it && Object(e) === e && it in e ? di.call(ur(e), 8, -1) : I ? "Object" : "", K = A || typeof e.constructor != "function" ? "" : e.constructor.name ? e.constructor.name + " " : "", M = K + (N || I ? "[" + Dt.call(Ou.call([], N || [], I || []), ": ") + "] " : "");
    return R.length === 0 ? M + "{}" : y ? M + "{" + $a(R, y) + "}" : M + "{ " + Dt.call(R, ", ") + " }";
  }
  return String(e);
};
function bc(t, e, r) {
  var n = (r.quoteStyle || e) === "double" ? '"' : "'";
  return n + t + n;
}
function qy(t) {
  return ar.call(String(t), /"/g, "&quot;");
}
function Oa(t) {
  return ur(t) === "[object Array]" && (!it || !(typeof t == "object" && it in t));
}
function Gy(t) {
  return ur(t) === "[object Date]" && (!it || !(typeof t == "object" && it in t));
}
function Du(t) {
  return ur(t) === "[object RegExp]" && (!it || !(typeof t == "object" && it in t));
}
function Qy(t) {
  return ur(t) === "[object Error]" && (!it || !(typeof t == "object" && it in t));
}
function Jy(t) {
  return ur(t) === "[object String]" && (!it || !(typeof t == "object" && it in t));
}
function Yy(t) {
  return ur(t) === "[object Number]" && (!it || !(typeof t == "object" && it in t));
}
function Zy(t) {
  return ur(t) === "[object Boolean]" && (!it || !(typeof t == "object" && it in t));
}
function Sc(t) {
  if (Wr)
    return t && typeof t == "object" && t instanceof Symbol;
  if (typeof t == "symbol")
    return !0;
  if (!t || typeof t != "object" || !Ma)
    return !1;
  try {
    return Ma.call(t), !0;
  } catch {
  }
  return !1;
}
function Xy(t) {
  if (!t || typeof t != "object" || !Aa)
    return !1;
  try {
    return Aa.call(t), !0;
  } catch {
  }
  return !1;
}
var em = Object.prototype.hasOwnProperty || function(t) {
  return t in this;
};
function or(t, e) {
  return em.call(t, e);
}
function ur(t) {
  return Wy.call(t);
}
function tm(t) {
  if (t.name)
    return t.name;
  var e = Uy.call(Ky.call(t), /^function\s*([\w$]+)/);
  return e ? e[1] : null;
}
function Ec(t, e) {
  if (t.indexOf)
    return t.indexOf(e);
  for (var r = 0, n = t.length; r < n; r++)
    if (t[r] === e)
      return r;
  return -1;
}
function rm(t) {
  if (!ro || !t || typeof t != "object")
    return !1;
  try {
    ro.call(t);
    try {
      no.call(t);
    } catch {
      return !0;
    }
    return t instanceof Map;
  } catch {
  }
  return !1;
}
function nm(t) {
  if (!fn || !t || typeof t != "object")
    return !1;
  try {
    fn.call(t, fn);
    try {
      dn.call(t, dn);
    } catch {
      return !0;
    }
    return t instanceof WeakMap;
  } catch {
  }
  return !1;
}
function om(t) {
  if (!Mu || !t || typeof t != "object")
    return !1;
  try {
    return Mu.call(t), !0;
  } catch {
  }
  return !1;
}
function am(t) {
  if (!no || !t || typeof t != "object")
    return !1;
  try {
    no.call(t);
    try {
      ro.call(t);
    } catch {
      return !0;
    }
    return t instanceof Set;
  } catch {
  }
  return !1;
}
function im(t) {
  if (!dn || !t || typeof t != "object")
    return !1;
  try {
    dn.call(t, dn);
    try {
      fn.call(t, fn);
    } catch {
      return !0;
    }
    return t instanceof WeakSet;
  } catch {
  }
  return !1;
}
function um(t) {
  return !t || typeof t != "object" ? !1 : typeof HTMLElement < "u" && t instanceof HTMLElement ? !0 : typeof t.nodeName == "string" && typeof t.getAttribute == "function";
}
function wc(t, e) {
  if (t.length > e.maxStringLength) {
    var r = t.length - e.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return wc(di.call(t, 0, e.maxStringLength), e) + n;
  }
  var o = ar.call(ar.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, sm);
  return bc(o, "single", e);
}
function sm(t) {
  var e = t.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[e];
  return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + zy.call(e.toString(16));
}
function nn(t) {
  return "Object(" + t + ")";
}
function qo(t) {
  return t + " { ? }";
}
function Lu(t, e, r, n) {
  var o = n ? $a(r, n) : Dt.call(r, ", ");
  return t + " (" + e + ") {" + o + "}";
}
function lm(t) {
  for (var e = 0; e < t.length; e++)
    if (Ec(t[e], `
`) >= 0)
      return !1;
  return !0;
}
function cm(t, e) {
  var r;
  if (t.indent === "	")
    r = "	";
  else if (typeof t.indent == "number" && t.indent > 0)
    r = Dt.call(Array(t.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: Dt.call(Array(e + 1), r)
  };
}
function $a(t, e) {
  if (t.length === 0)
    return "";
  var r = `
` + e.prev + e.base;
  return r + Dt.call(t, "," + r) + `
` + e.prev;
}
function On(t, e) {
  var r = Oa(t), n = [];
  if (r) {
    n.length = t.length;
    for (var o = 0; o < t.length; o++)
      n[o] = or(t, o) ? e(t[o], t) : "";
  }
  var a = typeof Ho == "function" ? Ho(t) : [], i;
  if (Wr) {
    i = {};
    for (var s = 0; s < a.length; s++)
      i["$" + a[s]] = a[s];
  }
  for (var u in t)
    or(t, u) && (r && String(Number(u)) === u && u < t.length || Wr && i["$" + u] instanceof Symbol || (hc.call(/[^\w$]/, u) ? n.push(e(u, t) + ": " + e(t[u], t)) : n.push(u + ": " + e(t[u], t))));
  if (typeof Ho == "function")
    for (var l = 0; l < a.length; l++)
      gc.call(t, a[l]) && n.push("[" + e(a[l]) + "]: " + e(t[a[l]], t));
  return n;
}
var vi = ht, Vr = gt, fm = Hy, dm = vi("%TypeError%"), $n = vi("%WeakMap%", !0), Nn = vi("%Map%", !0), vm = Vr("WeakMap.prototype.get", !0), pm = Vr("WeakMap.prototype.set", !0), ym = Vr("WeakMap.prototype.has", !0), mm = Vr("Map.prototype.get", !0), hm = Vr("Map.prototype.set", !0), gm = Vr("Map.prototype.has", !0), pi = function(t, e) {
  for (var r = t, n; (n = r.next) !== null; r = n)
    if (n.key === e)
      return r.next = n.next, n.next = t.next, t.next = n, n;
}, bm = function(t, e) {
  var r = pi(t, e);
  return r && r.value;
}, Sm = function(t, e, r) {
  var n = pi(t, e);
  n ? n.value = r : t.next = {
    // eslint-disable-line no-param-reassign
    key: e,
    next: t.next,
    value: r
  };
}, Em = function(t, e) {
  return !!pi(t, e);
}, Cc = function() {
  var e, r, n, o = {
    assert: function(a) {
      if (!o.has(a))
        throw new dm("Side channel does not contain " + fm(a));
    },
    get: function(a) {
      if ($n && a && (typeof a == "object" || typeof a == "function")) {
        if (e)
          return vm(e, a);
      } else if (Nn) {
        if (r)
          return mm(r, a);
      } else if (n)
        return bm(n, a);
    },
    has: function(a) {
      if ($n && a && (typeof a == "object" || typeof a == "function")) {
        if (e)
          return ym(e, a);
      } else if (Nn) {
        if (r)
          return gm(r, a);
      } else if (n)
        return Em(n, a);
      return !1;
    },
    set: function(a, i) {
      $n && a && (typeof a == "object" || typeof a == "function") ? (e || (e = new $n()), pm(e, a, i)) : Nn ? (r || (r = new Nn()), hm(r, a, i)) : (n || (n = { key: {}, next: null }), Sm(n, a, i));
    }
  };
  return o;
}, wm = ht, Cm = Yl, on = Cc(), Jt = wm("%TypeError%"), yi = {
  assert: function(t, e) {
    if (!t || typeof t != "object" && typeof t != "function")
      throw new Jt("`O` is not an object");
    if (typeof e != "string")
      throw new Jt("`slot` must be a string");
    if (on.assert(t), !yi.has(t, e))
      throw new Jt("`" + e + "` is not present on `O`");
  },
  get: function(t, e) {
    if (!t || typeof t != "object" && typeof t != "function")
      throw new Jt("`O` is not an object");
    if (typeof e != "string")
      throw new Jt("`slot` must be a string");
    var r = on.get(t);
    return r && r["$" + e];
  },
  has: function(t, e) {
    if (!t || typeof t != "object" && typeof t != "function")
      throw new Jt("`O` is not an object");
    if (typeof e != "string")
      throw new Jt("`slot` must be a string");
    var r = on.get(t);
    return !!r && Cm(r, "$" + e);
  },
  set: function(t, e, r) {
    if (!t || typeof t != "object" && typeof t != "function")
      throw new Jt("`O` is not an object");
    if (typeof e != "string")
      throw new Jt("`slot` must be a string");
    var n = on.get(t);
    n || (n = {}, on.set(t, n)), n["$" + e] = r;
  }
};
Object.freeze && Object.freeze(yi);
var Rm = yi, an = Rm, Pm = SyntaxError, Fu = typeof StopIteration == "object" ? StopIteration : null, Im = function(e) {
  if (!Fu)
    throw new Pm("this environment lacks StopIteration");
  an.set(e, "[[Done]]", !1);
  var r = {
    next: function() {
      var o = an.get(this, "[[Iterator]]"), a = an.get(o, "[[Done]]");
      try {
        return {
          done: a,
          value: a ? void 0 : o.next()
        };
      } catch (i) {
        if (an.set(o, "[[Done]]", !0), i !== Fu)
          throw i;
        return {
          done: !0,
          value: void 0
        };
      }
    }
  };
  return an.set(r, "[[Iterator]]", e), r;
}, Am = {}.toString, Rc = Array.isArray || function(t) {
  return Am.call(t) == "[object Array]";
}, Mm = String.prototype.valueOf, _m = function(e) {
  try {
    return Mm.call(e), !0;
  } catch {
    return !1;
  }
}, Om = Object.prototype.toString, $m = "[object String]", Nm = hr(), Pc = function(e) {
  return typeof e == "string" ? !0 : typeof e != "object" ? !1 : Nm ? _m(e) : Om.call(e) === $m;
}, mi = typeof Map == "function" && Map.prototype ? Map : null, xm = typeof Set == "function" && Set.prototype ? Set : null, oo;
mi || (oo = function(e) {
  return !1;
});
var Ic = mi ? Map.prototype.has : null, ju = xm ? Set.prototype.has : null;
!oo && !Ic && (oo = function(e) {
  return !1;
});
var Ac = oo || function(e) {
  if (!e || typeof e != "object")
    return !1;
  try {
    if (Ic.call(e), ju)
      try {
        ju.call(e);
      } catch {
        return !0;
      }
    return e instanceof mi;
  } catch {
  }
  return !1;
}, Tm = typeof Map == "function" && Map.prototype ? Map : null, hi = typeof Set == "function" && Set.prototype ? Set : null, ao;
hi || (ao = function(e) {
  return !1;
});
var Bu = Tm ? Map.prototype.has : null, Mc = hi ? Set.prototype.has : null;
!ao && !Mc && (ao = function(e) {
  return !1;
});
var _c = ao || function(e) {
  if (!e || typeof e != "object")
    return !1;
  try {
    if (Mc.call(e), Bu)
      try {
        Bu.call(e);
      } catch {
        return !0;
      }
    return e instanceof hi;
  } catch {
  }
  return !1;
}, Wu = mc, Ku = Im;
if (ai() || Ao()) {
  var Go = Symbol.iterator;
  Bn.exports = function(e) {
    if (e != null && typeof e[Go] < "u")
      return e[Go]();
    if (Wu(e))
      return Array.prototype[Go].call(e);
  };
} else {
  var km = Rc, Dm = Pc, Uu = ht, Lm = Uu("%Map%", !0), Fm = Uu("%Set%", !0), Rt = gt, zu = Rt("Array.prototype.push"), Vu = Rt("String.prototype.charCodeAt"), jm = Rt("String.prototype.slice"), Bm = function(e, r) {
    var n = e.length;
    if (r + 1 >= n)
      return r + 1;
    var o = Vu(e, r);
    if (o < 55296 || o > 56319)
      return r + 1;
    var a = Vu(e, r + 1);
    return a < 56320 || a > 57343 ? r + 1 : r + 2;
  }, Qo = function(e) {
    var r = 0;
    return {
      next: function() {
        var o = r >= e.length, a;
        return o || (a = e[r], r += 1), {
          done: o,
          value: a
        };
      }
    };
  }, Hu = function(e, r) {
    if (km(e) || Wu(e))
      return Qo(e);
    if (Dm(e)) {
      var n = 0;
      return {
        next: function() {
          var a = Bm(e, n), i = jm(e, n, a);
          return n = a, {
            done: a > e.length,
            value: i
          };
        }
      };
    }
    if (r && typeof e["_es6-shim iterator_"] < "u")
      return e["_es6-shim iterator_"]();
  };
  if (!Lm && !Fm)
    Bn.exports = function(e) {
      if (e != null)
        return Hu(e, !0);
    };
  else {
    var Wm = Ac, Km = _c, qu = Rt("Map.prototype.forEach", !0), Gu = Rt("Set.prototype.forEach", !0);
    if (typeof process > "u" || !process.versions || !process.versions.node)
      var Qu = Rt("Map.prototype.iterator", !0), Ju = Rt("Set.prototype.iterator", !0);
    var Yu = Rt("Map.prototype.@@iterator", !0) || Rt("Map.prototype._es6-shim iterator_", !0), Zu = Rt("Set.prototype.@@iterator", !0) || Rt("Set.prototype._es6-shim iterator_", !0), Um = function(e) {
      if (Wm(e)) {
        if (Qu)
          return Ku(Qu(e));
        if (Yu)
          return Yu(e);
        if (qu) {
          var r = [];
          return qu(e, function(o, a) {
            zu(r, [a, o]);
          }), Qo(r);
        }
      }
      if (Km(e)) {
        if (Ju)
          return Ku(Ju(e));
        if (Zu)
          return Zu(e);
        if (Gu) {
          var n = [];
          return Gu(e, function(o) {
            zu(n, o);
          }), Qo(n);
        }
      }
    };
    Bn.exports = function(e) {
      return Um(e) || Hu(e);
    };
  }
}
var zm = Bn.exports, Xu = function(t) {
  return t !== t;
}, Oc = function(e, r) {
  return e === 0 && r === 0 ? 1 / e === 1 / r : !!(e === r || Xu(e) && Xu(r));
}, Vm = Oc, $c = function() {
  return typeof Object.is == "function" ? Object.is : Vm;
}, Hm = $c, qm = mr, Gm = function() {
  var e = Hm();
  return qm(Object, { is: e }, {
    is: function() {
      return Object.is !== e;
    }
  }), e;
}, Qm = mr, Jm = zr, Ym = Oc, Nc = $c, Zm = Gm, xc = Jm(Nc(), Object);
Qm(xc, {
  getPolyfill: Nc,
  implementation: Ym,
  shim: Zm
});
var Xm = xc, Tc = Function.prototype.toString, Dr = typeof Reflect == "object" && Reflect !== null && Reflect.apply, Na, Wn;
if (typeof Dr == "function" && typeof Object.defineProperty == "function")
  try {
    Na = Object.defineProperty({}, "length", {
      get: function() {
        throw Wn;
      }
    }), Wn = {}, Dr(function() {
      throw 42;
    }, null, Na);
  } catch (t) {
    t !== Wn && (Dr = null);
  }
else
  Dr = null;
var eh = /^\s*class\b/, xa = function(e) {
  try {
    var r = Tc.call(e);
    return eh.test(r);
  } catch {
    return !1;
  }
}, Jo = function(e) {
  try {
    return xa(e) ? !1 : (Tc.call(e), !0);
  } catch {
    return !1;
  }
}, Kn = Object.prototype.toString, th = "[object Object]", rh = "[object Function]", nh = "[object GeneratorFunction]", oh = "[object HTMLAllCollection]", ah = "[object HTML document.all class]", ih = "[object HTMLCollection]", uh = typeof Symbol == "function" && !!Symbol.toStringTag, sh = !(0 in [,]), Ta = function() {
  return !1;
};
if (typeof document == "object") {
  var lh = document.all;
  Kn.call(lh) === Kn.call(document.all) && (Ta = function(e) {
    if ((sh || !e) && (typeof e > "u" || typeof e == "object"))
      try {
        var r = Kn.call(e);
        return (r === oh || r === ah || r === ih || r === th) && e("") == null;
      } catch {
      }
    return !1;
  });
}
var ch = Dr ? function(e) {
  if (Ta(e))
    return !0;
  if (!e || typeof e != "function" && typeof e != "object")
    return !1;
  try {
    Dr(e, null, Na);
  } catch (r) {
    if (r !== Wn)
      return !1;
  }
  return !xa(e) && Jo(e);
} : function(e) {
  if (Ta(e))
    return !0;
  if (!e || typeof e != "function" && typeof e != "object")
    return !1;
  if (uh)
    return Jo(e);
  if (xa(e))
    return !1;
  var r = Kn.call(e);
  return r !== rh && r !== nh && !/^\[object HTML/.test(r) ? !1 : Jo(e);
}, fh = ch, dh = Object.prototype.toString, kc = Object.prototype.hasOwnProperty, vh = function(e, r, n) {
  for (var o = 0, a = e.length; o < a; o++)
    kc.call(e, o) && (n == null ? r(e[o], o, e) : r.call(n, e[o], o, e));
}, ph = function(e, r, n) {
  for (var o = 0, a = e.length; o < a; o++)
    n == null ? r(e.charAt(o), o, e) : r.call(n, e.charAt(o), o, e);
}, yh = function(e, r, n) {
  for (var o in e)
    kc.call(e, o) && (n == null ? r(e[o], o, e) : r.call(n, e[o], o, e));
}, mh = function(e, r, n) {
  if (!fh(r))
    throw new TypeError("iterator must be a function");
  var o;
  arguments.length >= 3 && (o = n), dh.call(e) === "[object Array]" ? vh(e, r, o) : typeof e == "string" ? ph(e, r, o) : yh(e, r, o);
}, hh = mh, Yo = [
  "BigInt64Array",
  "BigUint64Array",
  "Float32Array",
  "Float64Array",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "Uint16Array",
  "Uint32Array",
  "Uint8Array",
  "Uint8ClampedArray"
], gh = typeof globalThis > "u" ? Ha : globalThis, bh = function() {
  for (var e = [], r = 0; r < Yo.length; r++)
    typeof gh[Yo[r]] == "function" && (e[e.length] = Yo[r]);
  return e;
}, io = hh, Sh = bh, es = zr, gi = gt, Un = ui, Eh = gi("Object.prototype.toString"), Dc = hr(), ts = typeof globalThis > "u" ? Ha : globalThis, ka = Sh(), bi = gi("String.prototype.slice"), Zo = Object.getPrototypeOf, wh = gi("Array.prototype.indexOf", !0) || function(e, r) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n] === r)
      return n;
  return -1;
}, uo = { __proto__: null };
Dc && Un && Zo ? io(ka, function(t) {
  var e = new ts[t]();
  if (Symbol.toStringTag in e) {
    var r = Zo(e), n = Un(r, Symbol.toStringTag);
    if (!n) {
      var o = Zo(r);
      n = Un(o, Symbol.toStringTag);
    }
    uo["$" + t] = es(n.get);
  }
}) : io(ka, function(t) {
  var e = new ts[t](), r = e.slice || e.set;
  r && (uo["$" + t] = es(r));
});
var Ch = function(e) {
  var r = !1;
  return io(uo, function(n, o) {
    if (!r)
      try {
        "$" + n(e) === o && (r = bi(o, 1));
      } catch {
      }
  }), r;
}, Rh = function(e) {
  var r = !1;
  return io(uo, function(n, o) {
    if (!r)
      try {
        n(e), r = bi(o, 1);
      } catch {
      }
  }), r;
}, Lc = function(e) {
  if (!e || typeof e != "object")
    return !1;
  if (!Dc) {
    var r = bi(Eh(e), 8, -1);
    return wh(ka, r) > -1 ? r : r !== "Object" ? !1 : Rh(e);
  }
  return Un ? Ch(e) : null;
}, Ph = Lc, Ih = function(e) {
  return !!Ph(e);
}, Ah = zr, Mh = gt, Fc = ht, _h = Ih, rs = Fc("ArrayBuffer", !0), ns = Fc("Float32Array", !0), zn = Mh("ArrayBuffer.prototype.byteLength", !0), os = rs && !zn && new rs().slice, as = os && Ah(os), jc = zn || as ? function(e) {
  if (!e || typeof e != "object")
    return !1;
  try {
    return zn ? zn(e) : as(e, 0), !0;
  } catch {
    return !1;
  }
} : ns ? function(e) {
  try {
    return new ns(e).buffer === e && !_h(e);
  } catch (r) {
    return typeof e == "object" && r.name === "RangeError";
  }
} : function(e) {
  return !1;
}, Oh = Date.prototype.getDay, $h = function(e) {
  try {
    return Oh.call(e), !0;
  } catch {
    return !1;
  }
}, Nh = Object.prototype.toString, xh = "[object Date]", Th = hr(), kh = function(e) {
  return typeof e != "object" || e === null ? !1 : Th ? $h(e) : Nh.call(e) === xh;
}, Da = gt, Bc = hr(), Wc, Kc, La, Fa;
if (Bc) {
  Wc = Da("Object.prototype.hasOwnProperty"), Kc = Da("RegExp.prototype.exec"), La = {};
  var Xo = function() {
    throw La;
  };
  Fa = {
    toString: Xo,
    valueOf: Xo
  }, typeof Symbol.toPrimitive == "symbol" && (Fa[Symbol.toPrimitive] = Xo);
}
var Dh = Da("Object.prototype.toString"), Lh = Object.getOwnPropertyDescriptor, Fh = "[object RegExp]", jh = Bc ? function(e) {
  if (!e || typeof e != "object")
    return !1;
  var r = Lh(e, "lastIndex"), n = r && Wc(r, "value");
  if (!n)
    return !1;
  try {
    Kc(e, Fa);
  } catch (o) {
    return o === La;
  }
} : function(e) {
  return !e || typeof e != "object" && typeof e != "function" ? !1 : Dh(e) === Fh;
}, Bh = gt, is = Bh("SharedArrayBuffer.prototype.byteLength", !0), Wh = is ? function(e) {
  if (!e || typeof e != "object")
    return !1;
  try {
    return is(e), !0;
  } catch {
    return !1;
  }
} : function(e) {
  return !1;
}, Kh = Number.prototype.toString, Uh = function(e) {
  try {
    return Kh.call(e), !0;
  } catch {
    return !1;
  }
}, zh = Object.prototype.toString, Vh = "[object Number]", Hh = hr(), qh = function(e) {
  return typeof e == "number" ? !0 : typeof e != "object" ? !1 : Hh ? Uh(e) : zh.call(e) === Vh;
}, Uc = gt, Gh = Uc("Boolean.prototype.toString"), Qh = Uc("Object.prototype.toString"), Jh = function(e) {
  try {
    return Gh(e), !0;
  } catch {
    return !1;
  }
}, Yh = "[object Boolean]", Zh = hr(), Xh = function(e) {
  return typeof e == "boolean" ? !0 : e === null || typeof e != "object" ? !1 : Zh && Symbol.toStringTag in e ? Jh(e) : Qh(e) === Yh;
}, ja = { exports: {} }, eg = Object.prototype.toString, tg = ai();
if (tg) {
  var rg = Symbol.prototype.toString, ng = /^Symbol\(.*\)$/, og = function(e) {
    return typeof e.valueOf() != "symbol" ? !1 : ng.test(rg.call(e));
  };
  ja.exports = function(e) {
    if (typeof e == "symbol")
      return !0;
    if (eg.call(e) !== "[object Symbol]")
      return !1;
    try {
      return og(e);
    } catch {
      return !1;
    }
  };
} else
  ja.exports = function(e) {
    return !1;
  };
var ag = ja.exports, Ba = { exports: {} }, us = typeof BigInt < "u" && BigInt, ig = function() {
  return typeof us == "function" && typeof BigInt == "function" && typeof us(42) == "bigint" && typeof BigInt(42) == "bigint";
}, ug = ig();
if (ug) {
  var sg = BigInt.prototype.valueOf, lg = function(e) {
    try {
      return sg.call(e), !0;
    } catch {
    }
    return !1;
  };
  Ba.exports = function(e) {
    return e === null || typeof e > "u" || typeof e == "boolean" || typeof e == "string" || typeof e == "number" || typeof e == "symbol" || typeof e == "function" ? !1 : typeof e == "bigint" ? !0 : lg(e);
  };
} else
  Ba.exports = function(e) {
    return !1;
  };
var cg = Ba.exports, fg = Pc, dg = qh, vg = Xh, pg = ag, yg = cg, mg = function(e) {
  if (e == null || typeof e != "object" && typeof e != "function")
    return null;
  if (fg(e))
    return "String";
  if (dg(e))
    return "Number";
  if (vg(e))
    return "Boolean";
  if (pg(e))
    return "Symbol";
  if (yg(e))
    return "BigInt";
}, so = typeof WeakMap == "function" && WeakMap.prototype ? WeakMap : null, ss = typeof WeakSet == "function" && WeakSet.prototype ? WeakSet : null, lo;
so || (lo = function(e) {
  return !1;
});
var Wa = so ? so.prototype.has : null, ea = ss ? ss.prototype.has : null;
!lo && !Wa && (lo = function(e) {
  return !1;
});
var hg = lo || function(e) {
  if (!e || typeof e != "object")
    return !1;
  try {
    if (Wa.call(e, Wa), ea)
      try {
        ea.call(e, ea);
      } catch {
        return !0;
      }
    return e instanceof so;
  } catch {
  }
  return !1;
}, Ka = { exports: {} }, gg = ht, zc = gt, bg = gg("%WeakSet%", !0), ta = zc("WeakSet.prototype.has", !0);
if (ta) {
  var ra = zc("WeakMap.prototype.has", !0);
  Ka.exports = function(e) {
    if (!e || typeof e != "object")
      return !1;
    try {
      if (ta(e, ta), ra)
        try {
          ra(e, ra);
        } catch {
          return !0;
        }
      return e instanceof bg;
    } catch {
    }
    return !1;
  };
} else
  Ka.exports = function(e) {
    return !1;
  };
var Sg = Ka.exports, Eg = Ac, wg = _c, Cg = hg, Rg = Sg, Pg = function(e) {
  if (e && typeof e == "object") {
    if (Eg(e))
      return "Map";
    if (wg(e))
      return "Set";
    if (Cg(e))
      return "WeakMap";
    if (Rg(e))
      return "WeakSet";
  }
  return !1;
}, Ig = gt, ls = Ig("ArrayBuffer.prototype.byteLength", !0), Ag = jc, Mg = function(e) {
  return Ag(e) ? ls ? ls(e) : e.byteLength : NaN;
}, Vc = ay, Bt = gt, cs = _y, _g = ht, Kr = zm, Og = Cc, fs = Xm, ds = mc, vs = Rc, ps = jc, ys = kh, ms = jh, hs = Wh, gs = oi, bs = mg, Ss = Pg, Es = Lc, ws = Mg, Cs = Bt("SharedArrayBuffer.prototype.byteLength", !0), Rs = Bt("Date.prototype.getTime"), na = Object.getPrototypeOf, Ps = Bt("Object.prototype.toString"), co = _g("%Set%", !0), Ua = Bt("Map.prototype.has", !0), fo = Bt("Map.prototype.get", !0), Is = Bt("Map.prototype.size", !0), vo = Bt("Set.prototype.add", !0), Hc = Bt("Set.prototype.delete", !0), po = Bt("Set.prototype.has", !0), Vn = Bt("Set.prototype.size", !0);
function As(t, e, r, n) {
  for (var o = Kr(t), a; (a = o.next()) && !a.done; )
    if (At(e, a.value, r, n))
      return Hc(t, a.value), !0;
  return !1;
}
function qc(t) {
  if (typeof t > "u")
    return null;
  if (typeof t != "object")
    return typeof t == "symbol" ? !1 : typeof t == "string" || typeof t == "number" ? +t == +t : !0;
}
function $g(t, e, r, n, o, a) {
  var i = qc(r);
  if (i != null)
    return i;
  var s = fo(e, i), u = Vc({}, o, { strict: !1 });
  return typeof s > "u" && !Ua(e, i) || !At(n, s, u, a) ? !1 : !Ua(t, i) && At(n, s, u, a);
}
function Ng(t, e, r) {
  var n = qc(r);
  return n ?? (po(e, n) && !po(t, n));
}
function Ms(t, e, r, n, o, a) {
  for (var i = Kr(t), s, u; (s = i.next()) && !s.done; )
    if (u = s.value, // eslint-disable-next-line no-use-before-define
    At(r, u, o, a) && At(n, fo(e, u), o, a))
      return Hc(t, u), !0;
  return !1;
}
function At(t, e, r, n) {
  var o = r || {};
  if (o.strict ? fs(t, e) : t === e)
    return !0;
  var a = bs(t), i = bs(e);
  if (a !== i)
    return !1;
  if (!t || !e || typeof t != "object" && typeof e != "object")
    return o.strict ? fs(t, e) : t == e;
  var s = n.has(t), u = n.has(e), l;
  if (s && u) {
    if (n.get(t) === n.get(e))
      return !0;
  } else
    l = {};
  return s || n.set(t, l), u || n.set(e, l), kg(t, e, o, n);
}
function _s(t) {
  return !t || typeof t != "object" || typeof t.length != "number" || typeof t.copy != "function" || typeof t.slice != "function" || t.length > 0 && typeof t[0] != "number" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}
function xg(t, e, r, n) {
  if (Vn(t) !== Vn(e))
    return !1;
  for (var o = Kr(t), a = Kr(e), i, s, u; (i = o.next()) && !i.done; )
    if (i.value && typeof i.value == "object")
      u || (u = new co()), vo(u, i.value);
    else if (!po(e, i.value)) {
      if (r.strict || !Ng(t, e, i.value))
        return !1;
      u || (u = new co()), vo(u, i.value);
    }
  if (u) {
    for (; (s = a.next()) && !s.done; )
      if (s.value && typeof s.value == "object") {
        if (!As(u, s.value, r.strict, n))
          return !1;
      } else if (!r.strict && !po(t, s.value) && !As(u, s.value, r.strict, n))
        return !1;
    return Vn(u) === 0;
  }
  return !0;
}
function Tg(t, e, r, n) {
  if (Is(t) !== Is(e))
    return !1;
  for (var o = Kr(t), a = Kr(e), i, s, u, l, d, y; (i = o.next()) && !i.done; )
    if (l = i.value[0], d = i.value[1], l && typeof l == "object")
      u || (u = new co()), vo(u, l);
    else if (y = fo(e, l), typeof y > "u" && !Ua(e, l) || !At(d, y, r, n)) {
      if (r.strict || !$g(t, e, l, d, r, n))
        return !1;
      u || (u = new co()), vo(u, l);
    }
  if (u) {
    for (; (s = a.next()) && !s.done; )
      if (l = s.value[0], y = s.value[1], l && typeof l == "object") {
        if (!Ms(u, t, l, y, r, n))
          return !1;
      } else if (!r.strict && (!t.has(l) || !At(fo(t, l), y, r, n)) && !Ms(u, t, l, y, Vc({}, r, { strict: !1 }), n))
        return !1;
    return Vn(u) === 0;
  }
  return !0;
}
function kg(t, e, r, n) {
  var o, a;
  if (typeof t != typeof e || t == null || e == null || Ps(t) !== Ps(e) || ds(t) !== ds(e))
    return !1;
  var i = vs(t), s = vs(e);
  if (i !== s)
    return !1;
  var u = t instanceof Error, l = e instanceof Error;
  if (u !== l || (u || l) && (t.name !== e.name || t.message !== e.message))
    return !1;
  var d = ms(t), y = ms(e);
  if (d !== y || (d || y) && (t.source !== e.source || cs(t) !== cs(e)))
    return !1;
  var f = ys(t), v = ys(e);
  if (f !== v || (f || v) && Rs(t) !== Rs(e) || r.strict && na && na(t) !== na(e))
    return !1;
  var h = Es(t), b = Es(e);
  if (h !== b)
    return !1;
  if (h || b) {
    if (t.length !== e.length)
      return !1;
    for (o = 0; o < t.length; o++)
      if (t[o] !== e[o])
        return !1;
    return !0;
  }
  var p = _s(t), S = _s(e);
  if (p !== S)
    return !1;
  if (p || S) {
    if (t.length !== e.length)
      return !1;
    for (o = 0; o < t.length; o++)
      if (t[o] !== e[o])
        return !1;
    return !0;
  }
  var w = ps(t), C = ps(e);
  if (w !== C)
    return !1;
  if (w || C)
    return ws(t) !== ws(e) ? !1 : typeof Uint8Array == "function" && At(new Uint8Array(t), new Uint8Array(e), r, n);
  var m = hs(t), g = hs(e);
  if (m !== g)
    return !1;
  if (m || g)
    return Cs(t) !== Cs(e) ? !1 : typeof Uint8Array == "function" && At(new Uint8Array(t), new Uint8Array(e), r, n);
  if (typeof t != typeof e)
    return !1;
  var E = gs(t), R = gs(e);
  if (E.length !== R.length)
    return !1;
  for (E.sort(), R.sort(), o = E.length - 1; o >= 0; o--)
    if (E[o] != R[o])
      return !1;
  for (o = E.length - 1; o >= 0; o--)
    if (a = E[o], !At(t[a], e[a], r, n))
      return !1;
  var A = Ss(t), I = Ss(e);
  return A !== I ? !1 : A === "Set" || I === "Set" ? xg(t, e, r, n) : A === "Map" ? Tg(t, e, r, n) : !0;
}
var Dg = function(e, r, n) {
  return At(e, r, n, Og());
};
const Lg = /* @__PURE__ */ Vs(Dg), Fg = ({
  data: t,
  expandableOpts: e,
  getExpandableStatusForRow: r,
  onExpandableIconClicked: n
}) => {
  if (!t)
    return null;
  const o = r(t);
  let a = null;
  return o === "expand" ? a = e.expandIcon : o === "collapse" ? a = e.collapseIcon : o === "loading" && (a = e.loadingIcon), a ? /* @__PURE__ */ D(
    "div",
    {
      style: {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ D(
        a,
        {
          style: { color: "#000" },
          onClick: (i) => {
            i.stopPropagation(), n(t);
          }
        }
      )
    }
  ) : null;
}, jg = ({
  value: t,
  StatusComponent: e
}) => e ? /* @__PURE__ */ D(
  "div",
  {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      height: "100%"
    },
    children: /* @__PURE__ */ D(e, { status: t })
  }
) : null, Bg = jt(jg), Wg = ({
  value: t,
  data: e,
  columnRender: r,
  getLevelForKey: n,
  hasExpandableColumn: o
}) => {
  const a = {};
  if (o && n && (e != null && e.id)) {
    const i = n(e.id) || 0;
    a.paddingLeft = `${(i + 1) * 20}px`;
  }
  return /* @__PURE__ */ D("div", { style: a, children: r ? r(t, e) : t });
}, xn = {
  autoHeight: !0,
  wrapText: !0,
  sortable: !1,
  comparator: () => 0,
  resizable: !0,
  valueFormatter: () => ""
  // To skip warnings, return an empty string
}, Kg = ({
  columns: t,
  initialSortState: e,
  onGetColumnsState: r,
  HeaderComponent: n,
  statusComponent: o,
  strings: a = {},
  onChangeTableType: i,
  onResetTableView: s,
  expandableOpts: u,
  getExpandableStatusForRow: l,
  onExpandableIconClicked: d,
  getLevelForKey: y
}) => {
  const f = Ae(u), v = Ae(l), h = Ae(d), b = Ae(y);
  dt(() => {
    f.current = u, v.current = l, h.current = d, b.current = y;
  }, [
    u,
    l,
    d,
    y
  ]);
  const p = yt(() => {
    if (o)
      return jt(
        (w) => o(w.status)
      );
  }, [o]), S = yt(() => {
    var N, K;
    const w = {
      ...xn,
      checkboxSelection: !0,
      suppressMovable: !0,
      sortable: !1,
      pinned: "left",
      lockPosition: "left",
      lockPinned: !0,
      maxWidth: (N = f.current) != null && N.onFetchChildrenForRecord ? 30 : 50,
      resizable: !1,
      field: Va,
      headerComponent: n
    }, m = !!((K = f.current) != null && K.onFetchChildrenForRecord && v.current && h.current) ? {
      ...xn,
      field: "$expandable",
      suppressMovable: !0,
      sortable: !1,
      pinned: "left",
      lockPosition: "left",
      lockPinned: !0,
      maxWidth: 40,
      resizable: !1,
      headerName: "",
      headerComponent: null,
      cellRenderer: (M) => /* @__PURE__ */ D(
        Fg,
        {
          data: M.data,
          expandableOpts: f.current,
          getExpandableStatusForRow: v.current,
          onExpandableIconClicked: (P) => {
            var j;
            (j = h.current) == null || j.call(h, P), M.api.refreshCells({
              rowNodes: [M.node],
              columns: [M.column],
              force: !0
            });
          }
        }
      ),
      cellStyle: {
        padding: 0,
        // Handled by renderer
        margin: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    } : null, g = t.map((M) => {
      const P = e == null ? void 0 : e.find(
        (j) => j.colId === M.key
      );
      return {
        ...xn,
        field: M.key,
        sortable: M.isSortable,
        headerName: M.title,
        sort: P == null ? void 0 : P.sort,
        sortIndex: P == null ? void 0 : P.sortIndex,
        pinned: !1,
        cellRenderer: (j) => {
          var W;
          return /* @__PURE__ */ D(
            Wg,
            {
              value: j.value,
              data: j.data,
              columnRender: M.render,
              getLevelForKey: b.current,
              hasExpandableColumn: !!((W = f.current) != null && W.onFetchChildrenForRecord)
            }
          );
        }
      };
    }), E = r == null ? void 0 : r(), R = E == null ? void 0 : E.map((M) => M.colId);
    return E && R && g.sort((M, P) => {
      const j = R.indexOf(M.field), W = R.indexOf(P.field);
      return j - W;
    }), [
      {
        ...xn,
        field: za,
        suppressMovable: !0,
        sortable: !1,
        lockPosition: "left",
        lockPinned: !0,
        maxWidth: 30,
        pinned: "left",
        resizable: !1,
        cellStyle: {
          padding: 0,
          margin: 0
        },
        headerComponent: () => /* @__PURE__ */ D(
          Hl,
          {
            resetTableViewLabel: (a == null ? void 0 : a.resetTableViewLabel) || "resetTableViewLabel",
            currentTableType: "paginated",
            onChangeTableType: i,
            changeToInfiniteLabel: (a == null ? void 0 : a.changeToInfiniteLabel) || "Canviar a llistat infinit",
            changeToPaginatedLabel: (a == null ? void 0 : a.changeToPaginatedLabel) || "Canviar a llistat paginat",
            onResetTableView: s
          }
        ),
        cellRenderer: p ? (M) => /* @__PURE__ */ D(
          Bg,
          {
            value: M.value,
            StatusComponent: p
          }
        ) : void 0
      },
      w,
      ...m ? [m] : [],
      ...g
    ];
  }, [
    n,
    t,
    r,
    p,
    e,
    a,
    i,
    s
  ]);
  return Ns(() => S, [S]);
}, Gc = mn(
  (t, e) => {
    const {
      dataSource: r,
      columns: n,
      onRowDoubleClick: o,
      onRowSelectionChange: a,
      height: i = 600,
      onRowStyle: s,
      onColumnChanged: u,
      onGetColumnsState: l,
      footer: d,
      footerHeight: y = 30,
      onRowStatus: f,
      statusComponent: v,
      hasStatusColumn: h = !1,
      strings: b = {},
      showPointerCursorInRows: p = !0,
      isLoading: S,
      onHeaderCheckboxClick: w,
      headerCheckboxState: C,
      onGetFirstVisibleRowIndex: m,
      onChangeFirstVisibleRowIndex: g,
      onGetFirstVisibleColumn: E,
      onChangeFirstVisibleColumn: R,
      onForceReload: A,
      initialSortState: I,
      onSortChange: N,
      onChangeTableType: K,
      expandableOpts: M
    } = t, P = Ae(null), j = Ae(null), W = d ? i + y : i, G = d ? i - y : i, [Y, V] = It(!1);
    hn(e, () => ({
      setSelectedRows: (O) => {
        var k, L;
        (L = (k = P.current) == null ? void 0 : k.api) == null || L.forEachNode((ce) => {
          var oe;
          (oe = ce == null ? void 0 : ce.data) != null && oe.id && O.includes(ce.data.id) ? ce.setSelected(!0) : ce.setSelected(!1);
        });
      },
      selectAll: () => {
        var O, k;
        (k = (O = P.current) == null ? void 0 : O.api) == null || k.selectAll();
      },
      unselectAll: () => {
        var O, k;
        (k = (O = P.current) == null ? void 0 : O.api) == null || k.deselectAll();
      },
      refresh: () => {
        var O, k, L, ce;
        (k = (O = P.current) == null ? void 0 : O.api) == null || k.deselectAll(), (ce = (L = P.current) == null ? void 0 : L.api) == null || ce.refreshCells();
      },
      updateRows: (O) => {
        var k;
        (k = P.current) != null && k.api && O.filter((L) => L == null ? void 0 : L.id).forEach((L) => {
          var oe;
          const ce = (oe = P.current) == null ? void 0 : oe.api.getRenderedNodes().find((ge) => {
            var je;
            return ((je = ge.data) == null ? void 0 : je.id) === (L == null ? void 0 : L.id);
          });
          ce && ce.setData({ ...ce.data, ...L });
        });
      },
      getVisibleRowIds: () => {
        var k;
        return (k = P.current) != null && k.api ? P.current.api.getRenderedNodes().map((L) => {
          var ce;
          return (ce = L == null ? void 0 : L.data) == null ? void 0 : ce.id;
        }) : [];
      },
      getVisibleRows: () => {
        var k;
        return (k = P.current) != null && k.api ? P.current.api.getRenderedNodes().map((L) => L == null ? void 0 : L.data) : [];
      },
      refreshRowStyles: () => {
        var O;
        (O = P.current) != null && O.api && P.current.api.redrawRows();
      }
    }));
    const te = Ls(n, "key"), { applyAndUpdateNewState: Q, applyAutoFitState: de } = Ws({
      gridRef: P,
      containerRef: j,
      columns: te,
      type: "paginated"
    }), {
      keyIsOpened: ye,
      onExpandableIconClicked: Ce,
      getExpandableStatusForRow: Me,
      getChildsForParent: $e,
      getLevelForKey: me,
      items: ve,
      openedKeys: ae
    } = Ts({
      dataSource: r,
      onFetchChildrenForRecord: M == null ? void 0 : M.onFetchChildrenForRecord,
      childField: M == null ? void 0 : M.childField
    }), he = H((O) => {
      requestAnimationFrame(() => {
        var k;
        (k = P.current) != null && k.api && P.current.api.ensureIndexVisible(O, "top");
      });
    }, []), Re = H((O) => {
      requestAnimationFrame(() => {
        var k;
        (k = P.current) != null && k.api && P.current.api.ensureColumnVisible(O, "start");
      });
    }, []), ee = H(() => {
      var O, k, L;
      if (!Y) {
        V(!0);
        const ce = (O = P.current) == null ? void 0 : O.api;
        if (!S && ce && ce.getDisplayedRowCount() > 0) {
          const oe = l == null ? void 0 : l();
          if (oe && oe.length > 0 ? (L = (k = P == null ? void 0 : P.current) == null ? void 0 : k.api) == null || L.applyColumnState({
            state: oe,
            applyOrder: !0
          }) : de(), m) {
            const ge = m();
            ge !== void 0 && he(ge);
          }
          if (E) {
            const ge = E();
            ge !== void 0 && Re(ge);
          }
        }
      }
    }, [
      Y,
      S,
      l,
      m,
      E,
      de,
      he,
      Re
    ]), Pe = H(() => {
      var L;
      const O = (L = P == null ? void 0 : P.current) == null ? void 0 : L.api.getColumnState();
      if (!O)
        return;
      const k = l == null ? void 0 : l();
      Ks(O, k) || (Q(O), u == null || u(O));
    }, [Q, u, l]), ke = H(
      (O) => {
        !O.finished || O.source !== "uiColumnResized" || Pe();
      },
      [Pe]
    ), x = H(
      (O) => {
        var k, L, ce, oe;
        if (!(O.top === -1 && O.direction === "horizontal" && O.left === 0)) {
          if (O.direction === "vertical") {
            const ge = (L = (k = P.current) == null ? void 0 : k.api) == null ? void 0 : L.getFirstDisplayedRowIndex();
            ge !== void 0 && (g == null || g(ge));
          } else if (O.direction === "horizontal") {
            const ge = ((oe = (ce = P.current) == null ? void 0 : ce.api) == null ? void 0 : oe.getColumnState()) || [];
            let je = 0, be;
            for (const Ne of ge) {
              if (Ne.pinned)
                continue;
              const Je = Ne.width || 0;
              if (je + Je > O.left) {
                be = Ne.colId;
                break;
              }
              je += Je;
            }
            be && (R == null || R(be));
          }
        }
      },
      [g, R]
    ), { HeaderComponent: Se } = rp(
      C,
      w
    ), Ee = H(() => {
      u == null || u([]), N == null || N([]), A == null || A();
    }, [u, A, N]), Ie = Kg({
      columns: te,
      initialSortState: I,
      onGetColumnsState: l,
      HeaderComponent: Se,
      statusComponent: v,
      strings: b,
      onChangeTableType: K,
      onResetTableView: Ee,
      expandableOpts: M,
      getExpandableStatusForRow: M != null && M.onFetchChildrenForRecord ? Me : void 0,
      onExpandableIconClicked: M != null && M.onFetchChildrenForRecord ? Ce : void 0,
      getLevelForKey: M != null && M.onFetchChildrenForRecord ? me : void 0
    });
    dt(() => {
      S ? V(!1) : S === !1 && r.length === 0 && V(!0);
    }, [r.length, S]);
    const T = H(
      ({ data: O }) => {
        o == null || o(O);
      },
      [o]
    ), _ = H(
      (O) => {
        if (O.source === "checkboxSelected" && O.node.data.id) {
          const k = {
            id: O.node.data.id,
            selected: O.node.isSelected() || !1
          };
          requestAnimationFrame(() => {
            a == null || a(k);
          });
        }
      },
      [a]
    ), $ = yt(() => ({
      cursor: p ? "pointer" : "default"
    }), [p]), F = H(() => {
      S === !1 && requestAnimationFrame(() => {
        ee();
      });
    }, [S, ee]), ne = yt(() => !h || !f ? r : r.map((O) => ({
      ...O,
      $status: f(O)
    })), [r, h, f]), re = yt(() => {
      if (!(M != null && M.onFetchChildrenForRecord))
        return ne;
      const O = (L, ce) => {
        let oe = [];
        return L.forEach((ge) => {
          if (!ge)
            return;
          const je = h && f && !ge.$status ? { ...ge, $status: f(ge) } : ge;
          if (oe.push(je), ye(ge.id)) {
            const be = $e(ge.id);
            be.length > 0 && (oe = oe.concat(
              O(
                be.map((Ne) => {
                  const Je = Ne.data;
                  return h && f && !Je.$status ? { ...Je, $status: f(Je) } : Je;
                })
              )
            ));
          }
        }), oe;
      }, k = ve.filter((L) => L.level === 0).map((L) => L.data);
      return O(k);
    }, [
      M,
      ne,
      ve,
      ye,
      $e,
      h,
      f,
      ae
    ]), ie = Ns(() => re, [re]), ue = yt(() => () => /* @__PURE__ */ D(ni, { message: b == null ? void 0 : b.noResultsLabel }), [b]), se = H((O) => String(O.data.id), []), Ke = H(
      (O) => {
        if (O.source !== "uiColumnSorted")
          return;
        const k = O.api.getColumnState().filter((L) => L.sort).map((L) => ({
          colId: L.colId,
          sort: L.sort,
          sortIndex: L.sortIndex
        }));
        Lg(k, I) || N == null || N(k);
      },
      [I, N]
    ), Ue = H(() => {
      var k;
      const O = (k = P.current) == null ? void 0 : k.api;
      if (O && !S) {
        const L = l == null ? void 0 : l();
        L && L.length > 0 ? O.applyColumnState({
          state: L,
          applyOrder: !0
        }) : de();
      }
    }, [S, l, de, P]);
    return dt(() => {
      var O;
      if ((O = P.current) != null && O.api && !S) {
        const k = setTimeout(() => {
          Ue();
        }, 50);
        return () => clearTimeout(k);
      }
    }, [Ie, S, Ue]), /* @__PURE__ */ st(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          height: W
        },
        children: [
          /* @__PURE__ */ st(
            "div",
            {
              ref: j,
              className: "ag-grid-default-table ag-theme-quartz",
              style: { height: G, width: "100%", position: "relative" },
              children: [
                !Y && /* @__PURE__ */ D(
                  "div",
                  {
                    style: {
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 999
                    },
                    children: /* @__PURE__ */ D(
                      "div",
                      {
                        style: {
                          width: 40,
                          height: 40,
                          border: "4px solid #f3f3f3",
                          borderTop: "4px solid #3498db",
                          borderRadius: "50%",
                          animation: "spin 1s linear infinite"
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ D("style", { children: `
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            ` }),
                /* @__PURE__ */ D(
                  xs,
                  {
                    ref: P,
                    rowBuffer: 0,
                    enableCellTextSelection: !0,
                    suppressLoadingOverlay: !0,
                    noRowsOverlayComponent: ue,
                    columnDefs: Ie,
                    rowData: ie,
                    onRowDoubleClicked: T,
                    suppressCellFocus: !0,
                    suppressRowClickSelection: !0,
                    rowSelection: "multiple",
                    onRowSelected: _,
                    suppressDragLeaveHidesColumns: !0,
                    getRowHeight: void 0,
                    getRowId: se,
                    rowStyle: $,
                    getRowStyle: s,
                    onDragStopped: Pe,
                    onColumnResized: ke,
                    onBodyScrollEnd: x,
                    onModelUpdated: F,
                    onSortChanged: Ke,
                    reactiveCustomComponents: !0,
                    debounceVerticalScrollbar: !0
                  }
                )
              ]
            }
          ),
          d && /* @__PURE__ */ D(
            "div",
            {
              style: {
                height: y
              },
              children: d
            }
          )
        ]
      }
    );
  }
);
Gc.displayName = "PaginatedTable";
const ob = jt(Gc);
export {
  nb as InfiniteTable,
  ob as PaginatedTable,
  pf as Table
};
//# sourceMappingURL=react-formiga-table.es.js.map
